/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/plankton/api/auth/account/activation-queue": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get accounts to send activation mail to.
         * @description Will automatically filter out accounts that have already been sent an activation mail or have invalid data.
         */
        get: operations["Account_GETGetAccountActivationQueue"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/account/activation-mark-sent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Marks the activation mail as sent. */
        post: operations["Account_POSTPostMarkActivationMailSent"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/account/activation-mark-failed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Marks the activation mail as failed. */
        post: operations["Account_POSTPostMarkActivationMailFailed"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/account/has-active-account-in-store": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Checks if there is an active account in the current store for the given email address / username. */
        get: operations["Account_GETGetHasActiveAccountInStore"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/account/person-rights": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets the rights granted to a person for a specific customer and store.
         *     Can be used outside the context of a signed-in user, e.g., to check if the person is allowed to see prices in an order confirmation email.
         * @description Can be called anonymously.
         *     This does not check if the person is allowed to sign in for the given customer and store, it just returns the rights granted to the person.
         */
        get: operations["Account_GETGetPersonRights"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/current": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the current basket for the user.
         * @description Must be authenticated.
         *     Default will either be a normal basket (no impersonation) or an internal basket (impersonation).
         *     Status NatchOS.Plankton.ImplementationModels.BasketStatus.Closed and NatchOS.Plankton.ImplementationModels.BasketStatus.Pending will be excluded.
         */
        get: operations["Basket_GETCurrentBasket"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/merge": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Merge the given source basket with the target basket and delete the source basket.
         *     No checks or validation is performed on the resulting line quantities.
         * @description Must be authenticated.
         *     Will either be a normal basket (no impersonation) or an internal basket (impersonation).
         */
        patch: operations["Basket_PATCHMergeBasket"];
        trace?: never;
    };
    "/plankton/api/basket/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Searches baskets that match criteria.
         * @description Must be authenticated, as a person or as a service account.
         *     If no status is specified, status NatchOS.Plankton.ImplementationModels.BasketStatus.Closed and NatchOS.Plankton.ImplementationModels.BasketStatus.Pending will be excluded.
         *     Authenticated users will only see their own baskets (filtered by customer ID).
         *     Service accounts (role `service`) can search across all customers.
         */
        get: operations["Basket_GETSearchBaskets"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/details": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the specified basket with the lines.
         * @description Can be called without authentication. Needed for anonymous baskets.
         *     Authenticated users will only have access to their own data (filtered by customer ID).
         *     Service accounts (role `service`) have access to data across all customers.
         */
        get: operations["Basket_GETGetBasketDetails"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/details-list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the specified baskets with the lines.
         * @description Must be authenticated.
         *     Authenticated users will only have access to their own data (filtered by customer ID).
         *     Service accounts (role `service`) have access to data across all customers.
         */
        get: operations["Basket_GETGetBasketDetailsList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/headers-list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the specified basket headers without the lines.
         * @description Must be authenticated.
         *     Better performance than getting full basket details, e.g., to display a list of templates.
         *     Authenticated users will only have access to their own data (filtered by customer ID).
         *     Service accounts (role `service`) have access to data across all customers.
         */
        get: operations["Basket_GETGetBasketHeadersList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/create-authenticated-basket": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create a basket for the authenticated user.
         *     The default transfer type will be "delivery".
         * @description Must be authenticated.
         *     Store is resolved from the request headers.
         */
        post: operations["Basket_POSTCreateAuthenticatedBasket"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/create-anonymous-basket": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create a basket for an anonymous user.
         *     Basket type will be "normal".
         *     The default transfer type will be "delivery".
         * @description Must be anonymous.
         *     Store is resolved from the request headers.
         */
        post: operations["Basket_POSTCreateAnonymousBasket"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/{basketId}/update-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update the status.
         * @description Can be called without authentication.
         */
        put: operations["Basket_PUTUpdateStatus"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/{basketId}/update-payment-information": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update the payment information.
         * @description Can be called without authentication.
         *     Basket status will be set to `CheckoutPayment` if the payment status is `Started`.
         *     Basket status will be set to `CheckoutContent` if the payment status is `Cancelled`, `Expired` or `Failed`.
         *     If the payment status is `Paid`, you must call the endpoint to submit the basket.
         */
        put: operations["Basket_PUTUpdatePaymentInformation"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/{basketId}/update-name": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update the name.
         * @description Must be authenticated.
         *     Update the name of the basket.
         */
        put: operations["Basket_PUTUpdateName"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/{basketId}/update-header": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update the basket header.
         * @description Can be called without authentication.
         *     Update most of the basket header fields.
         */
        put: operations["Basket_PUTUpdateHeader"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/{basketId}/batch-add-product-lines": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Add product lines to the basket.
         * @description Adds the product lines to the basket.
         *     Returns the complete basket.
         *     Will only save the new basket lines.
         *     Returns `409 Conflict` if product ID already exists in the `template` basket.
         */
        post: operations["Basket_POSTBatchAddProductLines"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/{basketId}/update-product-line": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update a single product line in the basket.
         * @description Updates a single product line in the basket.
         *     Returns the complete basket.
         *     Will save all the basket lines internally.
         */
        put: operations["Basket_PUTUpdateProductLine"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/{basketId}/batch-update-basket-lines": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update the lines in the basket.
         *     Delete lines not in the request.
         * @description Updates existing lines in the basket.
         *     Deletes the lines from the basket that are not in the request.
         *     Returns the complete basket.
         */
        put: operations["Basket_PUTBatchUpdateBasketLines"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/{basketId}/lines": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Delete lines by group id.
         * @description Deletes the basket lines for the specified group guids.
         */
        delete: operations["Basket_DELETEDeleteLines"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/{basketId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Delete basket.
         * @description Completely delete a basket.
         *     Should only be used for clearing a basket or template.
         *     Should not be used during the basket submit process.
         */
        delete: operations["Basket_DELETEDeleteBasket"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/{basketId}/submit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Submit the basket to the queue. */
        post: operations["Basket_POSTSubmitBasket"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/{basketId}/register-abandoned-basket-notification-sent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Registers the notification of an abandoned basket is sent using the current time. */
        put: operations["Basket_PUTRegisterAbandonedBasketNotificationSent"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/{basketId}/statistics": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets the basket statics for the specified basket ID.
         * @description Must NOT be authenticated.
         */
        get: operations["Basket_GETGetBasketStatistics"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/basket/statistics-list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets the basket statics for the specified list of basket IDs.
         * @description Must NOT be authenticated.
         */
        get: operations["Basket_GETGetBasketStatisticsList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/category/list/{rootCategoryId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Retrieves the categories with at least one product (default) as a hierarchical list.
         * @description Set the optional store id in the `X-NatchOS-StoreId` header.
         *     Can optionally be filtered for the current customer (if the authenticated customer has a custom catalog).
         *     Offline categories or categories without products will not be returned by default, unless filtering is disabled.
         */
        get: operations["Category_GET"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/category": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create or update a list of categories.
         * @description For categories at level 2, the parent category code and the category type code must be the same. The category type is a predefined list specified per implementation. Currently supported values are: `NAVIGATION`, `BRAND`, `BRAND_1`, `NAVIGATION_1`, `DEPARTMENT_1`, `BRAND_3`, `NAVIGATION_3`, `DEPARTMENT_3`, `BRAND_4`, `NAVIGATION_4`, `DEPARTMENT_4`.
         */
        post: operations["Category_POST"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/category/{categoryCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Delete a single category. */
        delete: operations["Category_DELETE"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/category/{sourceId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the external data for the specified categories under the given external source.
         * @description Extra data from an external source (other than master data) that is linked to a category.
         *
         *     Pass category code as entity code.
         *
         *     Pass an empty list to remove all external data from the entity for the given external source.
         */
        put: operations["CategoryExternalData_PUT"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/categoryproperty": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the property links per category.
         * @description Link between a category and one or more properties.
         *
         *     If the properties list is empty for a category all existing links will be removed.
         */
        put: operations["CategoryProperty_PUT"];
        post?: never;
        /** Delete the property links per category. */
        delete: operations["CategoryProperty_DELETE"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/customer/details": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets the specified customers. */
        get: operations["Customer_GET"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/customer/{customerId}/update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Update the customer data. */
        patch: operations["Customer_PATCH"];
        trace?: never;
    };
    "/plankton/api/customer": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create or update a list of customers. */
        post: operations["Customer_POST"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/customer/{customerCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Delete a single customer. */
        delete: operations["Customer_DELETE"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/customercategory": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the category combinations for the specified customers.
         * @description Link a customer to a list of categories, ie. allow list of brands the customer is allowed to purchase, deny list of product groups a customer can see.
         *
         *     Pass an empty list to remove all category links for a given customer.
         */
        put: operations["CustomerCategory_PUT"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/customerexternaldata/{sourceId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the external data for the specified customers under the given external source.
         * @description Extra data from an external source (other than master data) that is linked to a customer.
         *
         *     Pass customer code as entity code.
         *
         *     Pass an empty list to remove all external data from the entity for the given external source.
         */
        put: operations["CustomerExternalData_PUT"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/customersalesperson/{customerId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets the salespeople attached to the specified customer identifier. */
        get: operations["CustomerSalesperson_GET"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/customersalesperson": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the salesperson links per customer.
         * @description Link between a customer and one or more salespersons.
         *
         *     If the salesperson list is empty for a customer all existing links will be removed.
         */
        put: operations["CustomerSalesperson_PUT"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/deepdive/productdetailview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Logs a product detail view event. */
        post: operations["DeepDive_POSTProductDetailView"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/deepdive/productdocumentdownload": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Logs a product document download event. */
        post: operations["DeepDive_POSTProductDocumentDownload"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/document/details": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the specified documents.
         * @description Must be authenticated. Only documents matching the current user will be returned.
         */
        get: operations["Document_GET"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/document/most-recent-document-lines": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the most recent document lines the match the criteria.
         * @description Must be authenticated. Only document lines for documents matching the current user will be returned.
         */
        get: operations["Document_GETMostRecentDocumentLines"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/document": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create or update a list of documents. */
        post: operations["Document_POST"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/document/{documentCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Delete a single document. */
        delete: operations["Document_DELETE"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/documentsearch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Search documents for the current customer.
         * @description Must be authenticated and right to view the document type list.
         */
        post: operations["DocumentSearch_POST"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/entityfile/{entityType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the linked files for the specified entities.
         * @description Linked files are replaced per entity code and file type combination.
         *
         *     Existing links that match an entity code and file type combination, but are not specified in the data, will be removed.
         *
         *     Links for file types that are not specified for a given entity code and file type combination will not be removed.
         *
         *     E.g. sending only a single `product-image` for product `mach01`:
         *     - will delete all other `product-image` links
         *     - but will not delete other types like `product-video`
         *     - will not change any links for other products
         *
         *     If there are no files of a given file type for an entity, and you want to remove any existing links,
         *     add a fake file link for the entity, with the correct file type, but use `none` as the magic value for the url.
         *
         *     There is currently no way to delete all links for a specific entity, without specifying the types. Contact us to talk about your use case.
         */
        put: operations["EntityFile_PUT"];
        /**
         * Create or update the linked files for the specified entities.
         * @description A link between an entity and files (URLs).
         */
        post: operations["EntityFile_POST"];
        /**
         * Deletes the linked files for the specified entities.
         * @description A link between an entity and files (URLs).
         */
        delete: operations["EntityFile_DELETE"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/entitystore/{entityType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the linked stores for the specified entities.
         * @description A link between an entity and stores (IDs).
         *
         *     An empty list is not allowed.
         */
        put: operations["EntityStore_PUT"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/export-queue/get-next-item-by-type/{exportTypeId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get the next item from the specified type from the queue. */
        get: operations["ExportQueue_GETGetNextItemByType"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/export-queue/mark-processed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Mark a queue item as processed. */
        put: operations["ExportQueue_PUTMarkProcessed"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/export-queue/mark-failed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Mark a queue item as failed.
         * @description The internal failure count will be increased by 1.
         */
        put: operations["ExportQueue_PUTMarkFailed"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Logs in a user and returns the tokens.
         * @description For multi-customer the first customer will be used for the token.
         */
        post: operations["Login_POSTLogin"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/login/service-token": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Obtain a short-lived access token for a service account (machine-to-machine).
         * @description Authentication is based solely on the `X-Plankton-ApiKey` header.
         *     The API key must belong to a service account (`ClientType: service` in configuration).
         *     The resulting JWT contains a `role: service` claim and the client name.
         *     Service tokens grant cross-customer access to endpoints that support it (e.g. basket search).
         *     Do NOT send an `Authorization` header — this endpoint is anonymous.
         */
        post: operations["Login_POSTServiceToken"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/login/stores-allowed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Gets the stores with `sign in` permission.
         *     Returns `HTTP 401 Unauthorized` if the user is not found.
         * @description Gets a list of store ID for which the person has the `sign in allowed` permission with at least one customer.
         *     Most multi-store applications will determine store ID based on domain or deployment.
         *     In multi-tenant applications with a single domain, we can use this method to determine the store ID the user can sign in to.
         *     This does not check the status of the person, like locked out or blocked.
         */
        post: operations["Login_POSTStoresWithSignInAllowed"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/login/stores": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Gets the stores with `sign in` permission.
         * @deprecated
         * @description Gets a list of store ID for which the person has the `sign in allowed` permission with at least one customer.
         *     Most multi-store applications will determine store ID based on domain or deployment.
         *     In multi-tenant applications with a single domain, we can use this method to determine the store ID the user can sign in to.
         *     This does not check the status of the person, like locked out or blocked.
         */
        post: operations["Login_POSTStoresWithSignInAllowed_v1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/login/refresh": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Exchange a refresh token for new tokens. */
        post: operations["Login_POSTRefresh"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/login/impersonate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Impersonate a person and customer.
         * @description Will check if impersonation for the specified customer is allowed.
         *     WEB ROLE SIMULATION IS NOT IMPLEMENTED YET.
         */
        post: operations["Login_POSTImpersonate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/login/impersonate-search-customers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Search customers that can be impersonated.
         * @description Rights will be checked automatically and customers will be filtered to the salesperson if needed.
         */
        post: operations["Login_POSTImpersonateSearchCustomers"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/login/impersonate-search-persons": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Searches persons for the specified customer that have the sign-in permission. */
        post: operations["Login_POSTImpersonateSearchPersons"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/login/multi-customer-change": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Change current customer.
         * @description Get a new access token (and refresh token) for the current person and the specified customer.
         *     Will check if specified customer is part of the multi-customer options of the current person.
         */
        post: operations["Login_POSTMultiCustomerChange"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/login/multi-customer-options": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Get multi-customer options.
         * @description Get the list of customers that the current person can sign in for in a multi-customer setup.
         */
        post: operations["Login_POSTMultiCustomerOptions"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/login/debug-claims": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Output the claims from the JWT token. */
        post: operations["Login_POSTDebugClaims"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/message-configuration/resolve-email-config/{messageType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Get the configuration for an email message. */
        post: operations["MessageConfiguration_POSTresolve-email-config"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/meta/stores": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all stores.
         * @description List is cached in Plankton for 25 hours. This list is infrequently updated and can be safely cached by clients.
         */
        get: operations["Meta_GETStores"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/meta/document-statuses": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all document statuses.
         * @description List is cached in Plankton for 25 hours. This list is infrequently updated and can be safely cached by clients.
         */
        get: operations["Meta_GETDocumentStatuses"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/meta/order-types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all order types.
         * @description List is cached in Plankton for 25 hours. This list is infrequently updated and can be safely cached by clients.
         */
        get: operations["Meta_GETOrderTypes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/meta/payment-methods": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all payment methods.
         * @description List is cached in Plankton for 25 hours. This list is infrequently updated and can be safely cached by clients.
         */
        get: operations["Meta_GETPaymentMethods"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/meta/departments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all departments.
         *     List is NOT cached in Plankton.
         * @description This list is infrequently updated and can be safely cached by clients.
         */
        get: operations["Meta_GETDepartments"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/meta/warehouses": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all warehouses.
         * @description List is cached in Plankton for 25 hours. This list is infrequently updated and can be safely cached by clients.
         */
        get: operations["Meta_GETWarehouses"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/meta/transfer-subtypes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all the transfer subtypes.
         * @description List is cached in Plankton for 25 hours. This list is infrequently updated and can be safely cached by clients.
         */
        get: operations["Meta_GETTransferSubTypes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/meta/unit-of-measures": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all unit of measures.
         * @description List is cached in Plankton for 25 hours. This list is infrequently updated and can be safely cached by clients.
         */
        get: operations["Meta_GETUnitOfMeasures"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/meta/countries": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the countries that are linked to stores.
         * @description List is cached in Plankton for 25 hours. This list is infrequently updated and can be safely cached by clients.
         */
        get: operations["Meta_GETCountries"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/meta/webroles": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all the web roles with all the translations.
         * @description List is cached in Plankton for 25 hours. This list is infrequently updated and can be safely cached by clients.
         */
        get: operations["Meta_GETWebRoles"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/meta/sectors": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all the sectors with all the translations.
         * @description List is cached in Plankton for 25 hours. This list is infrequently updated and can be safely cached by clients.
         */
        get: operations["Meta_GETSectors"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/overpack/keys": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets the code keys of the entities that match with the internal id's. */
        get: operations["Overpack_GETKeys"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/overpack": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create or update a list of overpacks.
         * @description Overpack specific to a product.
         *     Defines a number of units in a pack.
         *     One product can have multiple overpacks.
         */
        post: operations["Overpack_POST"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/overpack/{overpackCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Delete a single overpack. */
        delete: operations["Overpack_DELETE"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/password/change-password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Change the password of the current person. */
        post: operations["Password_POSTChangePassword"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/password/password-reset-key-generate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate a password reset key.
         * @description Generate a password reset key.
         *     Call this from the "request password reset" page.
         *     Send the key via email.
         *     If the person is invalid then 204 wll be returned.
         */
        post: operations["Password_POSTPasswordResetKeyGenerate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/password/password-reset-key-validate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Validate the password reset key.
         * @description Validate the password reset key and return the person ID and username.
         *     Call this from the "reset password" page, which was accessed via the URL sent in the email.
         *     Username can be displayed to the user, so they know they are resetting the correct password.
         */
        post: operations["Password_POSTPasswordResetKeyValidate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/auth/password/reset-password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Change the password of a person using a password reset key. */
        post: operations["Password_POSTResetPassword"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/person/details": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets the specified persons. */
        get: operations["Person_GET"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/person/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Searches persons that match criteria. */
        post: operations["Person_POSTSearch"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/person": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create or update a list of persons. */
        post: operations["Person_POST"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/person/{personCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Delete a single person. */
        delete: operations["Person_DELETE"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/personexternaldata/{sourceId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the external data for the specified person under the given external source.
         * @description Extra data from an external source (other than master data) that is linked to a person.
         *
         *     Pass person code as entity code.
         *
         *     Pass an empty list to remove all external data from the entity for the given external source.
         */
        put: operations["PersonExternalData_PUT"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/product/get-id-by-code": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the identifier that matches the specified product code.
         * @description Can be zero if the code is unknown.
         */
        get: operations["Product_GETGetIdByCode"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/product/details": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets the specified products. */
        get: operations["Product_GET"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/product/getpropertiesbyproduct": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets the property values for the specified products.
         * @description Includes all the available translations.
         *     You can further constrain the results by passing a list of property ID's.
         */
        get: operations["Product_GETGetPropertiesByProduct"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/product": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create or update a list of products. */
        post: operations["Product_POST"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/product/{productCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Delete a single product. */
        delete: operations["Product_DELETE"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/product/batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Delete multiple products at once. */
        delete: operations["Product_DELETEDeleteProductsInBatch"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/productcategory": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the category links per product.
         * @description Link between a product and one or more categories.
         *
         *     If the category list is empty for a product all existing links will be removed.
         */
        put: operations["ProductCategory_PUT"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/productexternaldata/{sourceId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the external data for the specified products under the given external source.
         * @description Extra data from an external source (other than master data) that is linked to a product.
         *
         *     Pass product code as entity code.
         *
         *     Pass an empty list to remove all external data from the entity for the given external source.
         */
        put: operations["ProductExternalData_PUT"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/productprice/pricegroup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets the prices of one or more products and quantities for a specific customer price group and a specific currency. */
        get: operations["ProductPrice_GETGetForPriceGroup"];
        /**
         * Replace the product prices for the price groups.
         * @description Save or replace all product prices for the given price groups.
         *     Pass an empty list to remove all prices for a given price group.
         */
        put: operations["ProductPrice_PUT"];
        post?: never;
        /**
         * Delete the specified product prices per price group.
         * @description Delete the product prices and quantity combinations for the given price groups and currency.
         */
        delete: operations["ProductPrice_DELETE"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/productpropertyvalue": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the property values for the specified products.
         * @description Link between a product and one or more property values.
         */
        put: operations["ProductPropertyValue_PUT"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/productrelation/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get product relations for products.
         * @description Gets the product relations for the specified products and the specified relations (NatchOS.Plankton.ImplementationModels.RelationType).
         *     Will filter for current store if multi-store is enabled.
         *     Might return products the current user does not have access to (could be filtered via search).
         *     Relations can also be loaded together with the products, see NatchOS.Plankton.Controllers.Api.ProductController.
         */
        get: operations["ProductRelation_GETGetProductRelations"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/productrelation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the relations for the specified products.
         * @description Define relations between products.
         *
         *     Pass an empty list to remove all relations for a given product.
         */
        put: operations["ProductRelation_PUT"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/productsearch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Performs a search using the specified criteria and returns the results.
         * @description Supports search by text, category, and filter-only.
         *     The product identifier search has not been implemented yet.
         */
        post: operations["ProductSearch_POST"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/product-search-suggestions/suggestions": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Retrieves a list of product search suggestions based on the provided autocomplete query. */
        get: operations["ProductSearchSuggestions_GETGetSuggestions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/product-search-suggestions/history": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Retrieves a list of previously searched terms.
         * @description User must be authenticated to access this endpoint.
         */
        get: operations["ProductSearchSuggestions_GETGetHistory"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/productstock": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the stock information for the specified products.
         * @description Either stock count or stock indication is required.
         *
         *     Pass an empty list to remove all stock information for a given product.
         */
        put: operations["ProductStock_PUT"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/productstore": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the linked stores for the specified products.
         * @description A link between a product and stores (IDs), with optional extra data.
         *
         *     An empty list is not allowed.
         */
        put: operations["ProductStore_PUT"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/productsurcharge": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the surcharges for the specified products.
         * @description Pass an empty list to remove all surcharges for a given product.
         */
        put: operations["ProductSurcharge_PUT"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/property/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets all the properties that exist. */
        get: operations["Property_GETAll"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/property/all-classes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets all the property classes that properties belong to. */
        get: operations["Property_GETAllClasses"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/property": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create or update a list of properties. */
        post: operations["Property_POST"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/property/{propertyCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Delete a single property. */
        delete: operations["Property_DELETE"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/propertyvalue/getpropertiesvaluesbyproperty": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets the property values attached to the specified properties. */
        get: operations["PropertyValue_GETGetPropertiesValuesByProperty"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/propertyvalue": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Create or update a list of property values. */
        post: operations["PropertyValue_POST"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/propertyvalue/{propertyValueCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Delete a single property value. */
        delete: operations["PropertyValue_DELETE"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Returns informational text about the API.
         * @description This endpoint returns some informational text about the API (version, server) and your request (API key, IP address, trace id).
         *     This can be useful to test the connection.
         *     No authentication is required.
         */
        get: operations["Root_GET"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/shippingaddress/{shippingAddressId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets the specified shipping address.
         * @description Can be called without authentication. Needed for anonymous baskets.
         *     Authenticated users will only have access to their own data (filtered by customer ID).
         *     Service accounts (role `service`) have access to data across all customers.
         */
        get: operations["ShippingAddress_GET"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/shippingaddress/get-customer-shipping-address": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the shipping addresses for the current customer.
         * @description Must be authenticated. Only addresses matching the current user will be returned.
         */
        get: operations["ShippingAddress_GETGetCustomerShippingAddress"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/shippingaddress/{shippingAddressId}/update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update the shipping address data.
         * @description Can be called without authentication. Needed for anonymous baskets.
         *     Authenticated users will only have access to their own data (filtered by customer ID).
         *     Service accounts (role `service`) have access to data across all customers.
         */
        patch: operations["ShippingAddress_PATCH"];
        trace?: never;
    };
    "/plankton/api/shippingaddress": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Create or update a list of shipping addresses.
         *     This will not delete any shipping addresses.
         */
        post: operations["ShippingAddress_POST"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/shippingaddress/{shippingAddressCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /** Delete a single shipping address. */
        delete: operations["ShippingAddress_DELETE"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/plankton/api/shippingaddressexternaldata/{sourceId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace the external data for the specified shipping addresses under the given external source.
         * @description Extra data from an external source (other than master data) that is linked to a shipping address.
         *
         *     Pass shipping address code as entity code.
         *
         *     Pass an empty list to remove all external data from the entity for the given external source.
         */
        put: operations["ShippingAddressExternalData_PUT"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /** @description Contains the required fields to save an address. */
        Address: {
            /** @description The primary address line. */
            addressLine1: string;
            /** @description The secondary address line. */
            addressLine2?: string | null;
            /** @description The postal code. */
            postalCode: string;
            /** @description The city. */
            city: string;
            /** @description The territory code. */
            territoryCode?: string | null;
            /** @description The two-letter ISO country code. */
            countryCodeIso: string;
            /** @description The county code. */
            countyCode?: string | null;
            /** @description The location in a geodetic (round earth) coordinate system. */
            spatialLocation?: components["schemas"]["Coordinate"] | null;
        };
        /** @description Contains the required fields to save an address. */
        AddressDetails: {
            /** @description The primary address line. */
            addressLine1: string;
            /** @description The secondary address line. */
            addressLine2?: string | null;
            /** @description The postal code. */
            postalCode: string;
            /** @description The city. */
            city: string;
            /** @description The territory code. */
            territoryCode?: string | null;
            /** @description The two-letter ISO country code. */
            countryCodeIso: string;
        };
        /**
         * @description Most basic version of a translation attached to an entity.
         *     Contains fields with LCID specific content.
         */
        BasicTranslationJsonMisc: {
            /**
             * Format: int32
             * @description The language (as LCID or predefined CultureInfo identifier) of the translation.
             */
            lcid: number;
            /** @description The name of the entity in the specified LCID. */
            name: string;
            /** @description The description of the entity in the specified LCID. */
            description?: string | null;
            miscJson?: string | null;
        };
        /**
         * @description A part of the hierarchical structure.
         *     Can be used for navigation, product filters, groupings, etc...
         */
        Category: {
            /** @description The code of the category. */
            categoryCode: string;
            /**
             * @description The code of the parent category.
             *     The parent category must be created before the child category.
             *     Use the code of the category type if the category is at the highest level.
             */
            parentCategoryCode: string;
            /**
             * @description The code of the category type, part of a predefined list specified per implementation.
             *     Allowed values: `NAVIGATION`, `BRAND`, `BRAND_1`, `NAVIGATION_1`, `DEPARTMENT_1`, `BRAND_3`, `NAVIGATION_3`, `DEPARTMENT_3`, `BRAND_4`, `NAVIGATION_4`, `DEPARTMENT_4`.
             */
            categoryTypeCode: string;
            /** @description The internal name. */
            internalName: string;
            /** @description The internal description. */
            internalDescription?: string | null;
            /** @description A value indicating whether this category is online. */
            isOnline: boolean;
            /**
             * Format: int32
             * @description The optional weight of the category to calculate the score in search results of the generic autocomplete.
             */
            autoCompleteWeight?: number | null;
            /**
             * @description The sort order value of the category under its parent.
             *     Sorted alphabetically, not numerical.
             */
            sortOrderValue?: string | null;
            /**
             * Format: int32
             * @description The node level.
             *     Level 1 is reserved for root categories.
             */
            level: number;
            miscXml?: string | null;
            /**
             * @description The translations of the category.
             *     An empty list is not allowed, at least one item is required.
             *     Any existing translations for LCIDs that are not specified will be removed.
             */
            translations: components["schemas"]["CategoryTranslation"][];
        };
        /** @description Link between category and property. */
        CategoryPropertyCombination: {
            /** @description The category code. */
            categoryCode: string;
            /**
             * @description The properties that the category is linked to.
             *     An empty list is allowed; any existing links will be removed.
             */
            properties: components["schemas"]["CategoryPropertyData"][];
        };
        /** @description A property linked to a category. */
        CategoryPropertyData: {
            /** @description The code of the property linked to the category. */
            propertyCode: string;
            /** @description A value indicating whether this property must be shown with the product information. */
            showAsProductSpecification: boolean;
            /** @description A value indicating whether this property can be used as a filter for products. */
            useAsFilter: boolean;
            /**
             * Format: int32
             * @description The optional sort order value to sort properties.
             */
            sortOrderValue: number;
            miscJson?: string | null;
        };
        /** @description Included in category. Contains language specific data. */
        CategoryTranslation: {
            /**
             * Format: int32
             * @description The language (as LCID or predefined CultureInfo identifier) of the translation.
             */
            lcid: number;
            /** @description The name of the entity in the specified LCID. */
            name: string;
            /** @description The description of the entity in the specified LCID. */
            description?: string | null;
            miscXml?: string | null;
            /**
             * @description The list of synonyms of the entity in the specified LCID.
             *     Combined string length (with 1 character for separator per item) should not exceed 1000 characters.
             */
            synonymList?: string[] | null;
        };
        /** @description Represents data in a geodetic (round earth) coordinate system. */
        Coordinate: {
            /**
             * Format: double
             * @description The latitude of the position.
             */
            latitude: number;
            /**
             * Format: double
             * @description The longitude of the position.
             */
            longitude: number;
        };
        /** @description Contains address information, sales information, etc... It's the parent for NatchOS.Plankton.Models.Person. */
        Customer: {
            /** @description The code of the customer. */
            customerCode: string;
            /**
             * Format: int32
             * @description The type of the customer.
             *     Values are specific to the implementation.
             */
            customerType: number;
            name: string;
            secondaryName?: string | null;
            searchName?: string | null;
            /**
             * Format: int32
             * @description The language (as LCID or predefined CultureInfo identifier) of the customer.
             */
            lcid: number;
            /**
             * @description The currency ISO 4217 code.
             *     See http://en.wikipedia.org/wiki/ISO_4217 for a list.
             */
            currencyIso4217?: string | null;
            /**
             * @description The address.
             *     Required to save the customer.
             */
            address: components["schemas"]["Address"];
            /**
             * @description The phone numbers.
             *     This list may be empty.
             */
            phoneNumbers: components["schemas"]["PhoneNumber"][];
            /** Format: email */
            emailAddress?: string | null;
            websiteUrl?: string | null;
            /**
             * @description The customer status for the shop.
             *     Default accepted value is 'NORMAL'. Other values are specific to the implementation.
             */
            customerShopStatus: string;
            /** @description The reference under which the system owner is known to this customer. Reverse customer number so to speak. */
            systemOwnerReference?: string | null;
            /** @description A value indicating whether this NatchOS.Plankton.Models.Customer is blocked (depends on implementation). */
            isBlocked: boolean;
            /**
             * Format: double
             * @description A basic credit limit.
             *     Consider using NatchOS.Plankton.Models.Customer.Credit instead.
             */
            creditLimit?: number | null;
            departmentCode: string;
            customerPriceGroupCode?: string | null;
            customerDiscountCode?: string | null;
            paymentTermCode?: string | null;
            billToCustomerCode?: string | null;
            paymentMethodCode?: string | null;
            vatRegimeCode?: string | null;
            legalFormCode?: string | null;
            primaryContactPersonCode?: string | null;
            preferredBankAccountCode?: string | null;
            sectorCode?: string | null;
            /** @description The value added tax identification number of the customer. */
            vatRegistrationNumber?: string | null;
            /** @description A value indicating whether a value added tax identification number has been requested with a european government. */
            hasRequestedVatRegistrationNumber: boolean;
            /** @description The optional credit limit information. */
            credit?: components["schemas"]["CustomerCreditLimitData"] | null;
            miscXml?: string | null;
            miscJson?: string | null;
        };
        /**
         * @description Contains a list of categories linked to a given customer.
         *     The implementation can use this as an allow or deny list (something else).
         */
        CustomerCategory: {
            customerCode: string;
            /**
             * @description The categories that the customer is linked to.
             *     An empty list is allowed; any existing links will be removed.
             */
            categories: components["schemas"]["CustomerCategoryData"][];
        };
        /** @description A category linked to a customer. */
        CustomerCategoryData: {
            /** @description The code of the category linked to the customer. */
            categoryCode: string;
            miscXml?: string | null;
            miscJson?: string | null;
        };
        /**
         * @description A list of credit limits, optionally linked to a person, that are defined as
         *     a time-based total amount and/or single basket amount.
         */
        CustomerCreditLimitData: {
            /** @description A list of credit limit definitions. */
            creditLimits: components["schemas"]["CustomerCreditLimitDataLine"][];
            /** @description Gets or sets optional custom data related to the credit limit. */
            customData?: unknown;
        };
        /**
         * @description A credit limit, optionally linked to a person, that is defined as
         *     a time-based total amount (3 properties required) and/or
         *     a single basket amount (1 property required).
         */
        CustomerCreditLimitDataLine: {
            /**
             * @description The flow to execute when limit is reached.
             *     Supported values are `Approval` and `Block`.
             */
            limitAction: string;
            /** @description Gets or set the optional code of the person for whom the limit applies. */
            personCode?: string | null;
            /**
             * @description Gets or set the unit in which NatchOS.Plankton.Models.CustomerCreditLimitDataLine.PeriodCount is defined.
             *     Valid values are `D` (for days), `W` (for weeks), `M` (for months), `Y` (for years).
             *     Must also specify NatchOS.Plankton.Models.CustomerCreditLimitDataLine.PeriodCount and NatchOS.Plankton.Models.CustomerCreditLimitDataLine.PeriodMaximumAmount.
             */
            periodUnit?: string | null;
            /**
             * Format: int32
             * @description The length of the period to check outstanding orders amount.
             *     Must also specify NatchOS.Plankton.Models.CustomerCreditLimitDataLine.PeriodUnit and NatchOS.Plankton.Models.CustomerCreditLimitDataLine.PeriodMaximumAmount.
             */
            periodCount?: number | null;
            /**
             * Format: double
             * @description The maximum amount of the outstanding orders that is allowed.
             *     Must also specify NatchOS.Plankton.Models.CustomerCreditLimitDataLine.PeriodUnit and NatchOS.Plankton.Models.CustomerCreditLimitDataLine.PeriodCount.
             */
            periodMaximumAmount?: number | null;
            /**
             * Format: double
             * @description The maximum amount of a single basket.
             */
            basketMaximumAmount?: number | null;
            /** @description Gets or sets optional custom data related to the track and trace. */
            customData?: unknown;
        };
        /** @description Defines links between a customer and salespersons. */
        CustomerSalesperson: {
            customerCode: string;
            /**
             * @description The salesperson linked to the customer.
             *     An empty list is allowed; any existing links will be removed.
             */
            salespersons: components["schemas"]["Salesperson"][];
        };
        /**
         * @description Documents include invoices, quotes, invoices and shipping notes.
         *     This class contains the fields for all the types.
         */
        Document: {
            /** @description The code of the document. */
            documentCode: string;
            /**
             * @description The type of the document.
             *
             *     1 = Quote (A sales quote allows a prospective buyer to see what costs would be involved for the work they would like to have done.)
             *
             *     2 = Order (An agreement for specific products or services.)
             *
             *     3 = Shipment (A shipment document.)
             *
             *     4 = Invoice (An invoice for a completed order. Includes both positive and negative invoices, see NatchOS.Plankton.Models.DocumentInvoiceType.)
             */
            documentType: components["schemas"]["DocumentType"];
            /**
             * Format: int32
             * @description The store identifier (for multi-store implementations) to which the document is linked to.
             *     Use value `1` if multi-store is not used.
             */
            storeId: number;
            /**
             * Format: date-time
             * @description The date and optional time the document was created.
             */
            documentDateTime: string;
            /**
             * @description The custom status code of the document.
             *     Required when NatchOS.Plankton.Models.Document.DocumentType is NatchOS.Plankton.Models.DocumentType.Invoice or NatchOS.Plankton.Models.DocumentType.Order.
             */
            documentStatusCode?: string | null;
            /** @description Customer information attached to a document. */
            customerAddress: components["schemas"]["DocumentAddress"];
            /** @description Customer information attached to a document. */
            invoiceAddress: components["schemas"]["DocumentAddress"];
            /** @description Customer information attached to a document. */
            shippingAddress: components["schemas"]["DocumentAddress"];
            /**
             * @description The transfer type code.
             *     This <b>MUST</b> be one of the existing values in NatchOS.
             *     Creating new values from the API is not supported!
             *     Allowed values: `pickup`, `delivery`, `pickupnightsafe`.
             */
            transferTypeCode?: string | null;
            /**
             * @description The transfer subtype code.
             *     This <b>MUST</b> be one of the existing values in NatchOS.
             *     Creating new values from the API is not supported!
             *     Allowed values: .
             */
            transferSubTypeCode?: string | null;
            /** Format: double */
            totalAmountVatExcluded?: number | null;
            /** Format: double */
            totalAmountVatIncluded?: number | null;
            vatRegistrationNumber?: string | null;
            /**
             * @description List of NatchOS supported shipping advice options that can be used with NatchOS.Plankton.Models.ShippingAddress.ShippingAdvice and NatchOS.Plankton.Models.Document.ShippingAdvice.
             *
             *     0 = NotSet (Not set.)
             *
             *     1 = Partial (The order can be split up, ie. per product or even per smaller quantities of a single product.)
             *
             *     2 = CompleteOrderLines (The order can be split up, but every order line must be complete (quantity).)
             *
             *     3 = Complete (The order will be fulfilled once, when all products are available.)
             */
            shippingAdvice: components["schemas"]["ShippingAdvice"];
            externalReference?: string | null;
            internalComment?: string | null;
            externalComment?: string | null;
            paymentTermCode?: string | null;
            paymentMethodCode?: string | null;
            /**
             * @description The incoterms.
             *     International Commercial terms are a series of predefined commercial terms published by the International Chamber of Commerce (ICC) widely used in international commercial transactions. A series of three-letter trade terms related to common sales practices, the Incoterms rules are intended primarily to clearly communicate the tasks, costs and risks associated with the transportation and delivery of goods.
             */
            incoterms?: string | null;
            /**
             * Format: double
             * @description The currency factor.
             *     The value to be used to convert (multiply) the amount to euro.
             */
            currencyFactor?: number | null;
            /** @description The ISO 4217 Currency Code - 3 letters. */
            currencyIsoCode: string;
            creatorPersonCode?: string | null;
            salesPersonCode?: string | null;
            departmentCode?: string | null;
            contactMethodCode?: string | null;
            contactMethodDocumentNumber?: string | null;
            /**
             * Format: date-time
             * @description The requested date for delivery.
             */
            requestedDeliveryDate?: string | null;
            /**
             * Format: date-time
             * @description The promised date for delivery.
             */
            promisedDeliveryDate?: string | null;
            /** @description A value indicating whether this quote, invoice, order or shipment is still in progress. */
            isOpen: boolean;
            /**
             * Format: date-time
             * @description The date and optional time of the NatchOS.Plankton.Models.DocumentType.Shipment.
             *     Required when NatchOS.Plankton.Models.Document.DocumentType is NatchOS.Plankton.Models.DocumentType.Shipment.
             */
            shipmentDateTime?: string | null;
            /**
             * Format: date-time
             * @description The end date of the NatchOS.Plankton.Models.DocumentType.Quote.
             *     Required when NatchOS.Plankton.Models.Document.DocumentType is NatchOS.Plankton.Models.DocumentType.Quote.
             */
            quoteEndDate?: string | null;
            /**
             * @description The type of the NatchOS.Plankton.Models.DocumentType.Invoice.
             *     Required when NatchOS.Plankton.Models.Document.DocumentType is NatchOS.Plankton.Models.DocumentType.Invoice.
             *
             *     1 = Invoice (The regular invoice with a positive amount.)
             *
             *     2 = CreditNote (The invoice has a negative amount.)
             */
            invoiceType?: components["schemas"]["DocumentInvoiceType"] | null;
            /**
             * Format: double
             * @description The discount percentage of the NatchOS.Plankton.Models.DocumentType.Invoice.
             */
            invoiceDiscountPercentage?: number | null;
            /**
             * Format: date-time
             * @description The due date of the NatchOS.Plankton.Models.DocumentType.Invoice.
             *     Required when NatchOS.Plankton.Models.Document.DocumentType is NatchOS.Plankton.Models.DocumentType.Invoice.
             */
            invoiceDueDate?: string | null;
            /**
             * @description The type of the NatchOS.Plankton.Models.DocumentType.Order.
             *     Required when NatchOS.Plankton.Models.Document.DocumentType is NatchOS.Plankton.Models.DocumentType.Order.
             *
             *     1 = Normal (A normal order.)
             *
             *     2 = Return (A return order, customer sends something back.)
             */
            orderType?: components["schemas"]["DocumentOrderType"] | null;
            /**
             * Format: date-time
             * @description The date and optional time of the NatchOS.Plankton.Models.DocumentType.Order.
             *     Required when NatchOS.Plankton.Models.Document.DocumentType is NatchOS.Plankton.Models.DocumentType.Order.
             */
            orderDateTime?: string | null;
            miscXml?: string | null;
            /** @description The track and trace information. */
            trackTrace?: components["schemas"]["DocumentTrackTraceData"] | null;
            /** @description All the document lines. */
            lines?: components["schemas"]["DocumentLine"][] | null;
        };
        /** @description Customer information attached to a document. */
        DocumentAddress: {
            code: string;
            name: string;
            secondaryName?: string | null;
            /** Format: email */
            emailAddress?: string | null;
            contactName?: string | null;
            /**
             * Format: int32
             * @description The language (as LCID or predefined CultureInfo identifier) of the customer.
             */
            lcid: number;
            /** @description The address. */
            address: components["schemas"]["AddressDetails"];
        };
        /**
         * Format: int32
         * @description Supported types of invoices when NatchOS.Plankton.Models.Document.DocumentType is NatchOS.Plankton.Models.DocumentType.Invoice.
         *
         *     1 = Invoice (The regular invoice with a positive amount.)
         *
         *     2 = CreditNote (The invoice has a negative amount.)
         * @enum {integer}
         */
        DocumentInvoiceType: DocumentInvoiceType;
        /** @description A line attached to a NatchOS.Plankton.Models.Document. */
        DocumentLine: {
            /**
             * Format: int32
             * @description The line number.
             */
            lineNumber: number;
            /**
             * Format: int32
             * @description The parent line number to which this line is attached.
             */
            attachedToLineNumber?: number | null;
            /**
             * Format: int32
             * @description The custom type of the line.
             */
            lineType: number;
            /** @description The comment. */
            comment?: string | null;
            /** @description The name of the product. */
            productName?: string | null;
            /** @description The product number. */
            productNumber?: string | null;
            /** @description The technical product code. */
            productCode?: string | null;
            /** @description The product number as which this product is known to the main vendor. */
            mainVendorProductNumber?: string | null;
            /** @description The product number as which this product is known to the producer/manufacturer. */
            producerProductNumber?: string | null;
            /** @description The variant product number. */
            variantProductNumber?: string | null;
            /** @description The variant product code. */
            variantProductCode?: string | null;
            /** @description The customer product number. */
            customerProductNumber?: string | null;
            /** @description The customer product code. */
            customerProductCode?: string | null;
            /**
             * @description The EAN-13 barcode digits.
             *     An EAN-13 barcode (originally European Article Number, but now renamed International Article Number even though the abbreviation EAN has been retained) is a 13 digit (12 data and 1 check) barcoding standard.
             */
            ean?: string | null;
            /**
             * Format: double
             * @description The quantity.
             */
            quantity?: number | null;
            /**
             * Format: double
             * @description The quantity per unit of measure.
             */
            quantityPerUnitOfMeasure?: number | null;
            /**
             * Format: double
             * @description The quantity to invoice.
             */
            quantityToInvoice?: number | null;
            /**
             * Format: double
             * @description The quantity to ship.
             */
            quantityToShip?: number | null;
            /**
             * Format: double
             * @description The remaining quantity to ship.
             */
            remainingQuantity?: number | null;
            /**
             * Format: double
             * @description The unit price excluding vat.
             */
            unitPriceVatExcluded?: number | null;
            /**
             * Format: double
             * @description The unit price including vat.
             */
            unitPriceVatIncluded?: number | null;
            /**
             * Format: double
             * @description The vat percentage.
             */
            vatPercentage?: number | null;
            /**
             * Format: double
             * @description The line discount percentage.
             */
            lineDiscountPercentage?: number | null;
            /**
             * Format: double
             * @description The line discount amount.
             */
            lineDiscountAmount?: number | null;
            /**
             * Format: double
             * @description The line amount excluding vat.
             */
            lineAmountVatExcluded?: number | null;
            /**
             * Format: double
             * @description The line amount including vat.
             */
            lineAmountVatIncluded?: number | null;
            /** @description The unit of measure code. */
            unitOfMeasureCode?: string | null;
            /**
             * Format: double
             * @description The net weight.
             */
            weightNet?: number | null;
            /**
             * Format: double
             * @description The gross weight.
             */
            weightGross?: number | null;
            /** @description The weight unit of measure code. */
            weightUnitOfMeasureCode?: string | null;
            /**
             * Format: double
             * @description The volume.
             */
            volume?: number | null;
            /** @description The volume unit of measure code. */
            volumeUnitOfMeasureCode?: string | null;
            /** @description The department code. */
            departmentCode?: string | null;
            /**
             * Format: date-time
             * @description The shipment date and time.
             */
            shipmentDateTime?: string | null;
            /**
             * Format: date-time
             * @description The planned shipment date.
             */
            plannedShipmentDate?: string | null;
            /**
             * Format: date-time
             * @description The planned delivery date.
             */
            plannedDeliveryDate?: string | null;
            /**
             * Format: date-time
             * @description The promised delivery date.
             */
            promisedDeliveryDate?: string | null;
            /**
             * Format: date-time
             * @description The requested delivery date.
             */
            requestedDeliveryDate?: string | null;
            /** @description The custom status code of the line. */
            documentStatusCode?: string | null;
            miscXml?: string | null;
            /** @description The track and trace information. */
            trackTrace?: components["schemas"]["DocumentTrackTraceData"] | null;
            /**
             * Format: int32
             * @description The basket header id to link the document line to a basket.
             */
            basketHeaderId?: number | null;
        };
        /**
         * Format: int32
         * @description Supported types of orders when NatchOS.Plankton.Models.Document.DocumentType is NatchOS.Plankton.Models.DocumentType.Order.
         *
         *     1 = Normal (A normal order.)
         *
         *     2 = Return (A return order, customer sends something back.)
         * @enum {integer}
         */
        DocumentOrderType: DocumentOrderType;
        /**
         * @description Holds the track and trace information with optional custom data for a document or document line.
         *     Total JSON length must not exceed 4000 characters.
         */
        DocumentTrackTraceData: {
            /** @description A list of tracking information per parcel. */
            tracking?: components["schemas"]["DocumentTrackTraceItem"][] | null;
            /** @description Gets or sets optional custom data related to the track and trace. */
            customData?: unknown;
        };
        /**
         * @description Parcel level information.
         *     Part of the NatchOS.Plankton.Models.DocumentTrackTraceData.
         */
        DocumentTrackTraceItem: {
            /**
             * @description The tracking number of the parcel.
             *     Either `ShippingAgent` or `Url` is required.
             */
            trackingNumber: string;
            /** @description The optional shipping agent. */
            shippingAgent?: string | null;
            /** @description The optional URL with details of the parcel. */
            url?: string | null;
            /** @description Gets or sets optional custom data related to the track and trace. */
            customData?: unknown;
        };
        /**
         * Format: int32
         * @description Supported values for type of NatchOS.Plankton.Models.Document.
         *
         *     1 = Quote (A sales quote allows a prospective buyer to see what costs would be involved for the work they would like to have done.)
         *
         *     2 = Order (An agreement for specific products or services.)
         *
         *     3 = Shipment (A shipment document.)
         *
         *     4 = Invoice (An invoice for a completed order. Includes both positive and negative invoices, see NatchOS.Plankton.Models.DocumentInvoiceType.)
         * @enum {integer}
         */
        DocumentType: DocumentType;
        /**
         * @description Extra data from an external source (other than master data) that is linked to an entity.
         *     Supported entities: NatchOS.Plankton.Models.Person, NatchOS.Plankton.Models.Customer, NatchOS.Plankton.Models.ShippingAddress, NatchOS.Plankton.Models.Product, NatchOS.Plankton.Models.Category and warehouse.
         */
        EntityExternalData: {
            /** @description The entity code. */
            entityCode: string;
            /** @description The external data. */
            externalData: components["schemas"]["ExternalData"][];
        };
        /** @description Defines links between an entity code and files. */
        EntityFiles: {
            /** @description The code of the entity the file belongs to. */
            entityCode: string;
            /**
             * @description The files linked to the entity.
             *     An empty list is allowed; any existing links will be removed.
             */
            files: components["schemas"]["FileLink"][];
        };
        /** @description A store attached to an entity (in multi-store). */
        EntityStoreLink: {
            /**
             * Format: int32
             * @description The store identifier to link the entity to.
             */
            storeId: number;
            /**
             * @description The JSON that contains extra data that can not be placed in the predefined properties.
             *     Value must be escaped.
             */
            miscJson?: string | null;
        };
        /** @description Defines links between an entity code and stores (in multi-store). */
        EntityStores: {
            /** @description The code of the entity. */
            entityCode: string;
            /**
             * @description The stores linked to the entity.
             *     An empty list is allowed; any existing store links will be removed.
             */
            stores: components["schemas"]["EntityStoreLink"][];
        };
        /** @description Extra data for an entity that can optionally be linked to a specific culture. */
        ExternalData: {
            /**
             * Format: int32
             * @description The optional language (as LCID or predefined CultureInfo identifier) of the data.
             *     The data is considered culture neutral if no value is specified.
             */
            lcid?: number | null;
            /**
             * @description The miscellaneous XML.
             *     Set to `null` to remove the external data.
             */
            miscXml?: string | null;
        };
        /** @description A file attached to an entity. */
        FileLink: {
            /**
             * @description The file type.
             *     This determines the type and entity the file is linked to and must be a known value within NatchOS, configured by Alistar.
             *     Can be a path that starts with `\` (e.g. Azure Blob Storage container) or only the name for the type.
             *     E.g. `\category-image` to be used with a relative url, `ProductManual` to indicate the type.
             */
            fileType: string;
            /**
             * @description The URL of the file.
             *
             *     An absolute URL, e.g. `https://pim.natch.be/category-image/type1/x123987.jpg`, when the NatchOS.Plankton.Models.FileLink.FileType does not start with `\`.
             *     The absolute URL must have `https` protocol.
             *
             *     A root-relative URL, e.g. `/x123987.jpg` or `/type1/x123987.jpg`, that is prefixed with an origin (defined in application settings) and the NatchOS.Plankton.Models.FileLink.FileType (that starts with `\`).
             *     The relative URL must start with a forward slash `/`.
             *
             *     An extension is not required.
             */
            url: string;
            /**
             * Format: int32
             * @description The optional language (as LCID or predefined CultureInfo identifier) of the file.
             */
            lcid?: number | null;
            miscXml?: string | null;
        };
        /**
         * Format: int32
         * @description Supported values for gender.
         *
         *     0 = None (Unknown or not set.)
         *
         *     1 = Male (Male gender.)
         *
         *     2 = Female (Female gender.)
         * @enum {integer}
         */
        Gender: Gender;
        /** @description DEPRECATED. Use properties and property values instead. */
        Measurement: {
            /** @description The code for the unit of measure. */
            unitOfMeasureCode: string;
            /**
             * Format: double
             * @description The value of the measurement in the specified unit.
             *     Precision of 19 with a scale of 6.
             */
            value: number;
        };
        "Microsoft.AspNetCore.Mvc.ProblemDetails": {
            type?: string | null;
            title?: string | null;
            /** Format: int32 */
            status?: number | null;
            detail?: string | null;
            instance?: string | null;
        } & {
            [key: string]: unknown;
        };
        "Microsoft.AspNetCore.Mvc.ValidationProblemDetails": {
            type?: string | null;
            title?: string | null;
            /** Format: int32 */
            status?: number | null;
            detail?: string | null;
            instance?: string | null;
            errors: {
                [key: string]: string[];
            };
        } & {
            [key: string]: unknown;
        };
        "NatchOS.Domain.Ecommerce.CustomerSalesperson": {
            readonly isValid: boolean;
            miscXml?: string | null;
            isInternalSales: boolean;
            isMainSalesperson: boolean;
            /** Format: int32 */
            personId: number;
            /** Format: int32 */
            storeId: number;
        };
        /**
         * Format: int32
         * @description Defines how the brand name will be resolved.
         *
         *     0 = None (No brand name will be resolved.)
         *
         *     1 = Category (Determine the brand name via a category. Needs the root category id.)
         *
         *     2 = Property (Determine the brand name via a property. Needs the brand property id.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ApiModels.AnalyticsBrandSource": NatchOSPlanktonApiModelsAnalyticsBrandSource;
        /** @description Response object for authentication errors. */
        "NatchOS.Plankton.ApiModels.AuthErrorResponse": {
            /** @description The user-friendly error message. */
            message?: string | null;
            /**
             * @description The error code.
             *
             *     0 = None (Value has not been set.)
             *
             *     1 = Success (The username and password are valid. A successful login attempt has been registered.)
             *
             *     2 = IsLockedOut (The username is valid, but the account was previously locked out.)
             *
             *     3 = UserNotFound (The username is not valid.)
             *
             *     4 = LockedOutAfterTooManyAttempts (The username is valid, but password does not match. There have been too many attempt to authenticate the user in a specific time frame. The account has been locked out (and the event has been registered).)
             *
             *     5 = PasswordDoesNotMatch (The username is valid, but password does not match. A failed login attempt has been registered.)
             *
             *     6 = IsBlocked (The username is valid, but the account is blocked from using the application.)
             *
             *     7 = IsMissingPermissionForSignIn (User does not have the permission to sign in.)
             */
            code: components["schemas"]["NatchOS.Plankton.ApiModels.AuthenticateResultStatus"];
            /** @description A value indicating whether the credentials provided were invalid. */
            invalidCredentials: boolean;
        };
        /**
         * Format: int32
         * @description Defines the possible status of an authentication result.
         *
         *     0 = None (Value has not been set.)
         *
         *     1 = Success (The username and password are valid. A successful login attempt has been registered.)
         *
         *     2 = IsLockedOut (The username is valid, but the account was previously locked out.)
         *
         *     3 = UserNotFound (The username is not valid.)
         *
         *     4 = LockedOutAfterTooManyAttempts (The username is valid, but password does not match. There have been too many attempt to authenticate the user in a specific time frame. The account has been locked out (and the event has been registered).)
         *
         *     5 = PasswordDoesNotMatch (The username is valid, but password does not match. A failed login attempt has been registered.)
         *
         *     6 = IsBlocked (The username is valid, but the account is blocked from using the application.)
         *
         *     7 = IsMissingPermissionForSignIn (User does not have the permission to sign in.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ApiModels.AuthenticateResultStatus": NatchOSPlanktonApiModelsAuthenticateResultStatus;
        /**
         * Format: int32
         * @description Defines the filter for basket search on how the basket is attached to person, customer or custom entity id.
         *
         *     0 = Person (The basket is attached to a person.)
         *
         *     1 = Customer (The basket is attached to a customer. Will match all persons under the customer.)
         *
         *     2 = CustomEntity (The basket is attached to a custom entity.)
         *
         *     3 = None (No filter. Only for service accounts.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ApiModels.BasketFilterAttachedTo": NatchOSPlanktonApiModelsBasketFilterAttachedTo;
        /**
         * Format: int32
         * @description Defines the options for sorting the basket search results.
         *
         *     0 = NotSet (No specific order. Best performance.)
         *
         *     10 = CreationTimeAscending (Sort by creation time ascending.)
         *
         *     11 = CreationTimeDescending (Sort by creation time descending.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ApiModels.BasketSearchResultSortOrder": NatchOSPlanktonApiModelsBasketSearchResultSortOrder;
        /** @description Defines the response of the /root endpoint. */
        "NatchOS.Plankton.ApiModels.RootResponse": {
            /** @description The information about the API call and the server. */
            message?: string | null;
            /** @description A value indicating whether the API key passed into the headers is valid. */
            isValidApiKey: boolean;
            /**
             * Format: int32
             * @description The NatchOS store ID.
             */
            storeId: number;
        };
        /** @description Response object for the authentication actions. */
        "NatchOS.Plankton.ApiModels.TokenResponse": {
            /** @description The access token as a JWT. */
            accessToken?: string | null;
            /**
             * @description The refresh token to use to get a new access token.
             *     Refresh tokens are valid for 7 days and are single use.
             */
            refreshToken?: string | null;
        };
        "NatchOS.Plankton.Controllers.Api.Auth.AccountController+HasActiveAccountInStoreResponse": {
            hasAccountInStore: boolean;
            errorMessage?: string | null;
        };
        /** @description Request to change activation mail status. */
        "NatchOS.Plankton.Controllers.Api.Auth.AccountController+MarkActivationMailRequest": {
            /**
             * Format: int32
             * @description The person id.
             */
            personId: number;
        };
        "NatchOS.Plankton.Controllers.Api.Auth.AccountController+PersonRightsResponse": {
            rights: number[];
        };
        /** @description Represents a claim debug data transfer object. */
        "NatchOS.Plankton.Controllers.Api.Auth.LoginController+ClaimDebugDto": {
            /** @description The type of the claim. */
            type?: string | null;
            /** @description The value of the claim. */
            value?: string | null;
        };
        /** @description Request object for the impersonate endpoint. */
        "NatchOS.Plankton.Controllers.Api.Auth.LoginController+ImpersonateRequest": {
            /**
             * Format: int32
             * @description The customer id for the access token.
             */
            customerId: number;
            /**
             * Format: int32
             * @description The person id for the access token.
             */
            personId: number;
            /** @description The 2-letter language code (en, nl, fr, de) for the result messages. */
            languageCode?: string | null;
        };
        /**
         * @description Request object to search customers for impersonation.
         *     Customer code has been added for easier test integration.
         *     In an implementation you would use the search term.
         */
        "NatchOS.Plankton.Controllers.Api.Auth.LoginController+ImpersonateSearchCustomersRequest": {
            /** @description The search term for the full-text search. */
            searchTerm?: string | null;
            /** @description The customer code for a complete match. */
            customerCode?: string | null;
            /** @description The 2-letter language code (en, nl, fr, de) for the result messages. */
            languageCode?: string | null;
        };
        /** @description Request object to search for persons that can be impersonated. */
        "NatchOS.Plankton.Controllers.Api.Auth.LoginController+ImpersonateSearchPersonsRequest": {
            /**
             * Format: int32
             * @description The customer id.
             */
            customerId: number;
        };
        /** @description Request object for the login endpoint. */
        "NatchOS.Plankton.Controllers.Api.Auth.LoginController+LoginRequest": {
            /** @description The user's email address. */
            email?: string | null;
            /** @description The user's password. */
            password?: string | null;
            /** @description The 2-letter language code (en, nl, fr, de) for the result messages. */
            languageCode?: string | null;
        };
        /** @description Request object for the 'change customer' endpoint. */
        "NatchOS.Plankton.Controllers.Api.Auth.LoginController+MultiCustomerChangeRequest": {
            /**
             * Format: int32
             * @description The customer id for the access token.
             */
            customerId: number;
        };
        /** @description Request object for the refresh endpoint. */
        "NatchOS.Plankton.Controllers.Api.Auth.LoginController+RefreshRequest": {
            /** @description The refresh token. */
            refreshToken?: string | null;
        };
        /** @description Request object for the stores endpoint. */
        "NatchOS.Plankton.Controllers.Api.Auth.LoginController+StoresRequest": {
            /** @description The user's email address. */
            email?: string | null;
            /** @description The 2-letter language code (en, nl, fr, de) for the result messages. */
            languageCode?: string | null;
        };
        /** @description Request object for the stores endpoint. */
        "NatchOS.Plankton.Controllers.Api.Auth.LoginController+StoresRequest1": {
            /** @description The user's email address. */
            email?: string | null;
        };
        /** @description Request to change the password of the current person. */
        "NatchOS.Plankton.Controllers.Api.Auth.PasswordController+ChangePasswordRequest": {
            /** @description The current password. */
            currentPassword?: string | null;
            /** @description The new password, with a maximum length of 128. */
            newPassword?: string | null;
        };
        /**
         * @description Request to get a key that will allow the user to change the password.
         *     The key is valid for a limited time, and should be sent via email.
         */
        "NatchOS.Plankton.Controllers.Api.Auth.PasswordController+PasswordResetKeyGenerateRequest": {
            /** @description The username of the person to change the password for. */
            username?: string | null;
            /**
             * Format: int32
             * @description The number of hours until the key expires.
             */
            hoursUntilExpiration: number;
        };
        /** @description Response for generating a password reset key. */
        "NatchOS.Plankton.Controllers.Api.Auth.PasswordController+PasswordResetKeyGenerateResponse": {
            /**
             * Format: int32
             * @description The ID of the person.
             */
            personId: number;
            /** @description The username of the person. */
            username?: string | null;
            /** @description The email address of the person. */
            email?: string | null;
            /** @description The generated password reset key. */
            passwordResetKey?: string | null;
        };
        /** @description Request to validate a key that will allow the user to change the password. */
        "NatchOS.Plankton.Controllers.Api.Auth.PasswordController+PasswordResetKeyValidateRequest": {
            /** @description The key to validate. */
            passwordResetKey?: string | null;
        };
        /** @description Response for validating a password reset key. */
        "NatchOS.Plankton.Controllers.Api.Auth.PasswordController+PasswordResetKeyValidateResponse": {
            /** @description Indicates if the key is valid and not expired. */
            isValid: boolean;
            /**
             * Format: int32
             * @description The ID of the person associated with the key.
             */
            personId: number;
            /** @description The username of the person associated with the key. */
            username?: string | null;
        };
        /** @description Request to reset the password of a person using a reset key. */
        "NatchOS.Plankton.Controllers.Api.Auth.PasswordController+ResetPasswordRequest": {
            /** @description The reset key, created in another endpoint. */
            passwordResetKey?: string | null;
            /** @description The new password, with a maximum length of 128. */
            newPassword?: string | null;
        };
        /** @description The request to update a basket line. */
        "NatchOS.Plankton.Controllers.Api.BasketController+AddBasketLineRequestItem": {
            /**
             * Format: double
             * @description The quantity of products.
             */
            quantity: number;
            /**
             * Format: double
             * @description The gross sales price, without VAT, without discounts for a single unit.
             */
            unitPriceGrossVatExcluded: number;
            /**
             * Format: double
             * @description The net sales price, without VAT, including discounts, for a single unit.
             *     The actual price the customer pays.
             */
            unitPriceNetVatExcluded: number;
            /** @description A value indicating whether the line must be excluded from the order when exporting the basket. */
            excludeFromWebOrderExport?: boolean | null;
            /**
             * Format: double
             * @description The VAT amount for a single unit.
             */
            unitVatAmount?: number | null;
            /**
             * Format: double
             * @description The VAT percentage for the basket line.
             *     E.g., 21.00 for 21%.
             */
            vatPercentage?: number | null;
            /** @description The optional comment value. */
            comment?: string | null;
            /** @description The JSON that contains extra data. */
            miscJson?: string | null;
            /**
             * Format: int32
             * @description The technical key to identify a product.
             */
            productId: number;
            /**
             * @description The ID of the list from which the product was added to the basket.
             *     Will be sent to Google Tag Manager.
             */
            attributionListItemId?: string | null;
            /**
             * @description The name of the list from which the product was added to the basket.
             *     Will be sent to Google Tag Manager.
             */
            attributionListItemName?: string | null;
            /**
             * Format: uuid
             * @description The GUID used to group basket lines together, i.e., attach comment line to product line.
             *     All basket lines with the same NatchOS.Plankton.Controllers.Api.BasketController.AddBasketLineRequestItem.BasketLineGroupGuid must be removed as a unit.
             */
            basketLineGroupGuid?: string | null;
        };
        /** @description The request to submit a basket. */
        "NatchOS.Plankton.Controllers.Api.BasketController+BasketSubmitRequest": {
            /**
             * @description A flag indicating whether basket lines for identical products should be combined in the XML output.
             *     This will not change the basket content itself.
             */
            groupBasketLines: boolean;
        };
        /** @description The request to add multiple basket lines. */
        "NatchOS.Plankton.Controllers.Api.BasketController+BatchAddBasketLinesRequest": {
            /**
             * @description The basket lines to add.
             *     Must contain at least one item.
             */
            lines?: components["schemas"]["NatchOS.Plankton.Controllers.Api.BasketController+AddBasketLineRequestItem"][] | null;
            /** @description If set to `true`, multiple equal product ids can be added to the same basket. */
            multipleIdenticalProductIdsSupported: boolean;
            /** @description A value indicating whether the shipping cost of the basket should be reset to `null`. */
            resetShippingCost: boolean;
        };
        /** @description The request update multiple basket lines as part of a batch. */
        "NatchOS.Plankton.Controllers.Api.BasketController+BatchUpdateBasketLineRequestItem": {
            /**
             * Format: double
             * @description The quantity of products.
             */
            quantity: number;
            /**
             * Format: double
             * @description The gross sales price, without VAT, without discounts for a single unit.
             */
            unitPriceGrossVatExcluded: number;
            /**
             * Format: double
             * @description The net sales price, without VAT, including discounts, for a single unit.
             *     The actual price the customer pays.
             */
            unitPriceNetVatExcluded: number;
            /** @description A value indicating whether the line must be excluded from the order when exporting the basket. */
            excludeFromWebOrderExport?: boolean | null;
            /**
             * Format: double
             * @description The VAT amount for a single unit.
             */
            unitVatAmount?: number | null;
            /**
             * Format: double
             * @description The VAT percentage for the basket line.
             *     E.g., 21.00 for 21%.
             */
            vatPercentage?: number | null;
            /** @description The optional comment value. */
            comment?: string | null;
            /** @description The JSON that contains extra data. */
            miscJson?: string | null;
            /**
             * Format: int32
             * @description The ID of the basket line.
             */
            basketLineId: number;
        };
        /** @description The request to batch update the basket lines. */
        "NatchOS.Plankton.Controllers.Api.BasketController+BatchUpdateBasketLinesRequest": {
            /**
             * @description The basket lines to update.
             *     Must contain at least one item.
             */
            lines?: components["schemas"]["NatchOS.Plankton.Controllers.Api.BasketController+BatchUpdateBasketLineRequestItem"][] | null;
            /** @description If set to `true`, multiple equal product ids can be added to the same basket. */
            multipleIdenticalProductIdsSupported: boolean;
            /**
             * @description A value indicating whether lines not included in the request should be deleted.
             *     Defaults to `true`.
             */
            deleteLinesNotInRequest: boolean;
            /** @description A value indicating whether the shipping cost of the basket should be reset to `null`. */
            resetShippingCost: boolean;
        };
        /** @description The request to create an anonymous basket. */
        "NatchOS.Plankton.Controllers.Api.BasketController+CreateAnonymousBasketRequest": {
            /**
             * @description List of the NatchOS supported transfer types that can be used.
             *     See TransferSubType for the subtypes per transfer type.
             *
             *     0 = NotSet (Not set.)
             *
             *     1 = Pickup (Buyer will pick up the order.)
             *
             *     2 = Delivery (Seller will ship the order to the buyer.)
             *
             *     3 = PickupNightLocker (Buyer will pick up the order from a night locker.)
             */
            transferType: components["schemas"]["NatchOS.Plankton.ImplementationModels.PredefinedTransferType"];
        };
        /** @description The request to create a basket for the authenticated user. */
        "NatchOS.Plankton.Controllers.Api.BasketController+CreateBasketRequest": {
            /**
             * @description Identifies the different types of baskets.
             *
             *     1 = Normal (A regular basket.)
             *
             *     2 = Template (A template basket.)
             *
             *     3 = Blanket (A blanket basket.)
             *
             *     4 = Quote (A basket to request a quote for.)
             *
             *     5 = BasketFromAcceptedQuote (A basket from an approved quote.)
             *
             *     6 = BasketFromDeniedQuote (A basket from a denied quote.)
             *
             *     7 = NormalByInternal (A regular basket, but created by an internal person (ie. via impersonation).)
             *
             *     8 = ProductSelection (A selection of products defined by a person with enough rights, that can be linked to one or more persons. This can be used to group product together and limit the catalogue of a person to only selected products.)
             *
             *     9 = QuoteBasketForAnonymous (A basket for anonymous users with products meant for a quote request.)
             *
             *     10 = ToEProcurement (Much like a normal basket, but the basket is created during a PunchOut session (e.g. OCI or cXML). However, when proceeding through checkout, the basket will not be submitted like a normal basket. It will not be transmitted to the ERP system and therefore it will not directly generate an order in ERP. When checkout of this basket is finished, the basket is sent to the customer's e-procurement system that initiates the PunchOut session.)
             *
             *     11 = FromEProcurement (A basket of this type is created by a direct request from a customer's e-procurement system to the web shop, e.g. through a cXML OrderRequest. When such a request is received, the configured submit pipeline will typically be triggered to e.g. produce a web order in the ERP system and send a confirmation email.)
             */
            basketType: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketType"];
            /**
             * @description The optional flag to attach the basket to the current person.
             *     By default, the basket will be attached to the current person.
             */
            attachToCurrentPerson?: boolean | null;
            /**
             * Format: int32
             * @description The optional technical key of a custom entity the basket is attached to.
             *     This is implementation-specific.
             *     A basket can be linked to a custom entity or a person (default).
             */
            attachedToCustomId?: number | null;
            /**
             * @description The optional basket name.
             *     Should be used for templates.
             */
            basketName?: string | null;
        };
        /**
         * Format: int32
         * @description 0 = NotSet
         *
         *     1 = Normal (A regular basket.)
         *
         *     2 = NormalByInternal (A regular basket, but created by an internal person (ie. via impersonation).)
         *
         *     3 = Quote (A quote basket.)
         * @enum {integer}
         */
        "NatchOS.Plankton.Controllers.Api.BasketController+CurrentBasketQueryBasketType": NatchOSPlanktonControllersApiBasketControllerCurrentBasketQueryBasketType;
        /** @description The request to delete lines. */
        "NatchOS.Plankton.Controllers.Api.BasketController+DeleteLinesRequest": {
            /** @description The GUID list of basket line groups to be deleted. */
            groupGuids: string[];
            /** @description A value indicating whether the shipping cost of the basket should be reset to `null`. */
            resetShippingCost: boolean;
        };
        /** @description The request to merge an anonymous basket with a normal basket. */
        "NatchOS.Plankton.Controllers.Api.BasketController+MergeBasketRequest": {
            /**
             * Format: int32
             * @description The identifier of the source basket.
             */
            sourceBasketId: number;
            /**
             * Format: int32
             * @description The identifier of the target basket.
             */
            targetBasketId: number;
            /** @description If set to `true`, multiple equal product ids can be added to the same basket. */
            multipleIdenticalProductIdsSupported: boolean;
            /**
             * @description A value indicating how quantities should be handled when the original and the merging basket contain lines with identical products,
             *     and multiple lines with identical products are not allowed.
             *
             *     0 = Add
             *
             *     1 = Highest
             *
             *     2 = UseSource
             *
             *     3 = KeepTarget
             */
            quantityHandling: components["schemas"]["NatchOS.Plankton.Controllers.Api.BasketController+MergeBasketRequest+QuantityHandlingMethod"];
            /** @description A value indicating whether the shipping cost of the basket should be reset to `null`. */
            resetShippingCost: boolean;
        };
        /**
         * Format: int32
         * @description Defines the methods for handling the quantity when the target basket already contains the product and same products are not allowed.
         *
         *     0 = Add
         *
         *     1 = Highest
         *
         *     2 = UseSource
         *
         *     3 = KeepTarget
         * @enum {integer}
         */
        "NatchOS.Plankton.Controllers.Api.BasketController+MergeBasketRequest+QuantityHandlingMethod": NatchOSPlanktonControllersApiBasketControllerMergeBasketRequestQuantityHandlingMethod;
        /** @description The request to update a basket line. */
        "NatchOS.Plankton.Controllers.Api.BasketController+UpdateBasketLineRequest": {
            /**
             * Format: double
             * @description The quantity of products.
             */
            quantity: number;
            /**
             * Format: double
             * @description The gross sales price, without VAT, without discounts for a single unit.
             */
            unitPriceGrossVatExcluded: number;
            /**
             * Format: double
             * @description The net sales price, without VAT, including discounts, for a single unit.
             *     The actual price the customer pays.
             */
            unitPriceNetVatExcluded: number;
            /** @description A value indicating whether the line must be excluded from the order when exporting the basket. */
            excludeFromWebOrderExport?: boolean | null;
            /**
             * Format: double
             * @description The VAT amount for a single unit.
             */
            unitVatAmount?: number | null;
            /**
             * Format: double
             * @description The VAT percentage for the basket line.
             *     E.g., 21.00 for 21%.
             */
            vatPercentage?: number | null;
            /** @description The optional comment value. */
            comment?: string | null;
            /** @description The JSON that contains extra data. */
            miscJson?: string | null;
            /**
             * Format: int32
             * @description The ID of the basket line.
             */
            basketLineId: number;
            /** @description If set to `true`, multiple equal product ids can be added to the same basket. */
            multipleIdenticalProductIdsSupported: boolean;
            /** @description A value indicating whether the shipping cost of the basket should be reset to `null`. */
            resetShippingCost: boolean;
        };
        /** @description The request to update the name. */
        "NatchOS.Plankton.Controllers.Api.BasketController+UpdateNameRequest": {
            /** @description The new name of the basket. */
            name: string;
        };
        /** @description The request to update the status. */
        "NatchOS.Plankton.Controllers.Api.BasketController+UpdateStatusRequest": {
            /**
             * @description Defines every possible status of a basket.
             *     This can be used in the implementation to validate the flow through the checkout process.
             *     Can also be used for a basket that needs approval by a person with more privileges.
             *     Not all steps are required in an implementation.
             *
             *     0 = NotSet (Status has not been set explicitly.)
             *
             *     10 = Created (Basket has been created but lines have not been added yet.)
             *
             *     20 = InProgress (Lines are added to the basket. Checkout process has not started yet. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.Created status.)
             *
             *     30 = CheckoutContent (First step of the checkout process, where the user can change the contents of the basket. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.InProgress status.)
             *
             *     40 = CheckoutDetails (Second step of the checkout process, where the user can select transfer options of enter some details regarding the order. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutContent status.)
             *
             *     50 = CheckoutReview (Third step of the checkout process, where the user reviews the final state of the basket without changing anything. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutDetails status.)
             *
             *     60 = CheckoutPayment (Basket is in the payment step of the basket flow. Changes to the content of the basket should not be made. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutPayment status. If payment fails or is cancelled the status should go back to a previous step, i.e. NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutContent. If payment succeeds the status proceed to NatchOS.Plankton.ImplementationModels.BasketStatus.Closed and basket should be sent.)
             *
             *     70 = Pending (Basket is in a temporary state that requires some sort of approval or confirmation before it can proceed. Example of approval: current user can not submit the basket, but someone with more rights needs to do this. Example of confirmation: basket is sent to an external system where contents are validated before the basket can reach the NatchOS.Plankton.ImplementationModels.BasketStatus.Closed status.)
             *
             *     75 = BeingReviewed (Basket is being reviewed by a user having the rights to submit the basket.)
             *
             *     80 = Approved (Basket have been approved, either manually or automatically. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.Pending or NatchOS.Plankton.ImplementationModels.BasketStatus.BeingReviewed status. Next logical step would be to proceed to status NatchOS.Plankton.ImplementationModels.BasketStatus.Closed.)
             *
             *     99 = Closed (Basket is ready to be sent via standard `NatchOS API` or custom code.)
             */
            status: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketStatus"];
        };
        /**
         * @description Request model for updating a customer.
         *     Passing null will not update the value.
         *     Passing empty strings will clear the value.
         */
        "NatchOS.Plankton.Controllers.Api.CustomerController+CustomerUpdateRequest": {
            /**
             * Format: int32
             * @description The language (as lcid or predefined CultureInfo identifier) of the customer.
             */
            lcid: number;
            /** Format: int32 */
            departmentId: number;
            /** @description The primary name of the customer. */
            name?: string | null;
            /** @description The secondary name of the customer. */
            name2?: string | null;
            /** @description The email address of the customer. */
            emailAddress?: string | null;
            /** @description The VAT number of the customer. */
            vatNumber?: string | null;
            /** @description The phone number of the customer. */
            phoneNumber?: string | null;
            /** @description The mobile phone number of the customer. */
            phoneNumberMobile?: string | null;
            /** @description The first line of the customer's address. */
            addressLine1?: string | null;
            /** @description The second line of the customer's address. */
            addressLine2?: string | null;
            /** @description The postal code of the customer's address. */
            addressPostalCode?: string | null;
            /** @description The city of the customer's address. */
            addressCity?: string | null;
            /** @description The country code of the customer's address. */
            addressCountryCode?: string | null;
        };
        /** @description The data for a DeepDive event */
        "NatchOS.Plankton.Controllers.Api.DeepDiveController+DeepDiveEventData": {
            /**
             * Format: int32
             * @description The identifier of the product.
             */
            productId: number;
            /** @description The JSON that contains extra data. */
            miscJson?: string | null;
        };
        /** @description Represents a request to mark a queue item as failed. */
        "NatchOS.Plankton.Controllers.Api.ExportQueueController+MarkFailedRequest": {
            /**
             * Format: int64
             * @description The identifier of the queue item to mark as failed.
             */
            id: number;
            /**
             * Format: int32
             * @description The type of export.
             */
            exportTypeId: number;
            /** @description The reason for the failure. Will automatically be truncated to fit 1000 characters. */
            failureText?: string | null;
        };
        /** @description Represents a request to mark a queue item as processed. */
        "NatchOS.Plankton.Controllers.Api.ExportQueueController+MarkProcessedRequest": {
            /**
             * Format: int64
             * @description The identifier of the queue item to mark as processed.
             */
            id: number;
            /**
             * Format: int32
             * @description The type of export.
             */
            exportTypeId: number;
        };
        /**
         * @description Request to resolve a message configuration.
         *     The required fields are determined by the configuration in the database.
         */
        "NatchOS.Plankton.Controllers.Api.MessageConfigurationController+EmailMessageContextRequest": {
            /**
             * Format: int32
             * @description The language identifier.
             */
            lcid?: number | null;
            /**
             * Format: int32
             * @description The person identifier.
             *     If empty can be automatically resolved from the current user.
             */
            personId?: number | null;
            /**
             * Format: int32
             * @description The customer identifier.
             *     If empty can be automatically resolved from the current user.
             */
            customerId?: number | null;
            /**
             * Format: int32
             * @description The shipping address identifier.
             */
            shippingAddressId?: number | null;
            /**
             * Format: int32
             * @description The department identifier.
             */
            pickupDepartmentId?: number | null;
            /** @description An address specific to the current context. */
            address?: string | null;
        };
        /** @description Request to get a list of persons. */
        "NatchOS.Plankton.Controllers.Api.PersonController+PersonSearchRequest": {
            /** @description The customer id list. */
            customerIdList?: number[] | null;
        };
        /**
         * @description Request model for updating a shipping address.
         *     Passing null will not update the value.
         *     Passing empty strings will clear the value.
         */
        "NatchOS.Plankton.Controllers.Api.ShippingAddressController+ShippingAddressUpdateRequest": {
            /**
             * Format: int32
             * @description The ID of the shipping address in the repository.
             *     Need this for new addresses where only the code exists (anonymous baskets).
             */
            customerId: number;
            /**
             * Format: int32
             * @description The language (as lcid or predefined CultureInfo identifier) of the shipping address.
             */
            lcid: number;
            /** @description The primary name of the shipping address. */
            name?: string | null;
            /** @description The secondary name of the shipping address. */
            name2?: string | null;
            /** @description The email address of the shipping address. */
            emailAddress?: string | null;
            /** @description The phone number of the shipping address. */
            phoneNumber?: string | null;
            /** @description The mobile phone number of the shipping address. */
            phoneNumberMobile?: string | null;
            /** @description The first line of the shipping address. */
            addressLine1?: string | null;
            /** @description The second line of the shipping address. */
            addressLine2?: string | null;
            /** @description The postal code of the shipping address. */
            addressPostalCode?: string | null;
            /** @description The city of the shipping address. */
            addressCity?: string | null;
            /** @description The country code of the shipping address. */
            addressCountryCode?: string | null;
        };
        /** @description Represents an item for account activation. */
        "NatchOS.Plankton.ImplementationModels.AccountActivationItem": {
            /**
             * Format: int32
             * @description The identifier of the person.
             */
            personId: number;
            /**
             * Format: int32
             * @description The identifier of the customer.
             */
            customerId: number;
            /** @description The store associated with the account activation. */
            store: components["schemas"]["NatchOS.Plankton.ImplementationModels.Store"];
            /** @description The person associated with the account activation. */
            person: components["schemas"]["NatchOS.Plankton.ImplementationModels.Person"];
            /** @description The customer associated with the account activation. */
            customer: components["schemas"]["NatchOS.Plankton.ImplementationModels.CustomerBase"];
            /** @description The web role associated with the account activation. */
            webRole: components["schemas"]["NatchOS.Plankton.ImplementationModels.WebRole"];
        };
        /**
         * Format: int32
         * @description Defines the different account activation statuses for a person with a login.
         *
         *     5 = MailQueued (Account activation mail must be sent. Triggered when a login is created or a contact becomes a login.)
         *
         *     10 = MailSent (Account activation mail is sent, but account has not been activated yet. Triggered when the activation mail is sent.)
         *
         *     15 = AccountActivated (Account activation completed. Triggered when the login has initially set his password.)
         *
         *     20 = MailFailed (Account activation mail could not be sent.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.AccountActivationStatus": NatchOSPlanktonImplementationModelsAccountActivationStatus;
        /**
         * @description Contains the minimum address fields.
         *     Base class for NatchOS.Domain.Ecommerce.BasketAddress and NatchOS.Domain.Ecommerce.DocumentAddress.
         *     Used in a person's NatchOS.Domain.Ecommerce.Person.Address and customer's NatchOS.Domain.Ecommerce.Customer.Address.
         */
        "NatchOS.Plankton.ImplementationModels.AddressLoose": {
            /** @description The primary address line. */
            addressLine1?: string | null;
            /** @description The secondary address line. */
            addressLine2?: string | null;
            /** @description The postal code. */
            postalCode?: string | null;
            /** @description The city. */
            city?: string | null;
            /**
             * Format: int32
             * @description The country id.
             */
            countryId?: number | null;
        };
        /**
         * @description Contains the minimum address fields.
         *     Base class for NatchOS.Domain.Ecommerce.BasketAddress and NatchOS.Domain.Ecommerce.DocumentAddress.
         *     Used in a person's NatchOS.Domain.Ecommerce.Person.Address and customer's NatchOS.Domain.Ecommerce.Customer.Address.
         */
        "NatchOS.Plankton.ImplementationModels.AddressStrict": {
            /** @description The primary address line. */
            addressLine1: string;
            /** @description The secondary address line. */
            addressLine2?: string | null;
            /** @description The postal code. */
            postalCode: string;
            /** @description The city. */
            city: string;
            /**
             * Format: int32
             * @description The country id.
             */
            countryId: number;
            /** @description The two-letter country code (ISO 3166-1 alpha-2). */
            countryCode: string;
        };
        /** @description Default implementation of basket. */
        "NatchOS.Plankton.ImplementationModels.Basket": {
            /** @description The shipping address to deliver the products to in case the transfer type is a delivery. */
            shippingAddress: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketAddress"];
            /**
             * @description The shipping advice as an enum.
             *     This defines how complete the quantities for the ordered products must be before fulfillment of the order (or partial orders).
             *
             *     0 = NotSet (Not set.)
             *
             *     1 = Partial (The order can be split up, ie. per product or even per smaller quantities of a single product.)
             *
             *     2 = CompleteOrderLines (The order can be split up, but every order line must be complete (quantity).)
             *
             *     3 = Complete (The order will be fulfilled once, when all products are available.)
             */
            shippingAdvice: components["schemas"]["NatchOS.Plankton.ImplementationModels.PredefinedShippingAdvice"];
            /**
             * Format: double
             * @description The gross shipping cost.
             */
            shippingCostGrossVatExcluded?: number | null;
            /**
             * Format: double
             * @description The net shipping cost.
             */
            shippingCostNetVatExcluded?: number | null;
            /** @description The transfer to fields. */
            transferTo: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketPerson"];
            /**
             * @description The transfer type as an enum.
             *     Transfer types is a fixed list for all implementations.
             *
             *     0 = NotSet (Not set.)
             *
             *     1 = Pickup (Buyer will pick up the order.)
             *
             *     2 = Delivery (Seller will ship the order to the buyer.)
             *
             *     3 = PickupNightLocker (Buyer will pick up the order from a night locker.)
             */
            transferType: components["schemas"]["NatchOS.Plankton.ImplementationModels.PredefinedTransferType"];
            /**
             * Format: int32
             * @description The technical key of the transfer subtype, fex. all possible pickup locations.
             */
            transferSubTypeId?: number | null;
            /**
             * Format: date-time
             * @description The optional date chosen by the shopper on which the products will be transferred. (picked up or delivered).
             */
            transferDate?: string | null;
            /** @description The reference of the shopper(person) for this basket. */
            reference?: string | null;
            /** @description The instruction by the shopper(person) concerning this basket. */
            instructions?: string | null;
            /** @description The info supplied by the shopper(person) for this basket. */
            info?: string | null;
            /** @description The miscellaneous JSON with extra data. */
            miscJson?: string | null;
            /**
             * Format: int32
             * @description The technical key of the basket header.
             *     It's recommended to use NatchOS.Plankton.ImplementationModels.BasketHeader.UniqueId instead for anything that is publicly visible, i.e. cookies and URLs.
             */
            id: number;
            /**
             * Format: uuid
             * @description The unique identifier of the basket header.
             *     Use this value instead of NatchOS.Plankton.ImplementationModels.BasketHeader.Id to defend against enumeration attacks, i.e. changing basket id in cookie or url.
             */
            uniqueId: string;
            /**
             * Format: int32
             * @description The store id the basket is attached to.
             */
            storeId: number;
            /**
             * @description The type of the basket.
             *
             *     1 = Normal (A regular basket.)
             *
             *     2 = Template (A template basket.)
             *
             *     3 = Blanket (A blanket basket.)
             *
             *     4 = Quote (A basket to request a quote for.)
             *
             *     5 = BasketFromAcceptedQuote (A basket from an approved quote.)
             *
             *     6 = BasketFromDeniedQuote (A basket from a denied quote.)
             *
             *     7 = NormalByInternal (A regular basket, but created by an internal person (ie. via impersonation).)
             *
             *     8 = ProductSelection (A selection of products defined by a person with enough rights, that can be linked to one or more persons. This can be used to group product together and limit the catalogue of a person to only selected products.)
             *
             *     9 = QuoteBasketForAnonymous (A basket for anonymous users with products meant for a quote request.)
             *
             *     10 = ToEProcurement (Much like a normal basket, but the basket is created during a PunchOut session (e.g. OCI or cXML). However, when proceeding through checkout, the basket will not be submitted like a normal basket. It will not be transmitted to the ERP system and therefore it will not directly generate an order in ERP. When checkout of this basket is finished, the basket is sent to the customer's e-procurement system that initiates the PunchOut session.)
             *
             *     11 = FromEProcurement (A basket of this type is created by a direct request from a customer's e-procurement system to the web shop, e.g. through a cXML OrderRequest. When such a request is received, the configured submit pipeline will typically be triggered to e.g. produce a web order in the ERP system and send a confirmation email.)
             */
            basketType: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketType"];
            /**
             * @description The status of the basket.
             *
             *     0 = NotSet (Status has not been set explicitly.)
             *
             *     10 = Created (Basket has been created but lines have not been added yet.)
             *
             *     20 = InProgress (Lines are added to the basket. Checkout process has not started yet. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.Created status.)
             *
             *     30 = CheckoutContent (First step of the checkout process, where the user can change the contents of the basket. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.InProgress status.)
             *
             *     40 = CheckoutDetails (Second step of the checkout process, where the user can select transfer options of enter some details regarding the order. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutContent status.)
             *
             *     50 = CheckoutReview (Third step of the checkout process, where the user reviews the final state of the basket without changing anything. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutDetails status.)
             *
             *     60 = CheckoutPayment (Basket is in the payment step of the basket flow. Changes to the content of the basket should not be made. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutPayment status. If payment fails or is cancelled the status should go back to a previous step, i.e. NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutContent. If payment succeeds the status proceed to NatchOS.Plankton.ImplementationModels.BasketStatus.Closed and basket should be sent.)
             *
             *     70 = Pending (Basket is in a temporary state that requires some sort of approval or confirmation before it can proceed. Example of approval: current user can not submit the basket, but someone with more rights needs to do this. Example of confirmation: basket is sent to an external system where contents are validated before the basket can reach the NatchOS.Plankton.ImplementationModels.BasketStatus.Closed status.)
             *
             *     75 = BeingReviewed (Basket is being reviewed by a user having the rights to submit the basket.)
             *
             *     80 = Approved (Basket have been approved, either manually or automatically. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.Pending or NatchOS.Plankton.ImplementationModels.BasketStatus.BeingReviewed status. Next logical step would be to proceed to status NatchOS.Plankton.ImplementationModels.BasketStatus.Closed.)
             *
             *     99 = Closed (Basket is ready to be sent via standard `NatchOS API` or custom code.)
             */
            basketStatus: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketStatus"];
            /**
             * Format: int32
             * @description The technical key of the customer the basket is attached to.
             *     A basket is always linked to a customer.
             *     Value may be set when NatchOS.Plankton.ImplementationModels.BasketHeader.PersonId is set.
             *     Value must be set when NatchOS.Plankton.ImplementationModels.BasketHeader.AttachedToCustomId is set.
             */
            customerId: number;
            /**
             * Format: int32
             * @description The technical key of the person the basket is attached to.
             *     A basket can be linked to a person or a custom entity (NatchOS.Plankton.ImplementationModels.BasketHeader.AttachedToCustomId).
             *     Value for NatchOS.Plankton.ImplementationModels.BasketHeader.CustomerId may be set when basket is attached to a person.
             */
            personId?: number | null;
            /**
             * Format: int32
             * @description The optional technical key a custom entity the basket is attached to.
             *     This is implementation specific.
             *     A basket can be linked to a custom entity or a person (NatchOS.Plankton.ImplementationModels.BasketHeader.PersonId).
             *     Value for NatchOS.Plankton.ImplementationModels.BasketHeader.CustomerId must be set when basket is attached to custom entity.
             */
            attachedToCustomId?: number | null;
            /**
             * @description The name of the basket.
             *     Can be used for basket templates.
             *     The name must be unique for a person.
             */
            basketName?: string | null;
            /** @description The information of the online payment. */
            paymentInformation: components["schemas"]["NatchOS.Plankton.ImplementationModels.PaymentInformation"];
            /**
             * Format: date-time
             * @description The creation time of the basket header.
             */
            creationTimeUtc: string;
            /**
             * @description The statistics for the basket.
             *     If you don't need the complete basket, you can load the statistics separately for better performance.
             */
            statistics: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketStatistics"];
            /** @description The basket line product list. */
            basketLineProducts: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketLineProduct"][];
            /** @description A value indicating whether this basket is an anonymous basket. */
            isAnonymousBasket: boolean;
            /**
             * @description A flag indicating if the shipping address is the same as the invoice address.
             *     Should only be used for anonymous baskets.
             */
            isShippingAddressSameAsInvoiceAddress: boolean;
            /**
             * Format: int32
             * @description The person id of the impersonator that submitted the basket.
             *     Only set if the basket was submitted under impersonation.
             */
            submittedByImpersonatorPersonId?: number | null;
            /**
             * Format: double
             * @description The total gross amount of the product lines, (later: total gross amount of the product surcharge lines) and gross shipping cost.
             *     Sum of the lines and shipping cost.
             */
            readonly totalGrossVatExcluded: number;
            /**
             * Format: double
             * @description The total net amount of the product lines, (later: total net amount of the product surcharge lines) and net shipping cost.
             *     Sum of the lines and shipping cost.
             */
            readonly totalNetVatExcluded: number;
            /**
             * Format: double
             * @description The total VAT amount of the basket.
             *     Sum of the lines.
             */
            readonly totalVatAmount: number;
        };
        /** @description Extends the `Address` with extra fields required for the shipping address of a basket. */
        "NatchOS.Plankton.ImplementationModels.BasketAddress": {
            /** @description The primary address line. */
            addressLine1?: string | null;
            /** @description The secondary address line. */
            addressLine2?: string | null;
            /** @description The postal code. */
            postalCode?: string | null;
            /** @description The city. */
            city?: string | null;
            /**
             * Format: int32
             * @description The country id.
             */
            countryId?: number | null;
            /**
             * Format: int32
             * @description The optional ID of the address.
             */
            id?: number | null;
            /** @description The name for the address. */
            name?: string | null;
            /** @description The secondary name for the address. */
            name2?: string | null;
            /**
             * Format: int32
             * @description The culture identifier.
             */
            lcid?: number | null;
            /**
             * @description The two-letter country code (ISO 3166-1 alpha-2).
             *     Used for display. To set the country, use NatchOS.Plankton.ImplementationModels.AddressLoose.CountryId instead.
             */
            countryCode?: string | null;
        };
        /** @description Default implementation of basket header. */
        "NatchOS.Plankton.ImplementationModels.BasketHeader": {
            /** @description The shipping address to deliver the products to in case the transfer type is a delivery. */
            shippingAddress: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketAddress"];
            /**
             * @description The shipping advice as an enum.
             *     This defines how complete the quantities for the ordered products must be before fulfillment of the order (or partial orders).
             *
             *     0 = NotSet (Not set.)
             *
             *     1 = Partial (The order can be split up, ie. per product or even per smaller quantities of a single product.)
             *
             *     2 = CompleteOrderLines (The order can be split up, but every order line must be complete (quantity).)
             *
             *     3 = Complete (The order will be fulfilled once, when all products are available.)
             */
            shippingAdvice: components["schemas"]["NatchOS.Plankton.ImplementationModels.PredefinedShippingAdvice"];
            /**
             * Format: double
             * @description The gross shipping cost.
             */
            shippingCostGrossVatExcluded?: number | null;
            /**
             * Format: double
             * @description The net shipping cost.
             */
            shippingCostNetVatExcluded?: number | null;
            /** @description The transfer to fields. */
            transferTo: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketPerson"];
            /**
             * @description The transfer type as an enum.
             *     Transfer types is a fixed list for all implementations.
             *
             *     0 = NotSet (Not set.)
             *
             *     1 = Pickup (Buyer will pick up the order.)
             *
             *     2 = Delivery (Seller will ship the order to the buyer.)
             *
             *     3 = PickupNightLocker (Buyer will pick up the order from a night locker.)
             */
            transferType: components["schemas"]["NatchOS.Plankton.ImplementationModels.PredefinedTransferType"];
            /**
             * Format: int32
             * @description The technical key of the transfer subtype, fex. all possible pickup locations.
             */
            transferSubTypeId?: number | null;
            /**
             * Format: date-time
             * @description The optional date chosen by the shopper on which the products will be transferred. (picked up or delivered).
             */
            transferDate?: string | null;
            /** @description The reference of the shopper(person) for this basket. */
            reference?: string | null;
            /** @description The instruction by the shopper(person) concerning this basket. */
            instructions?: string | null;
            /** @description The info supplied by the shopper(person) for this basket. */
            info?: string | null;
            /** @description The miscellaneous JSON with extra data. */
            miscJson?: string | null;
            /**
             * Format: int32
             * @description The technical key of the basket header.
             *     It's recommended to use NatchOS.Plankton.ImplementationModels.BasketHeader.UniqueId instead for anything that is publicly visible, i.e. cookies and URLs.
             */
            id: number;
            /**
             * Format: uuid
             * @description The unique identifier of the basket header.
             *     Use this value instead of NatchOS.Plankton.ImplementationModels.BasketHeader.Id to defend against enumeration attacks, i.e. changing basket id in cookie or url.
             */
            uniqueId: string;
            /**
             * Format: int32
             * @description The store id the basket is attached to.
             */
            storeId: number;
            /**
             * @description The type of the basket.
             *
             *     1 = Normal (A regular basket.)
             *
             *     2 = Template (A template basket.)
             *
             *     3 = Blanket (A blanket basket.)
             *
             *     4 = Quote (A basket to request a quote for.)
             *
             *     5 = BasketFromAcceptedQuote (A basket from an approved quote.)
             *
             *     6 = BasketFromDeniedQuote (A basket from a denied quote.)
             *
             *     7 = NormalByInternal (A regular basket, but created by an internal person (ie. via impersonation).)
             *
             *     8 = ProductSelection (A selection of products defined by a person with enough rights, that can be linked to one or more persons. This can be used to group product together and limit the catalogue of a person to only selected products.)
             *
             *     9 = QuoteBasketForAnonymous (A basket for anonymous users with products meant for a quote request.)
             *
             *     10 = ToEProcurement (Much like a normal basket, but the basket is created during a PunchOut session (e.g. OCI or cXML). However, when proceeding through checkout, the basket will not be submitted like a normal basket. It will not be transmitted to the ERP system and therefore it will not directly generate an order in ERP. When checkout of this basket is finished, the basket is sent to the customer's e-procurement system that initiates the PunchOut session.)
             *
             *     11 = FromEProcurement (A basket of this type is created by a direct request from a customer's e-procurement system to the web shop, e.g. through a cXML OrderRequest. When such a request is received, the configured submit pipeline will typically be triggered to e.g. produce a web order in the ERP system and send a confirmation email.)
             */
            basketType: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketType"];
            /**
             * @description The status of the basket.
             *
             *     0 = NotSet (Status has not been set explicitly.)
             *
             *     10 = Created (Basket has been created but lines have not been added yet.)
             *
             *     20 = InProgress (Lines are added to the basket. Checkout process has not started yet. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.Created status.)
             *
             *     30 = CheckoutContent (First step of the checkout process, where the user can change the contents of the basket. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.InProgress status.)
             *
             *     40 = CheckoutDetails (Second step of the checkout process, where the user can select transfer options of enter some details regarding the order. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutContent status.)
             *
             *     50 = CheckoutReview (Third step of the checkout process, where the user reviews the final state of the basket without changing anything. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutDetails status.)
             *
             *     60 = CheckoutPayment (Basket is in the payment step of the basket flow. Changes to the content of the basket should not be made. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutPayment status. If payment fails or is cancelled the status should go back to a previous step, i.e. NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutContent. If payment succeeds the status proceed to NatchOS.Plankton.ImplementationModels.BasketStatus.Closed and basket should be sent.)
             *
             *     70 = Pending (Basket is in a temporary state that requires some sort of approval or confirmation before it can proceed. Example of approval: current user can not submit the basket, but someone with more rights needs to do this. Example of confirmation: basket is sent to an external system where contents are validated before the basket can reach the NatchOS.Plankton.ImplementationModels.BasketStatus.Closed status.)
             *
             *     75 = BeingReviewed (Basket is being reviewed by a user having the rights to submit the basket.)
             *
             *     80 = Approved (Basket have been approved, either manually or automatically. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.Pending or NatchOS.Plankton.ImplementationModels.BasketStatus.BeingReviewed status. Next logical step would be to proceed to status NatchOS.Plankton.ImplementationModels.BasketStatus.Closed.)
             *
             *     99 = Closed (Basket is ready to be sent via standard `NatchOS API` or custom code.)
             */
            basketStatus: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketStatus"];
            /**
             * Format: int32
             * @description The technical key of the customer the basket is attached to.
             *     A basket is always linked to a customer.
             *     Value may be set when NatchOS.Plankton.ImplementationModels.BasketHeader.PersonId is set.
             *     Value must be set when NatchOS.Plankton.ImplementationModels.BasketHeader.AttachedToCustomId is set.
             */
            customerId: number;
            /**
             * Format: int32
             * @description The technical key of the person the basket is attached to.
             *     A basket can be linked to a person or a custom entity (NatchOS.Plankton.ImplementationModels.BasketHeader.AttachedToCustomId).
             *     Value for NatchOS.Plankton.ImplementationModels.BasketHeader.CustomerId may be set when basket is attached to a person.
             */
            personId?: number | null;
            /**
             * Format: int32
             * @description The optional technical key a custom entity the basket is attached to.
             *     This is implementation specific.
             *     A basket can be linked to a custom entity or a person (NatchOS.Plankton.ImplementationModels.BasketHeader.PersonId).
             *     Value for NatchOS.Plankton.ImplementationModels.BasketHeader.CustomerId must be set when basket is attached to custom entity.
             */
            attachedToCustomId?: number | null;
            /**
             * @description The name of the basket.
             *     Can be used for basket templates.
             *     The name must be unique for a person.
             */
            basketName?: string | null;
            /** @description The information of the online payment. */
            paymentInformation: components["schemas"]["NatchOS.Plankton.ImplementationModels.PaymentInformation"];
            /**
             * Format: date-time
             * @description The creation time of the basket header.
             */
            creationTimeUtc: string;
            /**
             * @description The statistics for the basket.
             *     If you don't need the complete basket, you can load the statistics separately for better performance.
             */
            statistics: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketStatistics"];
        };
        /**
         * @description Default implementation of basket line product.
         *     Basket line type that can only contain product values.
         */
        "NatchOS.Plankton.ImplementationModels.BasketLineProduct": {
            /**
             * Format: int32
             * @description The technical key to identify a basket line.
             */
            readonly basketLineId: number;
            /**
             * Format: uuid
             * @description Gets or sets GUID which is used by the application (website) to identify this basket line.
             */
            basketLineGuid: string;
            /**
             * Format: uuid
             * @description The GUID used to group basket lines together, i.e attach comment line to product line.
             *     All basket lines with the same NatchOS.Plankton.ImplementationModels.BasketLine.BasketLineGroupGuid must be removed as a unit.
             */
            basketLineGroupGuid: string;
            /** @description A value indicating whether line must be excluded from the order when exporting the basket. */
            excludeFromWebOrderExport: boolean;
            /** @description The optional comment value. */
            comment?: string | null;
            /** @description The miscellaneous JSON with extra data. */
            miscJson?: string | null;
            /**
             * Format: int32
             * @description The technical key to identify a product.
             */
            productId: number;
            /**
             * Format: double
             * @description The quantity of products.
             */
            quantity: number;
            /**
             * Format: double
             * @description The gross sales price, without VAT, without discounts, for a single unit.
             */
            grossSalesPriceVatExcluded: number;
            /**
             * Format: double
             * @description The net sales price, without VAT, including discounts, for a single unit.
             *     The actual price the customer pays.
             */
            netSalesPriceVatExcluded: number;
            /**
             * Format: double
             * @description The total gross price, without VAT, without discounts for the basket line.
             *     This is NatchOS.Plankton.ImplementationModels.BasketLineProduct.GrossSalesPriceVatExcluded multiplied by NatchOS.Plankton.ImplementationModels.BasketLineProduct.Quantity.
             */
            readonly grossTotalLineAmountVatExcluded: number;
            /**
             * Format: double
             * @description The total net price, without VAT, including discounts, for the basket line.
             *     This is NatchOS.Plankton.ImplementationModels.BasketLineProduct.NetSalesPriceVatExcluded multiplied by NatchOS.Plankton.ImplementationModels.BasketLineProduct.Quantity.
             */
            readonly netTotalLineAmountVatExcluded: number;
            /**
             * @description The type of basket line: NatchOS.Plankton.ImplementationModels.Product.
             *
             *     1 = Product (A NatchOS.Plankton.ImplementationModels.BasketLineType.Product added to the basket.)
             *
             *     2 = Comment (A comment line (text) added to the basket. NOT IMPLEMENTED YET IN PLANKTON.)
             *
             *     3 = Voucher (A NatchOS.Plankton.ImplementationModels.BasketLineType.Voucher added to the basket. NOT IMPLEMENTED YET IN PLANKTON.)
             *
             *     4 = ProductSurcharge (Defines a surcharge for a line of type NatchOS.Plankton.ImplementationModels.BasketLineType.Product. Multiple surcharges can be added to a single product. NOT IMPLEMENTED YET IN PLANKTON.)
             *
             *     5 = CustomProduct (A custom product added to the basket. NOT IMPLEMENTED YET IN PLANKTON.)
             */
            readonly basketLineType: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketLineType"];
            /**
             * @description The ID of the list from which the product was added to the basket.
             *     Will be used to send to Google Tag Manager.
             */
            attributionListItemId?: string | null;
            /**
             * @description The name of the list from which the product was added to the basket.
             *     Will be used to send to Google Tag Manager.
             */
            attributionListItemName?: string | null;
            /**
             * Format: double
             * @description The VAT amount for a single unit.
             */
            unitVatAmount?: number | null;
            /**
             * Format: double
             * @description The VAT amount for the line.
             */
            readonly totalVatAmount?: number | null;
            /**
             * Format: double
             * @description The VAT percentage for the basket line.
             *     e.g. 21.00 for 21%.
             */
            vatPercentage?: number | null;
        };
        /**
         * Format: int32
         * @description Defines the basket line types.
         *
         *     1 = Product (A NatchOS.Plankton.ImplementationModels.BasketLineType.Product added to the basket.)
         *
         *     2 = Comment (A comment line (text) added to the basket. NOT IMPLEMENTED YET IN PLANKTON.)
         *
         *     3 = Voucher (A NatchOS.Plankton.ImplementationModels.BasketLineType.Voucher added to the basket. NOT IMPLEMENTED YET IN PLANKTON.)
         *
         *     4 = ProductSurcharge (Defines a surcharge for a line of type NatchOS.Plankton.ImplementationModels.BasketLineType.Product. Multiple surcharges can be added to a single product. NOT IMPLEMENTED YET IN PLANKTON.)
         *
         *     5 = CustomProduct (A custom product added to the basket. NOT IMPLEMENTED YET IN PLANKTON.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.BasketLineType": NatchOSPlanktonImplementationModelsBasketLineType;
        /** @description Represents the person that is to receive the goods. */
        "NatchOS.Plankton.ImplementationModels.BasketPerson": {
            /**
             * Format: int32
             * @description The technical key to identify the person who will receive the products by pickup or delivery.
             */
            personId?: number | null;
            /** @description The first name. */
            firstName?: string | null;
            /** @description The middle name. */
            middleName?: string | null;
            /**
             * @description The last name.
             *     Required field.
             */
            lastName?: string | null;
            /**
             * @description The email address.
             *     Required field.
             */
            emailAddress?: string | null;
            /**
             * Format: int32
             * @description The language (as lcid or predefined CultureInfo identifier) of the customer.
             */
            lcid: number;
            /** @description The regular phone number. */
            phoneNumber?: string | null;
            /** @description The mobile phone number. */
            phoneNumberMobile?: string | null;
        };
        /**
         * @description Statistics (times and counts) for NatchOS.Plankton.ImplementationModels.Basket.
         *     Can be loaded separately for improved performance.
         */
        "NatchOS.Plankton.ImplementationModels.BasketStatistics": {
            /**
             * Format: int32
             * @description The technical key of the basket header.
             */
            basketId: number;
            /**
             * Format: double
             * @description The total gross amount of all the basket lines at the time of loading from the data store.
             *     Amount is calculated in the data store and must not be set at implementation.
             *     Shipping cost is excluded from this price.
             */
            totalGrossVatExcluded: number;
            /**
             * Format: double
             * @description The total net amount of all the basket lines at the time of loading from the data store.
             *     Amount is calculated in the data store and must not be set at implementation.
             *     Shipping cost is excluded from this price.
             */
            totalNetVatExcluded: number;
            /**
             * Format: date-time
             * @description The time when the basket header or any of the basket lines was last updated.
             */
            lastBasketModificationTimeUtc?: string | null;
            /**
             * Format: date-time
             * @description The time when the last 'abandoned basket' notification was sent.
             */
            lastAbandonedBasketNotificationSentTimeUtc?: string | null;
            /**
             * Format: int32
             * @description The number of times the 'abandoned basket' notification was sent.
             */
            abandonedBasketNotificationsSentCount?: number | null;
            /**
             * Format: int32
             * @description The number of basket lines of the type NatchOS.Plankton.ImplementationModels.BasketLineType.Product.
             */
            productLineCount: number;
            /**
             * Format: int32
             * @description The number of basket lines of the type NatchOS.Plankton.ImplementationModels.BasketLineType.CustomProduct.
             */
            customProductLineCount: number;
            /**
             * Format: double
             * @description The sum of the quantities of basket lines of the type NatchOS.Plankton.ImplementationModels.BasketLineType.Product.
             */
            productQuantity: number;
            /**
             * Format: double
             * @description The sum of the quantities of basket lines of the type NatchOS.Plankton.ImplementationModels.BasketLineType.CustomProduct.
             */
            customProductQuantity: number;
            /**
             * Format: int32
             * @description The number of lines of the types NatchOS.Plankton.ImplementationModels.BasketLineType.Product and NatchOS.Plankton.ImplementationModels.BasketLineType.CustomProduct.
             *     This is the sum of NatchOS.Plankton.ImplementationModels.BasketStatistics.ProductLineCount and NatchOS.Plankton.ImplementationModels.BasketStatistics.CustomProductLineCount.
             */
            readonly totalProductLineCount: number;
            /**
             * Format: double
             * @description The quantities of lines of the types NatchOS.Plankton.ImplementationModels.BasketLineType.Product and NatchOS.Plankton.ImplementationModels.BasketLineType.CustomProduct.
             *     This is the sum of NatchOS.Plankton.ImplementationModels.BasketStatistics.ProductQuantity and NatchOS.Plankton.ImplementationModels.BasketStatistics.CustomProductQuantity.
             */
            readonly totalProductQuantity: number;
        };
        /**
         * Format: int32
         * @description Defines every possible status of a basket.
         *     This can be used in the implementation to validate the flow through the checkout process.
         *     Can also be used for a basket that needs approval by a person with more privileges.
         *     Not all steps are required in an implementation.
         *
         *     0 = NotSet (Status has not been set explicitly.)
         *
         *     10 = Created (Basket has been created but lines have not been added yet.)
         *
         *     20 = InProgress (Lines are added to the basket. Checkout process has not started yet. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.Created status.)
         *
         *     30 = CheckoutContent (First step of the checkout process, where the user can change the contents of the basket. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.InProgress status.)
         *
         *     40 = CheckoutDetails (Second step of the checkout process, where the user can select transfer options of enter some details regarding the order. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutContent status.)
         *
         *     50 = CheckoutReview (Third step of the checkout process, where the user reviews the final state of the basket without changing anything. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutDetails status.)
         *
         *     60 = CheckoutPayment (Basket is in the payment step of the basket flow. Changes to the content of the basket should not be made. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutPayment status. If payment fails or is cancelled the status should go back to a previous step, i.e. NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutContent. If payment succeeds the status proceed to NatchOS.Plankton.ImplementationModels.BasketStatus.Closed and basket should be sent.)
         *
         *     70 = Pending (Basket is in a temporary state that requires some sort of approval or confirmation before it can proceed. Example of approval: current user can not submit the basket, but someone with more rights needs to do this. Example of confirmation: basket is sent to an external system where contents are validated before the basket can reach the NatchOS.Plankton.ImplementationModels.BasketStatus.Closed status.)
         *
         *     75 = BeingReviewed (Basket is being reviewed by a user having the rights to submit the basket.)
         *
         *     80 = Approved (Basket have been approved, either manually or automatically. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.Pending or NatchOS.Plankton.ImplementationModels.BasketStatus.BeingReviewed status. Next logical step would be to proceed to status NatchOS.Plankton.ImplementationModels.BasketStatus.Closed.)
         *
         *     99 = Closed (Basket is ready to be sent via standard `NatchOS API` or custom code.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.BasketStatus": NatchOSPlanktonImplementationModelsBasketStatus;
        /**
         * Format: int32
         * @description Identifies the different types of baskets.
         *
         *     1 = Normal (A regular basket.)
         *
         *     2 = Template (A template basket.)
         *
         *     3 = Blanket (A blanket basket.)
         *
         *     4 = Quote (A basket to request a quote for.)
         *
         *     5 = BasketFromAcceptedQuote (A basket from an approved quote.)
         *
         *     6 = BasketFromDeniedQuote (A basket from a denied quote.)
         *
         *     7 = NormalByInternal (A regular basket, but created by an internal person (ie. via impersonation).)
         *
         *     8 = ProductSelection (A selection of products defined by a person with enough rights, that can be linked to one or more persons. This can be used to group product together and limit the catalogue of a person to only selected products.)
         *
         *     9 = QuoteBasketForAnonymous (A basket for anonymous users with products meant for a quote request.)
         *
         *     10 = ToEProcurement (Much like a normal basket, but the basket is created during a PunchOut session (e.g. OCI or cXML). However, when proceeding through checkout, the basket will not be submitted like a normal basket. It will not be transmitted to the ERP system and therefore it will not directly generate an order in ERP. When checkout of this basket is finished, the basket is sent to the customer's e-procurement system that initiates the PunchOut session.)
         *
         *     11 = FromEProcurement (A basket of this type is created by a direct request from a customer's e-procurement system to the web shop, e.g. through a cXML OrderRequest. When such a request is received, the configured submit pipeline will typically be triggered to e.g. produce a web order in the ERP system and send a confirmation email.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.BasketType": NatchOSPlanktonImplementationModelsBasketType;
        /** @description A structure where products are organized. */
        "NatchOS.Plankton.ImplementationModels.Category": {
            /**
             * Format: int32
             * @description The ID of the category in the repository.
             */
            id: number;
            /**
             * Format: int32
             * @description The root category id.
             *     This is the system category created during development.
             */
            rootId: number;
            /**
             * Format: int32
             * @description The parent category id.
             *     This is the same a NatchOS.Plankton.ImplementationModels.Category.RootId of NatchOS.Plankton.ImplementationModels.Category.Level is 1.
             */
            parentId: number;
            /**
             * Format: int32
             * @description The optional store id the category is attached to.
             *     This is only set for categories at level 1.
             *     Only available in multi-store implementations.
             */
            storeId?: number | null;
            /**
             * @description The category code.
             *     May only be used to communicate with master data.
             *     Don't use this value in front-end.
             */
            code: string;
            /** @description The internal name. */
            internalName: string;
            /** @description The internal description. */
            internalDescription?: string | null;
            /** @description A value indicating whether this NatchOS.Plankton.ImplementationModels.Category is online. */
            isOnline: boolean;
            /**
             * Format: int32
             * @description The node level.
             *     Root categories are level 1.
             */
            level: number;
            /** @description The translations, indexed by two-letter language code. */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.CategoryTranslation"];
            };
            /**
             * @description The external data (data from other systems than the master) attached to the category.
             *     Extension methods are available in NatchOS.BL.ExtensionMethods.ExternalDataExtensions.
             */
            readonly externalData: components["schemas"]["NatchOS.Plankton.ImplementationModels.ExternalData"][];
            /** @description The properties attached to the category. */
            readonly properties: components["schemas"]["NatchOS.Plankton.ImplementationModels.CategoryProperty"][];
            /**
             * Format: int32
             * @description The sequence number of the NatchOS.Plankton.ImplementationModels.Category within the parent.
             *     Use this to re-sort categories in the order they were returned from the data store.
             */
            sequenceNumber: number;
        };
        /** @description Defines the properties of a NatchOS.Plankton.ImplementationModels.Category. */
        "NatchOS.Plankton.ImplementationModels.CategoryProperty": {
            /**
             * Format: int32
             * @description The property identifier.
             */
            propertyId: number;
            /** @description A value indicating whether this property must be shown with the product information. */
            showAsProductSpecification: boolean;
            /** @description A value indicating whether this property can be used as a filter for products. */
            useAsFilter: boolean;
            /**
             * Format: int32
             * @description The value used for sorting.
             */
            sortOrderValue: number;
            /** @description A miscellaneous value which can be parsed before usage. */
            miscellaneous?: string | null;
        };
        /** @description Defines the translation of a NatchOS.Plankton.ImplementationModels.Category. */
        "NatchOS.Plankton.ImplementationModels.CategoryTranslation": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The name. */
            name: string;
            /** @description The description. */
            description?: string | null;
            /** @description The miscellaneous XML with extra data. */
            miscXml?: string | null;
        };
        /** @description Combination of an integer and a string that both represent a unique identifier to and ecommerce entity. */
        "NatchOS.Plankton.ImplementationModels.CodeIdCombination": {
            /**
             * Format: int32
             * @description The numerical id that represents the technical (internal) key in the data store.
             */
            id: number;
            /** @description The code that represents the external key from the supplied data. */
            code: string;
        };
        /** @description Represents a country with various properties such as ISO codes, VAT groups, and translations. */
        "NatchOS.Plankton.ImplementationModels.Country": {
            /**
             * Format: int32
             * @description The id of the country in the repository.
             */
            id: number;
            /**
             * @description The two-letter country code (ISO 3166-1 alpha-2).
             * @example US for United States.
             */
            isoAlpha2: string;
            /** @description The VAT Business Posting Group for Business-to-Business (B2B) transactions. */
            vatBusinessPostingGroupB2B?: string | null;
            /** @description The VAT Business Posting Group for Business-to-Consumer (B2C) transactions. */
            vatBusinessPostingGroupB2C?: string | null;
            /** @description The internal name. */
            internalName: string;
            /** @description The translations, indexed by two-letter language code. */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.CountryTranslation"];
            };
            /** @description Gets a list of store ids for which the country is online. */
            readonly storeIdList: number[];
        };
        /** @description Defines the translation of a country. */
        "NatchOS.Plankton.ImplementationModels.CountryTranslation": {
            /** Format: int32 */
            lcid: number;
            /** @description The name. */
            name: string;
        };
        /** @description Default implementation of customer. */
        "NatchOS.Plankton.ImplementationModels.Customer": {
            /**
             * Format: int32
             * @description The id of the customer in the repository.
             */
            id: number;
            /**
             * @description The code of the customer from the master data.
             *     May only be used to communicate with master data.
             *     Don't use this value in front-end.
             */
            code: string;
            /** @description The name. */
            name: string;
            /** @description The address. */
            address: components["schemas"]["NatchOS.Plankton.ImplementationModels.AddressStrict"];
            /** @description A value indicating whether the customer is internal. */
            readonly isCustomerTypeInternal: boolean;
            /** @description The miscellaneous JSON with extra data. */
            miscJson?: string | null;
            /** @description The secondary name. */
            name2?: string | null;
            /** @description The email address. */
            emailAddress?: string | null;
            /** @description The regular phone number. */
            phoneNumber?: string | null;
            /** @description The mobile phone number. */
            phoneNumberMobile?: string | null;
            /** @description The salespeople attached to the customer. */
            salespeople: components["schemas"]["NatchOS.Plankton.ImplementationModels.CustomerSalesperson"][];
            /**
             * @description The sales data.
             *     Will contain null reference if there is no data in the data store.
             */
            salesInfo?: components["schemas"]["NatchOS.Plankton.ImplementationModels.CustomerSalesInfo"] | null;
            /**
             * Format: int32
             * @description The type of the customer, which is internal or external.
             *     Use an enum in the implementation.
             *     Alternatively, you can load a list of customer types from the data store.
             */
            customerType: number;
            /**
             * Format: int32
             * @description The sector id.
             */
            sectorId?: number | null;
            /** @description The external data attached to the customer. */
            externalData: components["schemas"]["NatchOS.Plankton.ImplementationModels.ExternalData"][];
        };
        /** @description Base class for customer data. */
        "NatchOS.Plankton.ImplementationModels.CustomerBase": {
            /**
             * Format: int32
             * @description The id of the customer in the repository.
             */
            id: number;
            /**
             * @description The code of the customer from the master data.
             *     May only be used to communicate with master data.
             *     Don't use this value in front-end.
             */
            code: string;
            /** @description The name. */
            name: string;
            /** @description The address. */
            address: components["schemas"]["NatchOS.Plankton.ImplementationModels.AddressStrict"];
            /** @description A value indicating whether the customer is internal. */
            readonly isCustomerTypeInternal: boolean;
            /** @description The miscellaneous JSON with extra data. */
            miscJson?: string | null;
        };
        /** @description Contains settings and references to attached entity for the NatchOS.Plankton.ImplementationModels.Customer. */
        "NatchOS.Plankton.ImplementationModels.CustomerSalesInfo": {
            /**
             * Format: int32
             * @description The customer price group id.
             *     Can be used to get product prices by price group.
             */
            customerPriceGroupId?: number | null;
            /**
             * Format: int32
             * @description The payment terms id.
             */
            paymentTermsId?: number | null;
            /**
             * Format: int32
             * @description The currency id.
             *     A list of currencies can be load via the common list service class.
             */
            currencyId?: number | null;
            /**
             * Format: int32
             * @description The customer id to bill the orders to.
             */
            billToCustomerId?: number | null;
            /**
             * Format: int32
             * @description The payment method id.
             *     A list of currencies can be load via the common list service class.
             */
            paymentMethodId?: number | null;
            /**
             * Format: int32
             * @description The technical key of the department the customer is attached to.
             */
            departmentId: number;
            /** @description A value indicating whether a value added tax identification number has been requested with a european government. */
            vatNumberRequested: boolean;
            /** @description The value added tax identification number of the customer. */
            vatNumber?: string | null;
            /**
             * Format: int32
             * @description The vat regime id.
             *     Full support for this will be implemented in a later version.
             *     For now use an enum in the implementation.
             */
            vatRegimeId?: number | null;
        };
        /**
         * @description A customer can have salespeople attached to his account.
         *     This class identifies the person and some options.
         */
        "NatchOS.Plankton.ImplementationModels.CustomerSalesperson": {
            /**
             * Format: int32
             * @description The id of the salesperson.
             */
            personId: number;
            /**
             * Format: int32
             * @description The identifier of the store this salesperson is attached to.
             */
            storeId: number;
            /** @description A value indicating whether this salesperson is an internal sales or a field sales. */
            isInternalSales: boolean;
            /**
             * @description A value indicating whether this is the main salesperson.
             *     A customer can have multiple main salespersons.
             */
            isMainSalesperson: boolean;
        };
        /**
         * @description Defines a department of the company/store.
         *     Used in document, document line, shipping address, warehouse, ...
         */
        "NatchOS.Plankton.ImplementationModels.Department": {
            /**
             * Format: int32
             * @description The id.
             */
            id: number;
            /** @description The code of the department. */
            code: string;
            /** @description The internal name. */
            internalName: string;
            /** @description The translations, indexed by two-letter language code. */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.DepartmentTranslation"];
            };
            /**
             * Format: int32
             * @description The of store identifier the department is attached to.
             *     Only available in multi-store implementations.
             */
            storeId: number;
            /**
             * @description The address.
             *     This is optional.
             *     Always returns an instance.
             */
            address: components["schemas"]["NatchOS.Plankton.ImplementationModels.AddressLoose"];
            /** @description The email address of the department. */
            emailAddress?: string | null;
            /** @description The miscellaneous data in XML format. */
            miscXml?: string | null;
        };
        /** @description Defines the translation of a department. */
        "NatchOS.Plankton.ImplementationModels.DepartmentTranslation": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The name. */
            name: string;
            /** @description The description. */
            description?: string | null;
            /** @description The miscellaneous XML with extra data. */
            miscXml?: string | null;
        };
        /**
         * @description Default implementation of a document.
         *     Documents include invoices, quotes, invoices and shipping notes.
         *     This object contains the fields for all the types.
         */
        "NatchOS.Plankton.ImplementationModels.Document": {
            /**
             * Format: int32
             * @description The id of the document in the repository.
             */
            id: number;
            /**
             * Format: int32
             * @description The identifier of the store this document is attached to.
             */
            storeId: number;
            /**
             * @description The type of the document.
             *
             *     1 = Quote (A sales quote allows a prospective buyer to see what costs would be involved for the work they would like to have done.)
             *
             *     2 = Order (An agreement for specific products or services.)
             *
             *     3 = Shipment (A shipment document.)
             *
             *     4 = Invoice (An invoice for a completed order. Includes both positive and negative invoices, see NatchOS.Plankton.ImplementationModels.DocumentInvoiceType.)
             */
            documentType: components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentType"];
            /**
             * Format: double
             * @description The total amount excluding vat of the specific document type.
             */
            totalVatExcluded?: number | null;
            /**
             * Format: double
             * @description The total amount including vat of the specific document type.
             */
            totalVatIncluded?: number | null;
            /** @description A value indicating whether this quote, invoice, order or shipment is still in progress. */
            isOpen: boolean;
            /** @description The address of the customer to which the services or goods will be sold to. */
            customerAddress: components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentAddress"];
            /** @description The address of the customer to which the services or goods will be invoiced to. */
            invoiceAddress: components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentAddress"];
            /** @description The shipping address. */
            shippingAddress: components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentAddress"];
            /**
             * @description The lines attached to the document.
             *     This data will be loaded when `AddLines` is set to true.
             */
            readonly lines?: components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentLine"][] | null;
            /**
             * Format: double
             * @description The payment discount percentage.
             */
            paymentDiscountPercentage?: number | null;
            /**
             * Format: int32
             * @description The currency id.
             */
            currencyId?: number | null;
            /**
             * Format: double
             * @description The value to be used to convert (multiply) the amount to euro.
             */
            currencyFactor?: number | null;
            /** @description The value added tax identification number of the customer. */
            vatNumber?: string | null;
            /** @description The external reference. */
            externalReference?: string | null;
            /** @description The external comment. */
            externalComment?: string | null;
            /**
             * Format: date-time
             * @description The document date and time.
             */
            documentDateTime: string;
            /**
             * Format: int32
             * @description The id of status of the document.
             */
            documentStatusId?: number | null;
            /** @description The status of the document. */
            documentStatus?: components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentStatus"] | null;
            /**
             * Format: int32
             * @description The payment method id.
             */
            paymentMethodId?: number | null;
            /** @description The payment method. */
            paymentMethod?: components["schemas"]["NatchOS.Plankton.ImplementationModels.PaymentMethod"] | null;
            /**
             * Format: date-time
             * @description The requested delivery date.
             */
            requestedDeliveryDate?: string | null;
            /**
             * Format: date-time
             * @description The promised delivery date.
             */
            promisedDeliveryDate?: string | null;
            /**
             * Format: date-time
             * @description The order date and time.
             *     Required when NatchOS.Plankton.ImplementationModels.Document.DocumentType is NatchOS.Plankton.ImplementationModels.DocumentType.Order.
             */
            orderDateTime?: string | null;
            /**
             * Format: int32
             * @description The order type id.
             *     I.e. order, blanket order, return order, etc...
             *     Required when NatchOS.Plankton.ImplementationModels.Document.DocumentType is NatchOS.Plankton.ImplementationModels.DocumentType.Order.
             */
            orderTypeId?: number | null;
            /**
             * @description The order type.
             *     I.e. order, blanket order, return order, etc...
             *     Required when NatchOS.Plankton.ImplementationModels.Document.DocumentType is NatchOS.Plankton.ImplementationModels.DocumentType.Order.
             */
            orderType?: components["schemas"]["NatchOS.Plankton.ImplementationModels.OrderType"] | null;
            /**
             * @description The type of the invoice.
             *     Required when NatchOS.Plankton.ImplementationModels.Document.DocumentType is NatchOS.Plankton.ImplementationModels.DocumentType.Invoice.
             *
             *     0 = NotSet (Not set.)
             *
             *     1 = Invoice (The regular invoice with a positive amount.)
             *
             *     2 = CreditNote (The invoice has a negative amount.)
             */
            invoiceType: components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentInvoiceType"];
            /**
             * Format: date-time
             * @description The due date of the invoice.
             *     Required when NatchOS.Plankton.ImplementationModels.Document.DocumentType is NatchOS.Plankton.ImplementationModels.DocumentType.Invoice.
             */
            invoiceDueDate?: string | null;
            /**
             * Format: date-time
             * @description The shipment date and time.
             *     Required when NatchOS.Plankton.ImplementationModels.Document.DocumentType is NatchOS.Plankton.ImplementationModels.DocumentType.Shipment.
             */
            shipmentDateTime?: string | null;
            /**
             * Format: int32
             * @description The id of the NatchOS.Plankton.ImplementationModels.Person that created the document.
             */
            creatorPersonId?: number | null;
            /**
             * Format: int32
             * @description The salesperson id.
             */
            salespersonId?: number | null;
            /**
             * @description The shipping advice as an enum.
             *     This defines how complete the quantities for the ordered products must be before fulfillment of the order (or partial orders).
             *
             *     0 = NotSet (Not set.)
             *
             *     1 = Partial (The order can be split up, ie. per product or even per smaller quantities of a single product.)
             *
             *     2 = CompleteOrderLines (The order can be split up, but every order line must be complete (quantity).)
             *
             *     3 = Complete (The order will be fulfilled once, when all products are available.)
             */
            shippingAdvice: components["schemas"]["NatchOS.Plankton.ImplementationModels.PredefinedShippingAdvice"];
            /**
             * @description The transfer type as an enum.
             *     Transfer types is a fixed list for all implementations.
             *
             *     0 = NotSet (Not set.)
             *
             *     1 = Pickup (Buyer will pick up the order.)
             *
             *     2 = Delivery (Seller will ship the order to the buyer.)
             *
             *     3 = PickupNightLocker (Buyer will pick up the order from a night locker.)
             */
            transferType: components["schemas"]["NatchOS.Plankton.ImplementationModels.PredefinedTransferType"];
            /**
             * Format: int32
             * @description The technical key of the transfer subtype, fex. all possible pickup locations.
             */
            transferSubTypeId?: number | null;
            /**
             * Format: int32
             * @description The total line count.
             */
            totalLineCount?: number | null;
            /**
             * @description The files attached to the product.
             *     This data will be loaded when `AddFiles` is set to true.
             */
            readonly files: components["schemas"]["NatchOS.Plankton.ImplementationModels.File"][];
            /** @description The miscellaneous data in XML format. */
            miscXml?: string | null;
            /**
             * @description The JSON representation of the track and trace information.
             *     WARNING: Temporary solution. Will be replaced by a class in a future.
             */
            trackTraceJson?: string | null;
        };
        /** @description Extends the NatchOS.Plankton.ImplementationModels.AddressStrict class with extra properties. */
        "NatchOS.Plankton.ImplementationModels.DocumentAddress": {
            /** @description The primary address line. */
            addressLine1: string;
            /** @description The secondary address line. */
            addressLine2?: string | null;
            /** @description The postal code. */
            postalCode: string;
            /** @description The city. */
            city: string;
            /**
             * Format: int32
             * @description The country id.
             */
            countryId: number;
            /** @description The two-letter country code (ISO 3166-1 alpha-2). */
            countryCode: string;
            /**
             * Format: int32
             * @description The id of the customer or the shipping address.
             */
            id: number;
            /** @description The name of the contact person. */
            contactPersonName?: string | null;
            /** @description The name for the customer or address. */
            name?: string | null;
            /** @description The secondary name for the customer or address. */
            name2?: string | null;
            /**
             * Format: int32
             * @description The culture identifier.
             */
            lcid: number;
            /** @description The email address. */
            emailAddress?: string | null;
        };
        /**
         * Format: int32
         * @description Defines the types of NatchOS.Plankton.ImplementationModels.DocumentType.Invoice.
         *
         *     0 = NotSet (Not set.)
         *
         *     1 = Invoice (The regular invoice with a positive amount.)
         *
         *     2 = CreditNote (The invoice has a negative amount.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.DocumentInvoiceType": NatchOSPlanktonImplementationModelsDocumentInvoiceType;
        /** @description A line under a NatchOS.Plankton.ImplementationModels.Document. */
        "NatchOS.Plankton.ImplementationModels.DocumentLine": {
            /**
             * Format: int32
             * @description The id of the document line in the repository.
             */
            id: number;
            /**
             * Format: int32
             * @description The line number.
             */
            lineNumber: number;
            /**
             * Format: int32
             * @description The parent line number to which this line is attached.
             */
            attachedToLineNumber?: number | null;
            /**
             * Format: int32
             * @description The type of the line.
             */
            lineType: number;
            /**
             * Format: int32
             * @description The product id.
             */
            productId?: number | null;
            /**
             * Format: int32
             * @description The variant product id.
             */
            variantProductId?: number | null;
            /**
             * Format: int32
             * @description The unit of measure id for the quantity.
             */
            unitOfMeasureId?: number | null;
            /**
             * Format: int32
             * @description The unit of measure id for the weight.
             */
            weightUnitOfMeasureId?: number | null;
            /**
             * Format: int32
             * @description The unit of measure id for the volume.
             */
            volumeUnitOfMeasureId?: number | null;
            /**
             * Format: int32
             * @description The technical key of the department.
             */
            departmentId?: number | null;
            /**
             * Format: int32
             * @description The id of status of the document.
             */
            documentStatusId?: number | null;
            /** @description The comment. */
            comment?: string | null;
            /** @description The name of the product. */
            productName?: string | null;
            /** @description The product number. */
            productNumber?: string | null;
            /** @description The product number as which this product is known to the main vendor. */
            mainVendorProductNumber?: string | null;
            /** @description The product number as which this product is known to the producer/manufacturer. */
            producerProductNumber?: string | null;
            /** @description The variant product number. */
            variantProductNumber?: string | null;
            /** @description The customer product number. */
            customerProductNumber?: string | null;
            /**
             * @description The EAN-13 barcode digits.
             *     An EAN-13 barcode (originally European Article Number, but now renamed International Article Number even though the abbreviation EAN has been retained) is a 13 digit (12 data and 1 check) barcoding standard.
             */
            ean?: string | null;
            /**
             * Format: double
             * @description The quantity.
             */
            quantity?: number | null;
            /**
             * Format: double
             * @description The quantity per unit of measure.
             */
            quantityPerUnitOfMeasure?: number | null;
            /**
             * Format: double
             * @description The quantity to invoice.
             */
            quantityToInvoice?: number | null;
            /**
             * Format: double
             * @description The quantity to ship.
             */
            quantityToShip?: number | null;
            /**
             * Format: double
             * @description The remaining quantity to ship.
             */
            remainingQuantity?: number | null;
            /**
             * Format: double
             * @description The unit price excluding vat.
             */
            unitPriceVatExcluded?: number | null;
            /**
             * Format: double
             * @description The unit price including vat.
             */
            unitPriceVatIncluded?: number | null;
            /**
             * Format: double
             * @description The vat percentage.
             */
            vatPercentage?: number | null;
            /**
             * Format: double
             * @description The line discount percentage.
             */
            lineDiscountPercentage?: number | null;
            /**
             * Format: double
             * @description The line discount amount.
             */
            lineDiscountAmount?: number | null;
            /**
             * Format: double
             * @description The line amount excluding vat.
             */
            lineAmountVatExcluded?: number | null;
            /**
             * Format: double
             * @description The line amount including vat.
             */
            lineAmountVatIncluded?: number | null;
            /**
             * Format: double
             * @description The net weight.
             */
            weightNet?: number | null;
            /**
             * Format: double
             * @description The gross weight.
             */
            weightGross?: number | null;
            /**
             * Format: double
             * @description The volume.
             */
            volume?: number | null;
            /**
             * Format: date-time
             * @description The shipment date and time.
             */
            shipmentDateTime?: string | null;
            /**
             * Format: date-time
             * @description The planned shipment date.
             */
            plannedShipmentDate?: string | null;
            /**
             * Format: date-time
             * @description The planned delivery date.
             */
            plannedDeliveryDate?: string | null;
            /**
             * Format: date-time
             * @description The promised delivery date.
             */
            promisedDeliveryDate?: string | null;
            /**
             * Format: date-time
             * @description The requested delivery date.
             */
            requestedDeliveryDate?: string | null;
            /**
             * @description The JSON representation of the track and trace information.
             *     WARNING: Temporary solution. Will be replaced by a class in a future.
             */
            trackTraceJson?: string | null;
            /** @description The miscellaneous data in XML format. */
            miscXml?: string | null;
        };
        /**
         * @description Defines a date range for filtering.
         *     Only date parts are used, not the time.
         */
        "NatchOS.Plankton.ImplementationModels.DocumentSearch.DocumentDateRange": {
            /**
             * Format: date-time
             * @description The minimum date.
             */
            minimumDate?: string | null;
            /**
             * Format: date-time
             * @description The maximum date.
             */
            maximumDate?: string | null;
        };
        /** @description Defines a result of the document search. */
        "NatchOS.Plankton.ImplementationModels.DocumentSearch.DocumentIdResult": {
            /**
             * Format: int32
             * @description The ID of the document in the repository.
             */
            documentId: number;
            /**
             * Format: int64
             * @description The sort order value of the result within the set.
             */
            sortOrder: number;
        };
        /**
         * @description Defines all the search criteria for the document search.
         *     Document type and LCID are required.
         */
        "NatchOS.Plankton.ImplementationModels.DocumentSearch.DocumentSearchCriteria": {
            /**
             * @description The document type to filter NatchOS.Plankton.ImplementationModels.DocumentType.
             *
             *     1 = Quote (A sales quote allows a prospective buyer to see what costs would be involved for the work they would like to have done.)
             *
             *     2 = Order (An agreement for specific products or services.)
             *
             *     3 = Shipment (A shipment document.)
             *
             *     4 = Invoice (An invoice for a completed order. Includes both positive and negative invoices, see NatchOS.Plankton.ImplementationModels.DocumentInvoiceType.)
             */
            documentType: components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentType"];
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The optional search term to perform a full-text search. */
            searchTerm?: string | null;
            /**
             * Format: int32
             * @description The optional page size for the results.
             *     The result will contain the page count if this is set.
             */
            pageSize?: number | null;
            /**
             * @description The optional customer product code the document needs to contain (NatchOS.Plankton.ImplementationModels.DocumentLine.CustomerProductNumber).
             *     Exact match only.
             */
            customerProductCode?: string | null;
            /**
             * Format: double
             * @description The optional minimum amount for NatchOS.Plankton.ImplementationModels.Document.TotalVatIncluded.
             */
            minimumAmountVatIncluded?: number | null;
            /**
             * Format: double
             * @description The optional minimum amount for NatchOS.Plankton.ImplementationModels.Document.TotalVatExcluded.
             */
            minimumAmountVatExcluded?: number | null;
            /**
             * Format: double
             * @description The optional maximum amount for NatchOS.Plankton.ImplementationModels.Document.TotalVatIncluded.
             */
            maximumAmountVatIncluded?: number | null;
            /**
             * Format: double
             * @description The optional maximum amount for NatchOS.Plankton.ImplementationModels.Document.TotalVatExcluded.
             */
            maximumAmountVatExcluded?: number | null;
            /** @description Gets an optional list of statuses to filter by. */
            documentStatusIdList?: number[] | null;
            /**
             * Format: int32
             * @description The optional identifier of the product the document must contain (NatchOS.Plankton.ImplementationModels.DocumentLine.ProductId).
             */
            productId?: number | null;
            /**
             * Format: int32
             * @description The optional currency of the document (NatchOS.Plankton.ImplementationModels.Document.CurrencyId).
             */
            currencyId?: number | null;
            /**
             * Format: int32
             * @description The optional department the document must be linked to.
             */
            departmentId?: number | null;
            /**
             * Format: int32
             * @description The optional sales person the document must be linked to (NatchOS.Plankton.ImplementationModels.Document.SalespersonId).
             */
            salesPersonId?: number | null;
            /**
             * Format: int32
             * @description The optional shipping address the document must be linked to (NatchOS.Plankton.ImplementationModels.Document.ShippingAddress.
             */
            shippingAddressId?: number | null;
            /**
             * Format: int32
             * @description The optional country identifier of the customer the document must be linked to (NatchOS.Plankton.ImplementationModels.Document.CustomerAddress).
             */
            customerCountryId?: number | null;
            /** @description The optional postal code of the customer of the document must be linked to (NatchOS.Plankton.ImplementationModels.Document.CustomerAddress). */
            customerPostalCode?: string | null;
            /**
             * Format: int32
             * @description The optional identifier of the person that must have created the document (NatchOS.Plankton.ImplementationModels.Document.CreatorPersonId).
             */
            creatorPersonId?: number | null;
            /**
             * Format: int32
             * @description The optional invoicing customer the document must be linked to (NatchOS.Plankton.ImplementationModels.Document.InvoiceAddress).
             */
            invoiceCustomerId?: number | null;
            /**
             * Format: int32
             * @description The optional country identifier of the invoicing customer the document must be linked to (NatchOS.Plankton.ImplementationModels.Document.InvoiceAddress).
             */
            invoiceCustomerCountryId?: number | null;
            /** @description The optional postal code of the invoicing customer of the document must be linked to (NatchOS.Plankton.ImplementationModels.Document.InvoiceAddress). */
            invoiceCustomerPostalCode?: string | null;
            /**
             * Format: int32
             * @description The optional maximum number of document ID results to retrieve.
             */
            maximumDocumentResults?: number | null;
            /**
             * @description The sort order.
             *     Default value is NatchOS.Plankton.ImplementationModels.DocumentSearch.DocumentSearchResultSortOrder.DocumentDateDescending.
             *
             *     0 = NotSet (No specific order. Best performance.)
             *
             *     11 = ScoreDescending (Sort by search engine score descending (highest score first).)
             *
             *     12 = DocumentDateAscending (Sort by document date (NatchOS.Plankton.ImplementationModels.Document.DocumentDateTime) ascending (oldest documents first).)
             *
             *     13 = DocumentDateDescending (Sort by document date (NatchOS.Plankton.ImplementationModels.Document.DocumentDateTime) descending (newest documents first).)
             *
             *     14 = RequestedDeliveryDateAscending (Sort by requested delivery date (NatchOS.Plankton.ImplementationModels.Document.RequestedDeliveryDate) ascending (oldest first).)
             *
             *     15 = RequestedDeliveryDateDescending (Sort by requested delivery date (NatchOS.Plankton.ImplementationModels.Document.RequestedDeliveryDate) descending (newest first).)
             *
             *     16 = OrderDateAscending (Sort by order date (NatchOS.Plankton.ImplementationModels.Document.OrderDateTime) ascending (oldest first).)
             *
             *     17 = OrderDateDescending (Sort by order date (NatchOS.Plankton.ImplementationModels.Document.OrderDateTime) descending (newest first).)
             */
            sortOrder: components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentSearch.DocumentSearchResultSortOrder"];
            /** @description The optional allowed range for the document date (NatchOS.Plankton.ImplementationModels.Document.DocumentDateTime. */
            documentDateRange?: components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentSearch.DocumentDateRange"] | null;
            /** @description The optional allowed range for the order date (NatchOS.Plankton.ImplementationModels.Document.OrderDateTime. */
            orderDateRange?: components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentSearch.DocumentDateRange"] | null;
            /** @description The optional allowed range for the requested delivery date (NatchOS.Plankton.ImplementationModels.Document.RequestedDeliveryDate. */
            requestedDeliveryDateRange?: components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentSearch.DocumentDateRange"] | null;
        };
        /**
         * Format: int32
         * @description Defines the options for sorting the product ID list for NatchOS.Plankton.ImplementationModels.DocumentSearch.DocumentSearchCriteria.
         *
         *     0 = NotSet (No specific order. Best performance.)
         *
         *     11 = ScoreDescending (Sort by search engine score descending (highest score first).)
         *
         *     12 = DocumentDateAscending (Sort by document date (NatchOS.Plankton.ImplementationModels.Document.DocumentDateTime) ascending (oldest documents first).)
         *
         *     13 = DocumentDateDescending (Sort by document date (NatchOS.Plankton.ImplementationModels.Document.DocumentDateTime) descending (newest documents first).)
         *
         *     14 = RequestedDeliveryDateAscending (Sort by requested delivery date (NatchOS.Plankton.ImplementationModels.Document.RequestedDeliveryDate) ascending (oldest first).)
         *
         *     15 = RequestedDeliveryDateDescending (Sort by requested delivery date (NatchOS.Plankton.ImplementationModels.Document.RequestedDeliveryDate) descending (newest first).)
         *
         *     16 = OrderDateAscending (Sort by order date (NatchOS.Plankton.ImplementationModels.Document.OrderDateTime) ascending (oldest first).)
         *
         *     17 = OrderDateDescending (Sort by order date (NatchOS.Plankton.ImplementationModels.Document.OrderDateTime) descending (newest first).)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.DocumentSearch.DocumentSearchResultSortOrder": NatchOSPlanktonImplementationModelsDocumentSearchDocumentSearchResultSortOrder;
        /** @description Results for a document search. */
        "NatchOS.Plankton.ImplementationModels.DocumentSearch.SearchResults": {
            /**
             * Format: int32
             * @description The number of documents that match the criteria.
             *     This will take into account the NatchOS.Plankton.ImplementationModels.DocumentSearch.DocumentSearchCriteria.MaximumDocumentResults off the criteria.
             */
            resultCount: number;
            /**
             * Format: int32
             * @description The optional page count for the result set.
             *     Will only be calculated if page size was set in the search criteria.
             */
            pageCount?: number | null;
            /**
             * Format: int32
             * @description The optional page size for the result set.
             */
            pageSize?: number | null;
            /**
             * Format: int32
             * @description The total elapsed time measured for the SQL call to perform the search, in milliseconds.
             */
            elapsedMilliseconds: number;
            /** @description The documents per page number, starting with 1. */
            pagedDocuments: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentSearch.DocumentIdResult"][];
            };
        };
        /** @description Defines a status for a document. */
        "NatchOS.Plankton.ImplementationModels.DocumentStatus": {
            /**
             * Format: int32
             * @description The ID of the entity in the repository.
             */
            id: number;
            /** @description The internal name. */
            internalName: string;
            /** @description The translations, indexed by two-letter language code. */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.TranslationsBase.MetaTranslationWithName"];
            };
            /**
             * Format: int32
             * @description The document type identifier.
             */
            documentTypeId: number;
        };
        /**
         * Format: int32
         * @description Defines the type for a NatchOS.Plankton.ImplementationModels.Document.
         *
         *     1 = Quote (A sales quote allows a prospective buyer to see what costs would be involved for the work they would like to have done.)
         *
         *     2 = Order (An agreement for specific products or services.)
         *
         *     3 = Shipment (A shipment document.)
         *
         *     4 = Invoice (An invoice for a completed order. Includes both positive and negative invoices, see NatchOS.Plankton.ImplementationModels.DocumentInvoiceType.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.DocumentType": NatchOSPlanktonImplementationModelsDocumentType;
        /** @description Represents an email address, optionally with a display name, used in an email message. */
        "NatchOS.Plankton.ImplementationModels.EmailMessageAddress": {
            emailAddress: string;
            /** @description The display name of the address. */
            displayName?: string | null;
        };
        /** @description Defines the configuration of an email message. */
        "NatchOS.Plankton.ImplementationModels.EmailMessageConfiguration": {
            /** @description The single FROM address for the email message. */
            from: components["schemas"]["NatchOS.Plankton.ImplementationModels.EmailMessageAddress"];
            /** @description The list of TO addresses for the email message. */
            readonly to: components["schemas"]["NatchOS.Plankton.ImplementationModels.EmailMessageAddress"][];
            /** @description The list of CC addresses for the email message. */
            readonly cc: components["schemas"]["NatchOS.Plankton.ImplementationModels.EmailMessageAddress"][];
            /** @description The list of BCC addresses for the email message. */
            readonly bcc: components["schemas"]["NatchOS.Plankton.ImplementationModels.EmailMessageAddress"][];
            /** @description The list of REPLYTO addresses for the email message. */
            readonly replyTo: components["schemas"]["NatchOS.Plankton.ImplementationModels.EmailMessageAddress"][];
        };
        /**
         * Format: int32
         * @description Defines the different types of email messages that can be sent.
         *
         *     1 = PasswordReset (A password reset mail.)
         *
         *     2 = PasswordChanged (Mail to user informing their password has changed.)
         *
         *     3 = AccountActivation (An account activation mail.)
         *
         *     4 = StoreAccess (A store access notification mail.)
         *
         *     5 = BasketSubmitted (A basket submitted notification mail (to internal).)
         *
         *     6 = BasketConfirmation (A basket submitted confirmation mail (to customer).)
         *
         *     7 = AccountRequest (Mail to internal - a customer requested a new account.)
         *
         *     8 = AccountRequestResponse (Mail to customer - confirmation of account request.)
         *
         *     9 = Registration (Mail to internal - a new customer requested an account.)
         *
         *     10 = RegistrationResponse (Mail to customer - confirmation of registration.)
         *
         *     11 = ContactUpdate (Mail to internal - Summary of updated contact data.)
         *
         *     12 = BasketToPurchaser (Mail to customer - a basket was assigned to purchaser for approval.)
         *
         *     13 = CustomerNote (Mail with customer note.)
         *
         *     14 = QuoteRequest (Mail to customer with quote.)
         *
         *     15 = ContactForm (Mail to customer with data from a contact form.)
         *
         *     16 = AnonymousBasketMail (Mail to user with content of anonymous list.)
         *
         *     17 = AnonymousBasketQuoteRequest (Mail to internal - Anonymous quote request.)
         *
         *     18 = AnonymousBasketQuoteResponse (Mail to user - Confirmation of anonymous quote request.)
         *
         *     19 = BlanketOrderMail (Mail to user - Informing him of the status of his blanket orders.)
         *
         *     20 = PriceListReplyEmail (Mail to customer informing him that his requested price list is ready to be downloaded.)
         *
         *     21 = Return (Mail to internal - form for return has been submitted.)
         *
         *     22 = Warranty (Mail to internal - form for warranty has been submitted.)
         *
         *     23 = AbandonedBasket (Mail to user or customer to inform him of an abandoned basket.)
         *
         *     24 = InfoDeliveryTime (Mail to internal - a customer requests info about a delivery time for a product.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.EmailMessageType": NatchOSPlanktonImplementationModelsEmailMessageType;
        /** @description Represents an item of the queue. */
        "NatchOS.Plankton.ImplementationModels.ExportQueueItem": {
            /**
             * Format: int64
             * @description The identifier of the queue item.
             */
            id: number;
            /**
             * Format: int32
             * @description The store identifier.
             */
            storeId: number;
            /**
             * Format: int64
             * @description The related item identifier.
             *     This is the basket ID if the type is 1.
             */
            relatedEntityId: number;
            /**
             * Format: int32
             * @description The identifier of the type.
             */
            exportTypeId: number;
            /**
             * @description The data of the queue item.
             *     This is usually an XML or JSON string.
             */
            data: string;
            /**
             * Format: int32
             * @description The failure count.
             */
            failureCount: number;
        };
        /**
         * @description Contains data from the non-erp system attached to domain object.
         *     Can be language specific or language independent (lcid will be zero).
         */
        "NatchOS.Plankton.ImplementationModels.ExternalData": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /**
             * Format: int32
             * @description The ID of the external source.
             *     External sources can be ERP, PIM or DAM system, backoffice in the website.
             *     At implementation level this should be an enum.
             */
            externalSourceId: number;
            /** @description The miscellaneous XML. */
            miscXml?: string | null;
        };
        /** @description A file linked to an entity. */
        "NatchOS.Plankton.ImplementationModels.File": {
            /**
             * Format: int32
             * @description The entity file type id.
             */
            entityFileTypeId: number;
            /**
             * @description The name of the file.
             *     Only to be used for display.
             *     Use NatchOS.Plankton.ImplementationModels.File.Url for linking to the file.
             */
            fileName: string;
            /**
             * Format: uri
             * @description The absolute URL, including an origin.
             */
            url: string;
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The miscellaneous XML. */
            miscXml?: string | null;
        };
        /** @description Represents the result of a search for customers that can be impersonated. */
        "NatchOS.Plankton.ImplementationModels.ImpersonateSearchCustomersResult": {
            /**
             * Format: int32
             * @description The total number of customers found.
             */
            totalResultCount: number;
            /**
             * @description The list of customers that can be impersonated.
             *     Only available if the total result count is less than or equal to 100.
             */
            customers: components["schemas"]["NatchOS.Plankton.ImplementationModels.CustomerBase"][];
        };
        /** @description Represents a multi customer option. */
        "NatchOS.Plankton.ImplementationModels.MultiCustomerOption": {
            /**
             * Format: int32
             * @description The customer id.
             */
            customerId: number;
            /** @description The name. */
            name: string;
            /** @description The postal code. */
            postalCode?: string | null;
            /** @description The city. */
            city?: string | null;
            /**
             * Format: int32
             * @description The country id.
             */
            countryId: number;
            /** @description The two-letter country code (ISO 3166-1 alpha-2). */
            countryCode: string;
            /** @description The VAT number. */
            vatNumber?: string | null;
        };
        /** @description Defines the order type for a <seealso cref="T:NatchOS.Plankton.ImplementationModels.Document" /> of the type <seealso cref="F:NatchOS.Plankton.ImplementationModels.DocumentType.Order" />, found in <seealso cref="P:NatchOS.Plankton.ImplementationModels.Document.OrderTypeId" />. */
        "NatchOS.Plankton.ImplementationModels.OrderType": {
            /**
             * Format: int32
             * @description The ID of the entity in the repository.
             */
            id: number;
            /** @description The internal name. */
            internalName: string;
            /** @description The translations, indexed by two-letter language code. */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.TranslationsBase.MetaTranslationWithName"];
            };
        };
        /** @description Holds information of the online payment linked to the NatchOS.Plankton.ImplementationModels.BasketHeader. */
        "NatchOS.Plankton.ImplementationModels.PaymentInformation": {
            /** @description The reference or identifier of the online payment at the payment provider. */
            paymentReference?: string | null;
            /**
             * @description The payment service provider for the online payment, i.e. `MOLLIE`.
             *
             *     0 = NotSet (No value set.)
             *
             *     1 = Mollie (Mollie payment service provider. Officially support by NatchOS.)
             */
            paymentProvider: components["schemas"]["NatchOS.Plankton.ImplementationModels.PaymentProvider"];
            /** @description The payment method for the online payment, i.e. `BANCONTACT`. */
            paymentMethodName?: string | null;
            /**
             * @description The status of the online payment.
             *
             *     0 = NotSet (No online payment linked to the basket.)
             *
             *     1 = Started (The payment has been created with the payment service provider. The reference and provider have been stored in NatchOS.Plankton.ImplementationModels.BasketHeader.PaymentInformation.)
             *
             *     2 = Cancelled (The payment was cancelled by the user. A new payment should be created if the user proceeds to online payment again.)
             *
             *     3 = Expired (The payment has expired, e.g. the user has abandoned the payment. How much time it takes for a payment to expire depends on the payment method. A new payment should be created if the user proceeds to online payment again.)
             *
             *     4 = Failed (The payment has failed and cannot be completed with a different payment method. A new payment should be created if the user proceeds to online payment again.)
             *
             *     9 = Paid (The payment is successfully paid. Basket should be closed (NatchOS.Plankton.ImplementationModels.BasketStatus.Closed) and sent.)
             */
            paymentStatus: components["schemas"]["NatchOS.Plankton.ImplementationModels.PaymentStatus"];
            /**
             * Format: double
             * @description The total amount of the online payment.
             *     This amount may differ from the total of the basket content, i.e. an additional cost or a discount for online payment.
             */
            paymentAmount?: number | null;
        };
        /** @description Defines the payment methods linked in NatchOS.Plankton.ImplementationModels.Document.PaymentMethodId. */
        "NatchOS.Plankton.ImplementationModels.PaymentMethod": {
            /**
             * Format: int32
             * @description The ID of the property class in the repository.
             */
            id: number;
            /** @description The internal name. */
            internalName: string;
            /** @description The translations, indexed by two-letter language code. */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.TranslationsBase.EntityTranslationWithMiscXml"];
            };
            /** @description A value indicating whether this payment method is via online payment (like Mollie, bancontact...). */
            isOnlinePayment: boolean;
            /** @description The miscellaneous XML with extra data. */
            miscXml?: string | null;
        };
        /**
         * Format: int32
         * @description Defines the options for the payment provider linked to payment information of a basket.
         *
         *     0 = NotSet (No value set.)
         *
         *     1 = Mollie (Mollie payment service provider. Officially support by NatchOS.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.PaymentProvider": NatchOSPlanktonImplementationModelsPaymentProvider;
        /**
         * Format: int32
         * @description Defines the options for the status an online payment can have.
         *
         *     0 = NotSet (No online payment linked to the basket.)
         *
         *     1 = Started (The payment has been created with the payment service provider. The reference and provider have been stored in NatchOS.Plankton.ImplementationModels.BasketHeader.PaymentInformation.)
         *
         *     2 = Cancelled (The payment was cancelled by the user. A new payment should be created if the user proceeds to online payment again.)
         *
         *     3 = Expired (The payment has expired, e.g. the user has abandoned the payment. How much time it takes for a payment to expire depends on the payment method. A new payment should be created if the user proceeds to online payment again.)
         *
         *     4 = Failed (The payment has failed and cannot be completed with a different payment method. A new payment should be created if the user proceeds to online payment again.)
         *
         *     9 = Paid (The payment is successfully paid. Basket should be closed (NatchOS.Plankton.ImplementationModels.BasketStatus.Closed) and sent.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.PaymentStatus": NatchOSPlanktonImplementationModelsPaymentStatus;
        /**
         * @description Default implementation of person.
         *     Each person is attached to one or more NatchOS.Plankton.ImplementationModels.Customer.
         */
        "NatchOS.Plankton.ImplementationModels.Person": {
            /** @description The first name. */
            firstName?: string | null;
            /** @description The middle name. */
            middleName?: string | null;
            /**
             * @description The last name.
             *     Required field.
             */
            lastName: string;
            /**
             * @description The email address.
             *     Required field.
             */
            emailAddress: string;
            /**
             * @description The full name.
             *     This is a combination of FirstName and LastName.
             */
            readonly fullName: string;
            /**
             * Format: int32
             * @description The language (as lcid or predefined CultureInfo identifier) of the customer.
             */
            lcid: number;
            /** @description The regular phone number. */
            phoneNumber?: string | null;
            /** @description The mobile phone number. */
            phoneNumberMobile?: string | null;
            /**
             * Format: int32
             * @description The id of the person in the repository.
             */
            id: number;
            /**
             * @description The code of the person from the master data.
             *     May only be used to communicate with person data.
             *     Don't use this value in front-end.
             */
            code: string;
            /**
             * @description The logon name of the user.
             *     Must be unique.
             */
            userName: string;
            /** @description A value indicating whether this person is locked out as a result of too many invalid sign in attempts and therefore can't sign in anymore. */
            isLockedOut: boolean;
            /** @description A value indicating whether this person is blocked from signing in or using the application. */
            isBlocked: boolean;
            /**
             * @description The identifiers of the attached NatchOS.Plankton.ImplementationModels.Customer via one or more roles.
             *     The person may or may not be allowed to sign in for that customer depending on the `SignInAllowed` right that the person has for that customer.
             */
            customerIds: number[];
            /**
             * Format: int32
             * @description The id of the shipping address.
             */
            shippingAddressId?: number | null;
            /**
             * Format: int32
             * @description The salesperson id to which this person is attached.
             */
            salespersonId?: number | null;
            /**
             * @description The persons activation status.
             *
             *     5 = MailQueued (Account activation mail must be sent. Triggered when a login is created or a contact becomes a login.)
             *
             *     10 = MailSent (Account activation mail is sent, but account has not been activated yet. Triggered when the activation mail is sent.)
             *
             *     15 = AccountActivated (Account activation completed. Triggered when the login has initially set his password.)
             *
             *     20 = MailFailed (Account activation mail could not be sent.)
             */
            activationStatus: components["schemas"]["NatchOS.Plankton.ImplementationModels.AccountActivationStatus"];
            /** @description The external data attached to the person. */
            externalData: components["schemas"]["NatchOS.Plankton.ImplementationModels.ExternalData"][];
            /** @description The miscellaneous data in XML format. */
            miscXml?: string | null;
        };
        /**
         * Format: int32
         * @description List of predefined NatchOS rights.
         *     This is a subset of the rights defined in the NatchOS domain.
         *     Only exposed the rights that are relevant for the Plankton API and implementations for now.
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.PredefinedRight": NatchOSPlanktonImplementationModelsPredefinedRight;
        /**
         * Format: int32
         * @description List of NatchOS supported shipping advice options that can be used with basket and document.
         *
         *     0 = NotSet (Not set.)
         *
         *     1 = Partial (The order can be split up, ie. per product or even per smaller quantities of a single product.)
         *
         *     2 = CompleteOrderLines (The order can be split up, but every order line must be complete (quantity).)
         *
         *     3 = Complete (The order will be fulfilled once, when all products are available.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.PredefinedShippingAdvice": NatchOSPlanktonImplementationModelsPredefinedShippingAdvice;
        /**
         * Format: int32
         * @description List of the NatchOS supported transfer types that can be used.
         *     See TransferSubType for the subtypes per transfer type.
         *
         *     0 = NotSet (Not set.)
         *
         *     1 = Pickup (Buyer will pick up the order.)
         *
         *     2 = Delivery (Seller will ship the order to the buyer.)
         *
         *     3 = PickupNightLocker (Buyer will pick up the order from a night locker.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.PredefinedTransferType": NatchOSPlanktonImplementationModelsPredefinedTransferType;
        /** @description Default implementation of product. */
        "NatchOS.Plankton.ImplementationModels.Product": {
            /**
             * Format: int32
             * @description The ID of the product in the repository.
             */
            id: number;
            /**
             * @description The code of the product from the master data.
             *     May only be used to communicate with master data.
             *     Don't use this value in front-end.
             */
            code: string;
            /** @description The product number. */
            productNumber: string;
            /** @description The internal name. */
            internalName: string;
            /**
             * @description A value indicating whether this instance is online.
             *     Generally the product will not show up in search results and the detail page will not be available.
             */
            isOnline: boolean;
            /**
             * Format: int32
             * @description The product discount group id.
             */
            productDiscountGroupId: number;
            /** @description A value indicating whether discount is allowed for this product. */
            allowDiscount: boolean;
            /**
             * Format: double
             * @description The unit price.
             *     This is the standard selling price for the product (vat excluded).
             */
            unitPrice?: number | null;
            /**
             * Format: double
             * @description The unit list price or suggested reselling price (vat excluded).
             */
            unitListPrice?: number | null;
            /** @description A value indicating whether price should not be shown and is only available on request. */
            priceOnRequest: boolean;
            /**
             * Format: int32
             * @description The main vendor id.
             */
            mainVendorId: number;
            /** @description The product number as which this product is known to the main vendor. */
            mainVendorProductNumber?: string | null;
            /**
             * @description The EAN-13 barcode digits.
             *     An EAN-13 barcode (originally European Article Number, but now renamed International Article Number
             *     even though the abbreviation EAN has been retained) is a 13 digit (12 data and 1 check) barcoding standard.
             */
            ean?: string | null;
            /** @description The product number as which this product is known to the producer/manufacturer. */
            producerProductNumber?: string | null;
            /**
             * Format: int32
             * @description The average delivery time in days for the main vendor for this product.
             */
            leadTimeCalculation?: number | null;
            /**
             * Format: double
             * @description The minimum order quantity.
             *     Typically, in sales units.
             */
            minimumOrderQuantity?: number | null;
            /**
             * Format: double
             * @description The incremental order quantity.
             *     Typically, in sales units.
             */
            incrementalOrderQuantity?: number | null;
            /**
             * @description The intrastat code.
             *     Intrastat is the system for collecting information and producing statistics on the trade in goods between countries of the European Union (EU).
             */
            intrastatCode?: string | null;
            /**
             * Format: int32
             * @description The vat business posting group id.
             *     A vat business posting group is used to determine the VAT.
             */
            vatBusinessPostingGroupId: number;
            /** @description A value indicating whether this product is a model product. */
            isModelProduct: boolean;
            /**
             * Format: int32
             * @description A value for the configuration type id.
             *     A value greater than one indicates that the product is configurable.
             */
            configurationTypeId: number;
            /**
             * Format: int32
             * @description The value ID of the property that holds the brand name.
             *     This data will be loaded when `AddBrandPropertyForDataLayer` is set to true.
             *     Only available if brand name is implemented as a property.
             */
            brandPropertyValueId?: number | null;
            /**
             * @description The category ids attached to the product.
             *     This data will be loaded when `AddCategories` is set to true.
             */
            readonly categories: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductCategory"][];
            /**
             * @description The translations attached to the product, indexed by two-letter language code.
             *     This data will be loaded when `AddProductTranslations` is set to true.
             */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductTranslation"];
            };
            /**
             * @description The list of store specific data for the product.
             *     This data will be loaded when `AddStoreData` is set to true.
             */
            readonly storeData: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductStoreData"][];
            /**
             * @description The external data (data from other systems than the master) attached to the product.
             *     This data will be loaded when `AddExternalData` is set to true.
             */
            readonly externalData: components["schemas"]["NatchOS.Plankton.ImplementationModels.ExternalData"][];
            /**
             * @description The stock per warehouse.
             *     Only warehouses that currently have a stock count or stock indication are included.
             *     Will not include stock forecast.
             *     This data will be loaded when `AddStock` is set to true.
             */
            readonly stock: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductStock"][];
            /**
             * @description The overpacks for the product.
             *     This data will be loaded when `AddOverpacks` is set to true.
             *     Additional data on the overpacks will be loaded when
             *     `AddOverpackTranslations` is set to true.
             */
            readonly overpacks: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductOverpack"][];
            /**
             * @description The files attached to the product.
             *     This data will be loaded when `AddFiles` is set to true.
             */
            readonly files: components["schemas"]["NatchOS.Plankton.ImplementationModels.File"][];
            /**
             * @description The property values attached to the product.
             *     This data will be loaded when `AddPropertyValues` is set to true.
             */
            readonly propertyValues: components["schemas"]["NatchOS.Plankton.ImplementationModels.PropertyValue"][];
            /**
             * @description The relations for the product.
             *     This data will be loaded when `AddProductRelations` is set to true.
             *     Use `AddProductRelationsOnlyOnlineProducts` to only load relations for online products.
             */
            readonly relations: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductRelation"][];
            /** @description The miscellaneous data in XML format. */
            miscXml?: string | null;
            /**
             * @description Gets or set the data layer information of the product for GTM/GA.
             *     This data will be loaded when `AddPropertyValues` is set to true.
             */
            dataLayer: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductDataLayerDto"];
        };
        /** @description Categories attached to a product. */
        "NatchOS.Plankton.ImplementationModels.ProductCategory": {
            /**
             * Format: int32
             * @description The ID of the NatchOS.Plankton.ImplementationModels.Category in the repository.
             */
            categoryId: number;
            /**
             * Format: int32
             * @description The ID of the root NatchOS.Plankton.ImplementationModels.Category in the repository.
             */
            rootCategoryId: number;
            /** @description The miscellaneous JSON with extra data. */
            miscJson?: string | null;
        };
        "NatchOS.Plankton.ImplementationModels.ProductDataLayerDto": {
            /** @description The number of the product. */
            productNumber: string;
            /** @description The name of the product. */
            name: string;
            /** @description The name of the brand of the product. */
            brand?: string | null;
            /**
             * @description The optional category structure to which the product belongs.
             *     Has / as a delimiter to specify up to 5-levels of hierarchy (e.g. Apparel/Men/T-Shirts).
             */
            category?: string | null;
            /** @description The optional variant name or unique code or description for additional item details/options. */
            variant?: string | null;
            /** @description The affiliation for the product to designate a supplying company or brick and mortar store location. */
            affiliation?: string | null;
            /** @description The ID of the promotion associated with the product. */
            promotionId?: string | null;
            /** @description The name of the promotion associated with the product. */
            promotionName?: string | null;
        };
        /** @description Defines the overpack details of a specific product. */
        "NatchOS.Plankton.ImplementationModels.ProductOverpack": {
            /**
             * Format: int32
             * @description The id of the overpack.
             */
            id: number;
            /** @description The internal name of the overpack. */
            internalName: string;
            /**
             * Format: double
             * @description The number of sales units per pack.
             */
            unitsPerPack: number;
            /**
             * @description The translations of the overpack, indexed by two-letter language code.
             *     This data will be loaded when `AddOverpackTranslations` is set to true.
             */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductOverpackTranslation"];
            };
            /** @description The miscellaneous JSON with extra data. */
            miscJson?: string | null;
        };
        /** @description Contains the language-specific properties of a NatchOS.Plankton.ImplementationModels.ProductOverpack. */
        "NatchOS.Plankton.ImplementationModels.ProductOverpackTranslation": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The name. */
            name: string;
            /** @description The description. */
            description?: string | null;
            /** @description The miscellaneous JSON with extra data. */
            miscJson?: string | null;
        };
        /** @description Product price attached to a price group. */
        "NatchOS.Plankton.ImplementationModels.ProductPrice": {
            /**
             * Format: int32
             * @description The product id.
             */
            productId: number;
            /**
             * Format: double
             * @description The line quantity.
             */
            lineQuantity: number;
            /**
             * Format: double
             * @description The minimum order quantity which must be ordered to get the unit price.
             */
            minimumOrderQuantity: number;
            /**
             * Format: double
             * @description The unit price.
             */
            unitPrice: number;
            /** @description Gets or sets miscellaneous data, a JSON string. */
            miscJson?: string | null;
        };
        "NatchOS.Plankton.ImplementationModels.ProductPropertyValues": {
            /** Format: int32 */
            productId: number;
            propertyValues: components["schemas"]["NatchOS.Plankton.ImplementationModels.PropertyValue"][];
        };
        /** @description Relation between two products. */
        "NatchOS.Plankton.ImplementationModels.ProductRelation": {
            /**
             * @description The product relation type.
             *
             *     1 = HasAlternative (The related product is an alternative to the origin product.)
             *
             *     2 = FrequentlyBoughtTogetherWith (The related product appears frequently in the same order as the origin product.)
             *
             *     3 = CustomersWhoBoughtThisAlsoBought (The related product is often bought by the same customer who bought origin product.)
             *
             *     4 = MandatoryIncludes (The related product is mandatory included in a sale of origin product.)
             *
             *     5 = HasAccessory (The related product is an accessory of the origin product.)
             *
             *     6 = IsModelOf (The origin product is the model for the related product.)
             *
             *     7 = IsInSameSeries (The origin product belongs to the same series of products as the related product.)
             *
             *     8 = HasReplacement (The related product is a replacement for the origin product. This is the reverse of NatchOS.Plankton.ImplementationModels.RelationType.IsReplacementOf.)
             *
             *     9 = TemporaryHasAlternative (Time bound (by range) version of NatchOS.Plankton.ImplementationModels.RelationType.HasAlternative.)
             *
             *     10 = Basic (The related product has a basic relation to the origin product, without any specific meaning.)
             *
             *     11 = SuggestedIncludes (The related product is a highly recommended accessory.)
             *
             *     12 = ContainsSubassembly (The related product is a subassembly of the origin product. I.e. a BOM definition, the product that is bought is built out of several other products.)
             *
             *     13 = HasCheaperAlternative (The related product is a cheaper alternative to the original product.)
             *
             *     70 = HasHighlyAdvisedAccessory (The related product is an important accessory of the origin product.)
             *
             *     106 = IsVariantOf (The origin product is a variant of the related product (model). This is the opposite of NatchOS.Plankton.ImplementationModels.RelationType.IsModelOf.)
             *
             *     108 = IsReplacementOf (The origin product is a replacement of the related product. This is the opposite of NatchOS.Plankton.ImplementationModels.RelationType.HasReplacement.)
             */
            relation: components["schemas"]["NatchOS.Plankton.ImplementationModels.RelationType"];
            /**
             * Format: int32
             * @description The product id.
             */
            masterProductId: number;
            /**
             * Format: int32
             * @description The related product id.
             */
            relatedProductId: number;
            /**
             * Format: date-time
             * @description The start date (without time part) for the relation if the type is time-bound.
             */
            startDate?: string | null;
            /**
             * Format: date-time
             * @description The end date (without time part) for the relation if the type is time-bound.
             */
            endDate?: string | null;
            /**
             * Format: double
             * @description The optional count of NatchOS.Plankton.ImplementationModels.ProductRelation.RelatedProductId related to NatchOS.Plankton.ImplementationModels.ProductRelation.MasterProductId.
             */
            ratio?: number | null;
            /** @description Determines whether the specified relation type has a time constraint. */
            isTimeBoundType: boolean;
            /** @description The miscellaneous XML with extra data. */
            miscXml?: string | null;
        };
        /**
         * Format: int32
         * @description Defines the options to include model products and related products for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.
         *
         *     0 = Default (Don't use special logic. Use this value if the implementation does not use model products.)
         *
         *     1 = ModelOnly (Search in the model products and return results based on these model products.)
         *
         *     2 = ModelViaRelated (Search in the related products, but return results based on their model products.)
         *
         *     3 = RelatedOnly (Search in the related products and return results based on these related products.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.ModelsQueryType": NatchOSPlanktonImplementationModelsProductSearchModelsQueryType;
        /** @description Defines all the search criteria for the product search. */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The optional search term to perform a full-text search. */
            searchTerm?: string | null;
            /**
             * Format: int32
             * @description The optional page size for the results.
             *     The result will contain the page count if this is set.
             */
            pageSize?: number | null;
            /**
             * Format: int32
             * @description The category identifier to search in.
             *     Used for drilldown; for text searches this will be merged into NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.CategoryIdList.
             */
            categoryId: number;
            /**
             * @description Gets or sets where the search was originated.
             *
             *     0 = NotSet (Not set.)
             *
             *     1 = Scanning (Search in identifiers after scanning a product bar code. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.ProductIdentifier. Can be set automatically as the default value in !:ProductIdentifierSearchCriteria constructor.)
             *
             *     2 = TextSearch (Textual search in products. Is set automatically as the default value in NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria constructor with a search term. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.TextSearch.)
             *
             *     3 = DrillDown (Search under a category as part of a drill down. Is set automatically as the default value in NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria constructor with a category. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.DrillDown.)
             *
             *     4 = QuickEntry (Search in identifiers Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.ProductIdentifier. Can be set automatically as the default value in !:ProductIdentifierSearchCriteria constructor.)
             *
             *     5 = ProductPage (Search from a product page, i.e. get all promotions. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.DrillDown. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.)
             *
             *     6 = AutoComplete (Search for autocomplete in search text box. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.TextSearch. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.)
             *
             *     7 = Sitemap (Search for building the sitemap.xml content. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.DrillDown and NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.TextSearch. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.)
             *
             *     8 = External (Search from an external source, like a webservice or API. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.DrillDown and NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.TextSearch. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.)
             *
             *     9 = Category (Get category id's with product counts optionally specific for a customer. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.)
             *
             *     10 = PriceList (Use the product search to get the product id's for a pricelist. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.)
             *
             *     11 = FilterSearch (Use the product search to filter a list of products. Is set automatically as the default value for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria constructor with a product ID list.)
             *
             *     12 = ZeroResultsFallbackRetry (In cases where a user-initiated product search returns no results, the system automatically generates and executes a refined query (e.g., via typo correction, normalization, or reformulation) to improve result retrieval.)
             */
            searchOrigin: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.SearchOrigin"];
            /** @description A list of product identifiers to use for filtering. */
            productIdFilterList?: number[] | null;
            /** @description A list of categories the products must be attached to. */
            categoryIdList?: number[] | null;
            /** @description A list of property values to products must be attached to. */
            propertyValueFilterList?: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.PropertyValueFilterDto"][] | null;
            /**
             * @description A value indicating whether the search term may be used as a suggestion for the generic auto complete.
             *     Default is `true` when origin is NatchOS.Plankton.ImplementationModels.ProductSearch.SearchOrigin.TextSearch.
             */
            logAsSearchSuggestion?: boolean | null;
            /**
             * @description A value indicating whether only products from the custom's favorites should be included.
             *     User must be authenticated.
             */
            includeOnlyCustomerFavorites?: boolean | null;
            /**
             * @description A value indicating whether only products from the person's favorites should be included.
             *     To load all person favorites, pass `null` as search term.
             *     User must be authenticated.
             */
            includeOnlyPersonFavorites?: boolean | null;
            /**
             * @description A value indicating whether only products that were previously bought by the customer should be included.
             *     User must be authenticated.
             */
            includeOnlyProductsBoughtByCustomer?: boolean | null;
            /**
             * Format: int32
             * @description The optional maximum number of days in the past a product was bought in order for it be be considered as bought.
             *     Must be set with NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.IncludeOnlyProductsBoughtByCustomer.
             */
            productsBoughtByCustomerMaximumAgeInDays?: number | null;
            /** @description A value indicating whether only products with stock should be included. */
            includeOnlyProductsInStock?: boolean | null;
            /**
             * @description A value indicating whether only online products should be included.
             *     Default is `true`.
             */
            includeOnlyOnlineProducts?: boolean | null;
            /**
             * Format: int32
             * @description An optional promotion type to filter the products.
             */
            promotionTypeId?: number | null;
            /**
             * Format: int32
             * @description The optional maximum number of product ID results to retrieve.
             *     Must be set with NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.ProductIdentifier, but can also be used for other search types.
             *     Does not need to be set for drill-down or text searches. Would rather be used to get first 5 promotions.
             */
            maximumProductResults?: number | null;
            /**
             * @description A value indicating whether a list of product IDs should be returned.
             *     If you only need category or property filters, you can set this to `false`.
             *     Default value is `true`.
             */
            returnProductIdList?: boolean | null;
            /** @description A value indicating whether property filters (counts) should be returned. */
            returnPropertyFilters?: boolean | null;
            /**
             * @description A value indicating whether category filters (counts) should be returned.
             *     If `true`, then at least one value must be passed in NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.RestrictCategoryFiltersToRootCategoryIdList.
             */
            returnCategoryFilters?: boolean | null;
            /** @description A value indicating whether to only search in customer product codes. */
            onlySearchInCustomerProductCodes?: boolean | null;
            /**
             * @description The sort order for the product ID results.
             *     Not used for NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.ProductIdentifier.
             *
             *     0 = NotSet (No specific order. Best performance.)
             *
             *     11 = ScoreDescending (Sort by search engine score descending (highest score first).)
             *
             *     12 = ProductNumberAscending (Sort alphabetically by product number ascending.)
             *
             *     13 = ProductNumberDescending (Sort alphabetically by product number descending.)
             *
             *     14 = ProductNameAscending (Sort alphabetically by product name (from translation) ascending.)
             *
             *     15 = ProductNameDescending (Sort alphabetically by product name (from translation) descending.)
             *
             *     16 = PreviouslyBoughtThenPromoThenProductNumber (Sort (1) by previously bought first, (2) then by the order value of the promotion type, (3) then by product number ascending (alphabetically).)
             *
             *     18 = PreviouslyBoughtThenPromoThenProductName (Sort (1) by previously bought first, (2) then by the order value of the promotion type, (3) then by product name ascending (alphabetically).)
             *
             *     20 = PreviouslyBoughtThenProductNumber (Sort (1) by previously bought first, (2) then by product number ascending (alphabetically).)
             *
             *     22 = PreviouslyBoughtThenProductName (Sort (1) by previously bought first, (2) then by product name ascending (alphabetically).)
             *
             *     24 = InStockThenProductNumber (Sort (1) by products that are in stock first, (2) then by product number ascending (alphabetically).)
             *
             *     26 = PreviouslyBoughtThenInStock (Sort (1) by previously bought first, (2) then by products that are in stock.)
             *
             *     28 = MostBought (Sort (1) by most bought.)
             *
             *     30 = Personalized (A customer's personalized sort order of the search results.)
             *
             *     32 = TimesBoughtAscending (Order by number of times bought.)
             *
             *     33 = TimesBoughtDescending (Order by number of times bought.)
             *
             *     34 = LastTimeBoughtAscending (Order by last time bought.)
             *
             *     35 = LastTimeBoughtDescending (Order by last time bought.)
             *
             *     40 = PriceAscending (Order by ascending price.)
             *
             *     41 = PriceDescending (Order by descending price.)
             *
             *     42 = CustomerProductCodeAscending (Order by customer product code ascending.)
             *
             *     43 = CustomerProductCodeDescending (Order by customer product code descending.)
             *
             *     44 = ProductCodeAscending (Order by product code ascending.)
             *
             *     45 = ProductCodeDescending (Order by product code descending.)
             *
             *     100 = Random (Explicitly randomize the results.)
             *
             *     112 = PersonalizedThenProductNumberAscending (Order by a personalized sort order and product number ascending. Combination of NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchResultSortOrder.Personalized followed by NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchResultSortOrder.ProductNameAscending.)
             *
             *     126 = PreviouslyBoughtThenInStockThenWithPicture (Sort (1) by previously bought first, (2) then by products that are in stock, (3) then products with a picture.)
             *
             *     128 = MostBoughtThenWithPicture (Sort (1) by most bought, (2) then products with a picture.)
             */
            sortOrder: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchResultSortOrder"];
            /**
             * @description The option to handle models and related products.
             *
             *     0 = Default (Don't use special logic. Use this value if the implementation does not use model products.)
             *
             *     1 = ModelOnly (Search in the model products and return results based on these model products.)
             *
             *     2 = ModelViaRelated (Search in the related products, but return results based on their model products.)
             *
             *     3 = RelatedOnly (Search in the related products and return results based on these related products.)
             */
            modelsQueryType?: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.ModelsQueryType"] | null;
            /**
             * @description The ids of the properties that will be used to filter the property results.
             *     If this value is set, only property values of these properties will be returned.
             */
            restrictPropertyFilterToPropertyIdList?: number[] | null;
            /**
             * @description Gets a list of category root ids. Only categories belonging to these roots will be returned.
             *     Only used/needed if NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.ReturnCategoryFilters is `true`.
             */
            restrictCategoryFiltersToRootCategoryIdList?: number[] | null;
            /**
             * @description A flag indicating whether a property value order value (`PropertyValueOrderValue`) should be returned in the property value recordset.
             *     If set to `False`, the value returned in that field will always be 0.
             */
            returnPropertyValueOrderValue?: boolean | null;
            /**
             * @description The filter types to return.
             *     When a filter type is set, this will trigger the product search to return
             *     whether there are items within the result set that can be further filtered
             *     with the supplied filter type.
             *     Default is `None`.
             *
             *     0 = None (No filter.)
             *
             *     1 = PromoType (Indicates filtering on promotion type (e.g. new product).)
             *
             *     2 = StockProduct (Indicates filtering on stock.)
             *
             *     4 = FavoritesForCustomer (Indicates filtering on favorites for customer.)
             *
             *     8 = FavoritesForPerson (Indicates filtering on favorites for customer.)
             *
             *     16 = ProductsBoughtByCustomer (Indicates filtering on product that were bought by customer.)
             *
             *     32 = CustomerProductCode (Indicates filtering on products that have a customer specific product code.)
             */
            returnFilterType?: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.SearchFilterType"] | null;
            /**
             * Format: int32
             * @description The currency id.
             *     A valid value is required when sorting by price.
             */
            currencyId?: number | null;
            /**
             * @description An implementation-specific JSON value containing settings and options to be used in the data store.
             *     This can include directions for an extra join with a custom table, specific sorting options, etc...
             */
            customQueryParameters?: string | null;
            /**
             * @description The caching hint.
             *
             *     0 = AnonymousOnly (Allow cache for anonymous users. Don't cache for authenticated users. This is the default setting.)
             *
             *     1 = Disabled (Disabled caching for anonymous users and authenticated users.)
             *
             *     2 = AnonymousAndAuthenticated (Allow caching for anonymous and authenticated users. Use with caution, as this might lead to many cache items.)
             */
            caching: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchResultCaching"];
        };
        /**
         * Format: int32
         * @description Hint for product search caching.
         *     Caching and the duration of the cache is managed by the service layer.
         *
         *     0 = AnonymousOnly (Allow cache for anonymous users. Don't cache for authenticated users. This is the default setting.)
         *
         *     1 = Disabled (Disabled caching for anonymous users and authenticated users.)
         *
         *     2 = AnonymousAndAuthenticated (Allow caching for anonymous and authenticated users. Use with caution, as this might lead to many cache items.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchResultCaching": NatchOSPlanktonImplementationModelsProductSearchProductSearchResultCaching;
        /**
         * Format: int32
         * @description Defines the options for sorting the product ID list for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.
         *
         *     0 = NotSet (No specific order. Best performance.)
         *
         *     11 = ScoreDescending (Sort by search engine score descending (highest score first).)
         *
         *     12 = ProductNumberAscending (Sort alphabetically by product number ascending.)
         *
         *     13 = ProductNumberDescending (Sort alphabetically by product number descending.)
         *
         *     14 = ProductNameAscending (Sort alphabetically by product name (from translation) ascending.)
         *
         *     15 = ProductNameDescending (Sort alphabetically by product name (from translation) descending.)
         *
         *     16 = PreviouslyBoughtThenPromoThenProductNumber (Sort (1) by previously bought first, (2) then by the order value of the promotion type, (3) then by product number ascending (alphabetically).)
         *
         *     18 = PreviouslyBoughtThenPromoThenProductName (Sort (1) by previously bought first, (2) then by the order value of the promotion type, (3) then by product name ascending (alphabetically).)
         *
         *     20 = PreviouslyBoughtThenProductNumber (Sort (1) by previously bought first, (2) then by product number ascending (alphabetically).)
         *
         *     22 = PreviouslyBoughtThenProductName (Sort (1) by previously bought first, (2) then by product name ascending (alphabetically).)
         *
         *     24 = InStockThenProductNumber (Sort (1) by products that are in stock first, (2) then by product number ascending (alphabetically).)
         *
         *     26 = PreviouslyBoughtThenInStock (Sort (1) by previously bought first, (2) then by products that are in stock.)
         *
         *     28 = MostBought (Sort (1) by most bought.)
         *
         *     30 = Personalized (A customer's personalized sort order of the search results.)
         *
         *     32 = TimesBoughtAscending (Order by number of times bought.)
         *
         *     33 = TimesBoughtDescending (Order by number of times bought.)
         *
         *     34 = LastTimeBoughtAscending (Order by last time bought.)
         *
         *     35 = LastTimeBoughtDescending (Order by last time bought.)
         *
         *     40 = PriceAscending (Order by ascending price.)
         *
         *     41 = PriceDescending (Order by descending price.)
         *
         *     42 = CustomerProductCodeAscending (Order by customer product code ascending.)
         *
         *     43 = CustomerProductCodeDescending (Order by customer product code descending.)
         *
         *     44 = ProductCodeAscending (Order by product code ascending.)
         *
         *     45 = ProductCodeDescending (Order by product code descending.)
         *
         *     100 = Random (Explicitly randomize the results.)
         *
         *     112 = PersonalizedThenProductNumberAscending (Order by a personalized sort order and product number ascending. Combination of NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchResultSortOrder.Personalized followed by NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchResultSortOrder.ProductNameAscending.)
         *
         *     126 = PreviouslyBoughtThenInStockThenWithPicture (Sort (1) by previously bought first, (2) then by products that are in stock, (3) then products with a picture.)
         *
         *     128 = MostBoughtThenWithPicture (Sort (1) by most bought, (2) then products with a picture.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchResultSortOrder": NatchOSPlanktonImplementationModelsProductSearchProductSearchResultSortOrder;
        /** @description Property value filter data transfer object. */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.PropertyValueFilterDto": {
            /**
             * Format: int32
             * @description The property id.
             */
            propertyId: number;
            /**
             * Format: int32
             * @description The property value id.
             */
            propertyValueId: number;
        };
        /**
         * @description Represents an available filter in a product search.
         *     When receiving a result set from product search,
         *     the values in this class represent what kind of filters
         *     can be used to further filter the results.
         */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.Results.AvailableFilterResult": {
            /**
             * @description The search filter type.
             *
             *     0 = None (No filter.)
             *
             *     1 = PromoType (Indicates filtering on promotion type (e.g. new product).)
             *
             *     2 = StockProduct (Indicates filtering on stock.)
             *
             *     4 = FavoritesForCustomer (Indicates filtering on favorites for customer.)
             *
             *     8 = FavoritesForPerson (Indicates filtering on favorites for customer.)
             *
             *     16 = ProductsBoughtByCustomer (Indicates filtering on product that were bought by customer.)
             *
             *     32 = CustomerProductCode (Indicates filtering on products that have a customer specific product code.)
             */
            filterType: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.SearchFilterType"];
            /**
             * Format: int32
             * @description The search filter subtype.
             */
            filterSubType: number;
        };
        /** @description An option for a category filter in a product search. */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.Results.CategoryFilterResult": {
            /**
             * Format: int32
             * @description The ID of the category in the repository.
             */
            categoryId: number;
            /**
             * Format: int64
             * @description The number of online products in the result set for the category and all of its descendants.
             *     A product is online if the NatchOS.Plankton.ImplementationModels.Product.IsOnline flag is set to `true`.
             *     The value can be null if the product count was not calculated during the product search.
             */
            onlineProductCountSubtree?: number | null;
            /**
             * @description A value indicating if the category or its descendants contain online products.
             *     A product is online if the NatchOS.Plankton.ImplementationModels.Product.IsOnline flag is set to `true`.
             */
            hasOnlineProducts: boolean;
        };
        /** @description Defines a result of the product search. */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.Results.ProductIdResult": {
            /**
             * Format: int32
             * @description The ID of the product in the repository.
             */
            productId: number;
            /**
             * Format: int64
             * @description The sort order value of the result within the set.
             */
            sortOrder: number;
            /**
             * Format: double
             * @description The rank of the result based on FTS.
             */
            ftsRank?: number | null;
            /**
             * Format: double
             * @description The optional rank of the result based on vector search.
             */
            vectorRank?: number | null;
        };
        /**
         * @description A facet filter for a property in a product search.
         *     Contains property values.
         */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.Results.PropertyFilter": {
            /**
             * Format: int32
             * @description The ID of the property in the repository.
             */
            propertyId: number;
            /**
             * Format: int32
             * @description The sort order for this value.
             */
            sortOrder?: number | null;
            /**
             * @description The type of the property value.
             *
             *     0 = NotSet (Value not set.)
             *
             *     1 = Text (A textual value. Stored in NatchOS.Plankton.ImplementationModels.PropertyValueTranslation.TextValue.)
             *
             *     2 = NumericValue (A numerical value, integer or decimal.)
             *
             *     4 = Boolean (A boolean value, stored as numeric 0 or 1.)
             */
            valueType: components["schemas"]["NatchOS.Plankton.ImplementationModels.PropertyValueType"];
            /**
             * @description The values.
             *     Not explicitly sorted. Sorting is done by the caller.
             */
            values: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.Results.PropertyFilterValue"][];
            /**
             * Format: int32
             * @description The optional id of the property class this property falls under.
             */
            propertyClassId?: number | null;
            /** @description The internal name. */
            internalName: string;
            displayName: string;
            /**
             * @description The type of the property filter.
             *
             *     0 = NotSet (Value not set.)
             *
             *     1 = Intersect (Evaluated as an `AND` operator within the property values. Selecting more values/options within the same property may reduce results. This was formerly known as 'Single'.)
             *
             *     2 = Union (Evaluated as an `OR` operator within the property values. Selecting more values/options within the same property may increase results. This was formerly known as 'Multi'.)
             *
             *     3 = Range (A selection of a range.)
             */
            filterType: components["schemas"]["NatchOS.Plankton.ImplementationModels.PropertyFilterType"];
        };
        /** @description An option for a property filter in a product search. */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.Results.PropertyFilterValue": {
            /**
             * Format: int32
             * @description The ID of the property value in the repository.
             */
            propertyValueId: number;
            /**
             * Format: int32
             * @description The number of products in the result set that are linked to the property value.
             */
            count: number;
            /**
             * Format: int32
             * @description The number of products linked to the property value, but excluding the current property as a filter.
             *     If this value is set, it should be used over NatchOS.Plankton.ImplementationModels.ProductSearch.Results.PropertyFilterValue.Count.
             */
            countActive?: number | null;
            /**
             * Format: int64
             * @description The sort order for this value.
             */
            sortOrder: number;
            /**
             * Format: double
             * @description The optional numeric value.
             */
            numericValue?: number | null;
            /** @description The optional boolean value. */
            booleanValue?: boolean | null;
            /** @description The optional text value. */
            textValue?: string | null;
        };
        /** @description Results for a product search. */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.Results.SearchResults": {
            /**
             * @description The type of search that was performed.
             *
             *     0 = DrillDown (A drill-down in category.)
             *
             *     1 = TextSearch (Perform a textual search.)
             *
             *     2 = ProductIdentifier (Search in all the product identifiers.)
             *
             *     3 = FilterSearch (Search in all products, with one or more filters enabled.)
             */
            searchType: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType"];
            /**
             * Format: int32
             * @description The number of products that match the criteria.
             *     This will take into account the NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.MaximumProductResults off the criteria.
             */
            resultCount: number;
            /**
             * Format: int32
             * @description The optional page count for the result set.
             *     Will only be calculated if page size was set in the search criteria.
             */
            pageCount?: number | null;
            /**
             * Format: int32
             * @description The optional page size for the result set.
             */
            pageSize?: number | null;
            /**
             * Format: int32
             * @description The total elapsed time measured for the SQL call to perform the search, in milliseconds.
             */
            elapsedMilliseconds: number;
            /**
             * @description The products per page number, starting with 1.
             *     Only available if NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.ReturnProductIdList was `true`
             *     and NatchOS.Plankton.ImplementationModels.ProductSearch.Results.SearchResults.SearchType was not NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.ProductIdentifier.
             */
            pagedProducts: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.Results.ProductIdResult"][];
            };
            /**
             * @description The available property filters within the result set.
             *     Already sorted by the sort order value of the property.
             *     Only available if NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.ReturnPropertyFilters was `true`.
             */
            readonly propertyFilters: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.Results.PropertyFilter"][];
            /**
             * @description Gets available category filters within the result set.
             *     Only available if NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.ReturnCategoryFilters was `true`.
             */
            readonly categoryFilters: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.Results.CategoryFilterResult"][];
            /**
             * @description The available filter types within the result set.
             *     Only available if NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.ReturnFilterType was set to a value greater than 0.
             */
            readonly availableFilterTypes: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.Results.AvailableFilterResult"][];
        };
        /**
         * Format: int32
         * @description Defines the additional filter capabilities for which can be queried while
         *     performing a product search.
         *
         *     0 = None (No filter.)
         *
         *     1 = PromoType (Indicates filtering on promotion type (e.g. new product).)
         *
         *     2 = StockProduct (Indicates filtering on stock.)
         *
         *     4 = FavoritesForCustomer (Indicates filtering on favorites for customer.)
         *
         *     8 = FavoritesForPerson (Indicates filtering on favorites for customer.)
         *
         *     16 = ProductsBoughtByCustomer (Indicates filtering on product that were bought by customer.)
         *
         *     32 = CustomerProductCode (Indicates filtering on products that have a customer specific product code.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.SearchFilterType": NatchOSPlanktonImplementationModelsProductSearchSearchFilterType;
        /**
         * Format: int32
         * @description Defines the origins in the implementation for a product search.
         *     Matches `ProductSearchType` in the database.
         *
         *     0 = NotSet (Not set.)
         *
         *     1 = Scanning (Search in identifiers after scanning a product bar code. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.ProductIdentifier. Can be set automatically as the default value in !:ProductIdentifierSearchCriteria constructor.)
         *
         *     2 = TextSearch (Textual search in products. Is set automatically as the default value in NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria constructor with a search term. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.TextSearch.)
         *
         *     3 = DrillDown (Search under a category as part of a drill down. Is set automatically as the default value in NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria constructor with a category. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.DrillDown.)
         *
         *     4 = QuickEntry (Search in identifiers Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.ProductIdentifier. Can be set automatically as the default value in !:ProductIdentifierSearchCriteria constructor.)
         *
         *     5 = ProductPage (Search from a product page, i.e. get all promotions. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.DrillDown. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.)
         *
         *     6 = AutoComplete (Search for autocomplete in search text box. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.TextSearch. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.)
         *
         *     7 = Sitemap (Search for building the sitemap.xml content. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.DrillDown and NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.TextSearch. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.)
         *
         *     8 = External (Search from an external source, like a webservice or API. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.DrillDown and NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.TextSearch. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.)
         *
         *     9 = Category (Get category id's with product counts optionally specific for a customer. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.)
         *
         *     10 = PriceList (Use the product search to get the product id's for a pricelist. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.)
         *
         *     11 = FilterSearch (Use the product search to filter a list of products. Is set automatically as the default value for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria constructor with a product ID list.)
         *
         *     12 = ZeroResultsFallbackRetry (In cases where a user-initiated product search returns no results, the system automatically generates and executes a refined query (e.g., via typo correction, normalization, or reformulation) to improve result retrieval.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.SearchOrigin": NatchOSPlanktonImplementationModelsProductSearchSearchOrigin;
        /**
         * Format: int32
         * @description Defines the types of product searches for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.
         *
         *     0 = DrillDown (A drill-down in category.)
         *
         *     1 = TextSearch (Perform a textual search.)
         *
         *     2 = ProductIdentifier (Search in all the product identifiers.)
         *
         *     3 = FilterSearch (Search in all products, with one or more filters enabled.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType": NatchOSPlanktonImplementationModelsProductSearchSearchType;
        /** @description Search suggestion based on a category. */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.Suggestions.CategorySuggestion": {
            /**
             * Format: int32
             * @description The ID of the suggested category.
             */
            categoryId: number;
            /** @description The name of the suggested category. */
            categoryName: string;
            /**
             * Format: int32
             * @description The root category ID of the suggested category.
             */
            rootCategoryId: number;
            /**
             * Format: int32
             * @description The weight of the result in relation to the other results.
             *     Should be used for sorting. Higher value is more important.
             */
            autoCompleteWeight: number;
        };
        /** @description Represents a custom suggestion object used within the product search suggestions context. */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.Suggestions.CustomSuggestion": {
            /** @description The text associated with the custom suggestion. */
            text: string;
        };
        /** @description Represents the results of search suggestions, including text suggestions, category suggestions, and custom suggestions. */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.Suggestions.SearchSuggestionResults": {
            /** @description The text-based suggestions. */
            readonly textSuggestions: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.Suggestions.TextSuggestion"][];
            /** @description The category suggestions. */
            readonly categorySuggestions: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.Suggestions.CategorySuggestion"][];
            /** @description The custom suggestions. */
            readonly customSuggestions: components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.Suggestions.CustomSuggestion"][];
        };
        /** @description Represents a suggestion for text-based search queries. */
        "NatchOS.Plankton.ImplementationModels.ProductSearch.Suggestions.TextSuggestion": {
            /** @description The text associated with the suggestion. */
            text: string;
            /** @description A value indicating whether the suggestion originates from personal history. */
            isFromHistory: boolean;
        };
        /** @description Combination of the warehouse and the stock count for a product. */
        "NatchOS.Plankton.ImplementationModels.ProductStock": {
            /**
             * Format: int32
             * @description The warehouse id.
             */
            warehouseId: number;
            /** @description The internal name of the warehouse. */
            warehouseInternalName: string;
            /**
             * Format: double
             * @description The actual stock count.
             *     As alternative to the actual stock, see NatchOS.Plankton.ImplementationModels.ProductStock.StockIndication.
             */
            stockCount?: number | null;
            /**
             * @description The stock indication.
             *     An alternative to the actual stock in NatchOS.Plankton.ImplementationModels.ProductStock.StockCount.
             */
            stockIndication?: string | null;
        };
        /** @description Defines store-specific data that is attached to a product. */
        "NatchOS.Plankton.ImplementationModels.ProductStoreData": {
            /**
             * Format: int32
             * @description The identifier of the store.
             */
            storeId: number;
            /**
             * Format: double
             * @description The transport cost of this product in the store. Can be NULL.
             */
            transportCost?: number | null;
            /**
             * Format: double
             * @description Shipping of this product is free if the basket amount is at least this large. Can be NULL.
             */
            minimumAmountFreeShipping?: number | null;
            /**
             * Format: int32
             * @description The number of days needed to transfer this product between warehouses. Can be NULL.
             */
            transferLeadTimeInDays?: number | null;
            /**
             * Format: int32
             * @description The id of the promotion type.
             */
            promotionTypeId?: number | null;
        };
        /** @description Defines the translation of a NatchOS.Plankton.ImplementationModels.Product. */
        "NatchOS.Plankton.ImplementationModels.ProductTranslation": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The name. */
            name: string;
            /** @description The description. */
            description?: string | null;
            /** @description The miscellaneous XML with extra data. */
            miscXml?: string | null;
        };
        "NatchOS.Plankton.ImplementationModels.Property": {
            /**
             * Format: int32
             * @description The id of the property in the repository.
             */
            id: number;
            /**
             * Format: int32
             * @description The optional id of the property class this property falls under.
             */
            propertyClassId?: number | null;
            /** @description The internal name. */
            internalName: string;
            /**
             * @description The type of the property value.
             *
             *     0 = NotSet (Value not set.)
             *
             *     1 = Text (A textual value. Stored in NatchOS.Plankton.ImplementationModels.PropertyValueTranslation.TextValue.)
             *
             *     2 = NumericValue (A numerical value, integer or decimal.)
             *
             *     4 = Boolean (A boolean value, stored as numeric 0 or 1.)
             */
            propertyValueType: components["schemas"]["NatchOS.Plankton.ImplementationModels.PropertyValueType"];
            /**
             * @description The type of the property filter.
             *
             *     0 = NotSet (Value not set.)
             *
             *     1 = Intersect (Evaluated as an `AND` operator within the property values. Selecting more values/options within the same property may reduce results. This was formerly known as 'Single'.)
             *
             *     2 = Union (Evaluated as an `OR` operator within the property values. Selecting more values/options within the same property may increase results. This was formerly known as 'Multi'.)
             *
             *     3 = Range (A selection of a range.)
             */
            propertyFilterType: components["schemas"]["NatchOS.Plankton.ImplementationModels.PropertyFilterType"];
            /** @description A value indicating whether this property must be shown with the product information. */
            showAsProductSpecification: boolean;
            /** @description A value indicating whether this property can be used as a filter for products. */
            useAsFilter: boolean;
            /**
             * @description A value indicating whether this property should be included in the search index (e.g. Full-Text Search in SQL or Azure Search).
             *     The NatchOS.Plankton.ImplementationModels.Property.PropertyValueType is expected to be NatchOS.Plankton.ImplementationModels.PropertyValueType.Text.
             */
            includeInSearchIndex: boolean;
            /**
             * Format: int32
             * @description The optional sort order value to sort properties.
             */
            sortOrderValue?: number | null;
            /** @description The translations, indexed by two-letter language code. */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.PropertyTranslation"];
            };
            /** @description The miscellaneous XML with extra data. */
            miscXml?: string | null;
        };
        /** @description Defines the class of a NatchOS.Plankton.ImplementationModels.Property. */
        "NatchOS.Plankton.ImplementationModels.PropertyClass": {
            /**
             * Format: int32
             * @description The ID of the property class in the repository.
             */
            id: number;
            /** @description The internal name. */
            internalName: string;
            /**
             * Format: int32
             * @description The optional sort order value to sort classes.
             */
            sortOrderValue?: number | null;
            /** @description The translations, indexed by two-letter language code. */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.PropertyClassTranslation"];
            };
            /** @description The miscellaneous XML with extra data. */
            miscXml?: string | null;
        };
        /** @description Defines the translation of a NatchOS.Plankton.ImplementationModels.PropertyClass. */
        "NatchOS.Plankton.ImplementationModels.PropertyClassTranslation": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The name. */
            name: string;
            /** @description The description. */
            description?: string | null;
            /** @description The miscellaneous XML with extra data. */
            miscXml?: string | null;
        };
        /**
         * Format: int32
         * @description Defines the filter implementation of the NatchOS.Plankton.ImplementationModels.Property for the UI.
         *
         *     0 = NotSet (Value not set.)
         *
         *     1 = Intersect (Evaluated as an `AND` operator within the property values. Selecting more values/options within the same property may reduce results. This was formerly known as 'Single'.)
         *
         *     2 = Union (Evaluated as an `OR` operator within the property values. Selecting more values/options within the same property may increase results. This was formerly known as 'Multi'.)
         *
         *     3 = Range (A selection of a range.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.PropertyFilterType": NatchOSPlanktonImplementationModelsPropertyFilterType;
        /** @description Defines the translation of a NatchOS.Plankton.ImplementationModels.Property. */
        "NatchOS.Plankton.ImplementationModels.PropertyTranslation": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The name. */
            name: string;
            /** @description The description. */
            description?: string | null;
            /** @description The miscellaneous XML with extra data. */
            miscXml?: string | null;
        };
        /**
         * @description Defines a value for a NatchOS.Plankton.ImplementationModels.Property.
         *     See the NatchOS.Plankton.ImplementationModels.Property this value is attached to for information about the type and usage in the implementation.
         */
        "NatchOS.Plankton.ImplementationModels.PropertyValue": {
            /**
             * Format: int32
             * @description The ID of the property value in the repository.
             */
            id: number;
            /**
             * Format: int32
             * @description The property (specification) identifier.
             */
            propertyId: number;
            /**
             * @description The type of the property value.
             *
             *     0 = NotSet (Value not set.)
             *
             *     1 = Text (A textual value. Stored in NatchOS.Plankton.ImplementationModels.PropertyValueTranslation.TextValue.)
             *
             *     2 = NumericValue (A numerical value, integer or decimal.)
             *
             *     4 = Boolean (A boolean value, stored as numeric 0 or 1.)
             */
            propertyValueType: components["schemas"]["NatchOS.Plankton.ImplementationModels.PropertyValueType"];
            /** @description The optional language independent textual value. */
            textValue?: string | null;
            /**
             * Format: double
             * @description The optional numeric value.
             */
            numericValue?: number | null;
            /**
             * @description The optional boolean value.
             *     Determined from the numeric value if the NatchOS.Plankton.ImplementationModels.PropertyValue.PropertyValueType is NatchOS.Plankton.ImplementationModels.PropertyValueType.Boolean.
             */
            readonly booleanValue?: boolean | null;
            /**
             * @description The translations of the textual value.
             *     Translations are optional.
             */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.PropertyValueTranslation"];
            };
            /** @description The miscellaneous data in XML format. */
            miscXml?: string | null;
        };
        /** @description Contains the language specific text value of a NatchOS.Plankton.ImplementationModels.PropertyValue. */
        "NatchOS.Plankton.ImplementationModels.PropertyValueTranslation": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The textual value. */
            textValue: string;
            /** @description The miscellaneous data in XML format. */
            miscXml?: string | null;
        };
        /**
         * Format: int32
         * @description Defines the values that a NatchOS.Plankton.ImplementationModels.Property and NatchOS.Plankton.ImplementationModels.PropertyValue can have.
         *
         *     0 = NotSet (Value not set.)
         *
         *     1 = Text (A textual value. Stored in NatchOS.Plankton.ImplementationModels.PropertyValueTranslation.TextValue.)
         *
         *     2 = NumericValue (A numerical value, integer or decimal.)
         *
         *     4 = Boolean (A boolean value, stored as numeric 0 or 1.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.PropertyValueType": NatchOSPlanktonImplementationModelsPropertyValueType;
        /**
         * Format: int32
         * @description The relation types which can be used to create relations between an origin product and a related product.
         *     Relation types that are the reverse of another one should have an ID of the base type + 100.
         *
         *     1 = HasAlternative (The related product is an alternative to the origin product.)
         *
         *     2 = FrequentlyBoughtTogetherWith (The related product appears frequently in the same order as the origin product.)
         *
         *     3 = CustomersWhoBoughtThisAlsoBought (The related product is often bought by the same customer who bought origin product.)
         *
         *     4 = MandatoryIncludes (The related product is mandatory included in a sale of origin product.)
         *
         *     5 = HasAccessory (The related product is an accessory of the origin product.)
         *
         *     6 = IsModelOf (The origin product is the model for the related product.)
         *
         *     7 = IsInSameSeries (The origin product belongs to the same series of products as the related product.)
         *
         *     8 = HasReplacement (The related product is a replacement for the origin product. This is the reverse of NatchOS.Plankton.ImplementationModels.RelationType.IsReplacementOf.)
         *
         *     9 = TemporaryHasAlternative (Time bound (by range) version of NatchOS.Plankton.ImplementationModels.RelationType.HasAlternative.)
         *
         *     10 = Basic (The related product has a basic relation to the origin product, without any specific meaning.)
         *
         *     11 = SuggestedIncludes (The related product is a highly recommended accessory.)
         *
         *     12 = ContainsSubassembly (The related product is a subassembly of the origin product. I.e. a BOM definition, the product that is bought is built out of several other products.)
         *
         *     13 = HasCheaperAlternative (The related product is a cheaper alternative to the original product.)
         *
         *     70 = HasHighlyAdvisedAccessory (The related product is an important accessory of the origin product.)
         *
         *     106 = IsVariantOf (The origin product is a variant of the related product (model). This is the opposite of NatchOS.Plankton.ImplementationModels.RelationType.IsModelOf.)
         *
         *     108 = IsReplacementOf (The origin product is a replacement of the related product. This is the opposite of NatchOS.Plankton.ImplementationModels.RelationType.HasReplacement.)
         * @enum {integer}
         */
        "NatchOS.Plankton.ImplementationModels.RelationType": NatchOSPlanktonImplementationModelsRelationType;
        /** @description Defines a sector to which a customer can be attached. */
        "NatchOS.Plankton.ImplementationModels.Sector": {
            /**
             * Format: int32
             * @description The identifier of the sector.
             */
            id: number;
            /**
             * @description The code of the sector from the master data.
             *     May only be used to communicate with master data.
             *     Don't use this value in front-end.
             */
            code: string;
            /** @description The internal name. */
            internalName: string;
            /**
             * @description The list of store identifiers the sector is attached to.
             *     Only available in multi-store implementations.
             */
            readonly storeIdList: number[];
            /** @description The translations, indexed by two-letter language code. */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.SectorTranslation"];
            };
            /** @description The miscellaneous data in XML format. */
            miscXml?: string | null;
        };
        /** @description Defines the translation of a sector. */
        "NatchOS.Plankton.ImplementationModels.SectorTranslation": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The name. */
            name: string;
            /** @description The description. */
            description?: string | null;
            /** @description The miscellaneous XML with extra data. */
            miscXml?: string | null;
        };
        /** @description Shipping address attached to a NatchOS.Plankton.ImplementationModels.Customer. */
        "NatchOS.Plankton.ImplementationModels.ShippingAddress": {
            /** @description The primary address line. */
            addressLine1: string;
            /** @description The secondary address line. */
            addressLine2?: string | null;
            /** @description The postal code. */
            postalCode: string;
            /** @description The city. */
            city: string;
            /**
             * Format: int32
             * @description The country id.
             */
            countryId: number;
            /** @description The two-letter country code (ISO 3166-1 alpha-2). */
            countryCode: string;
            /**
             * Format: int32
             * @description The id of the shipping address in the data store.
             */
            id: number;
            /**
             * @description The code of the NatchOS.Plankton.ImplementationModels.ShippingAddress from the master data.
             *     May only be used to communicate with master data.
             *     Don't use this value in front-end.
             */
            code: string;
            /** @description The name. */
            name?: string | null;
            /** @description The secondary name. */
            name2?: string | null;
            /** @description A value indicating whether this instance is main shipping address. */
            isMainShippingAddress: boolean;
            /**
             * Format: int32
             * @description The culture identifier.
             */
            lcid: number;
            /** @description The email. */
            emailAddress?: string | null;
            /** @description The regular phone number. */
            phoneNumber?: string | null;
            /** @description The mobile phone number. */
            phoneNumberMobile?: string | null;
            /**
             * Format: int32
             * @description The customer id.
             */
            customerId: number;
            /**
             * Format: int32
             * @description The primary contact person id.
             */
            primaryContactPersonId?: number | null;
            /**
             * Format: int32
             * @description The shipping time in days.
             */
            shippingTimeInDays?: number | null;
            /**
             * Format: int32
             * @description The technical key of the department the shipping address is linked to.
             */
            departmentId?: number | null;
            /**
             * Format: int32
             * @description The shipping advice id.
             *     Full support for this will be implemented in a later version.
             *     For now use an enum in the implementation.
             */
            shippingAdviceId?: number | null;
            /**
             * @description The external data (data from other systems than the master) attached to the product.
             *     This data will be loaded when `AddExternalData` is set to true.
             */
            readonly externalData: components["schemas"]["NatchOS.Plankton.ImplementationModels.ExternalData"][];
            /** @description The miscellaneous data in XML format. */
            miscXml?: string | null;
        };
        /** @description Defines fields for a store in a multi-store implementation. */
        "NatchOS.Plankton.ImplementationModels.Store": {
            /**
             * Format: int32
             * @description The ID of the store in the repository.
             */
            id: number;
            /** @description The internal name. */
            internalName: string;
            /** @description The translations, indexed by two-letter language code. */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.StoreTranslation"];
            };
            /** @description The miscellaneous JSON with extra data. */
            miscJson?: string | null;
        };
        /** @description Contains the language-specific properties of a NatchOS.Plankton.ImplementationModels.Store. */
        "NatchOS.Plankton.ImplementationModels.StoreTranslation": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The name. */
            name: string;
            /** @description The description. */
            description?: string | null;
            /** @description The miscellaneous JSON with extra data. */
            miscJson?: string | null;
        };
        /** @description Defines a subtype for a predefined transfer type that can optionally be attached to a department. */
        "NatchOS.Plankton.ImplementationModels.TransferSubtype": {
            /**
             * Format: int32
             * @description The identifier of the transfer subtype.
             */
            id: number;
            /**
             * @description The code of the transfer subtype from the master data.
             *     May only be used to communicate with master data.
             *     Don't use this value in front-end.
             */
            code: string;
            /**
             * @description The main transfer type this subtype is linked to.
             *
             *     0 = NotSet (Not set.)
             *
             *     1 = Pickup (Buyer will pick up the order.)
             *
             *     2 = Delivery (Seller will ship the order to the buyer.)
             *
             *     3 = PickupNightLocker (Buyer will pick up the order from a night locker.)
             */
            transferType: components["schemas"]["NatchOS.Plankton.ImplementationModels.PredefinedTransferType"];
            /** @description A value indicating whether this transfer subtype is online and can be used. */
            isOnline: boolean;
            /**
             * Format: int32
             * @description The identifier of the optional NatchOS.Plankton.ImplementationModels.Department linked to this transfer subtype.
             */
            departmentId?: number | null;
            /**
             * @description The list of store identifiers the transfer subtype is attached to.
             *     Only available in multi-store implementations.
             */
            readonly storeIdList: number[];
            /** @description The translations, indexed by two-letter language code. */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.TransferSubtypeTranslation"];
            };
            /** @description The miscellaneous JSON with extra data. */
            miscJson?: string | null;
        };
        /** @description Contains the language-specific properties of the NatchOS.Plankton.ImplementationModels.TransferSubtype. */
        "NatchOS.Plankton.ImplementationModels.TransferSubtypeTranslation": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The name. */
            name: string;
            /** @description The description. */
            description?: string | null;
            /** @description The miscellaneous JSON with extra data. */
            miscJson?: string | null;
        };
        /** @description Defines the default translation fields. */
        "NatchOS.Plankton.ImplementationModels.TranslationsBase.EntityTranslationWithMiscXml": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The name. */
            name: string;
            /** @description The description. */
            description?: string | null;
            /** @description The miscellaneous XML with extra data. */
            miscXml?: string | null;
        };
        /** @description Contains the language specific name of the entity/meta. */
        "NatchOS.Plankton.ImplementationModels.TranslationsBase.MetaTranslationWithName": {
            /** Format: int32 */
            lcid: number;
            /** @description The name. */
            name: string;
        };
        /** @description Defines a unit of measure. */
        "NatchOS.Plankton.ImplementationModels.UnitOfMeasure": {
            /**
             * Format: int32
             * @description The id of the unit of measure in the repository.
             */
            id: number;
            /** @description The code of the unit of measure. */
            code: string;
            /** @description The internal name. */
            internalName: string;
            /** @description The translations, indexed by two-letter language code. */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.UnitOfMeasureTranslation"];
            };
        };
        /** @description Contains the language specific properties of the NatchOS.Plankton.ImplementationModels.UnitOfMeasure. */
        "NatchOS.Plankton.ImplementationModels.UnitOfMeasureTranslation": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The name. */
            name: string;
            /** @description The description. */
            description?: string | null;
            /** @description The miscellaneous XML with extra data. */
            miscXml?: string | null;
            /**
             * @description The plural form of the name.
             *     When no value is available in the database, the value of NatchOS.Plankton.ImplementationModels.TranslationsBase.EntityTranslationWithMiscXml.Name will be used.
             */
            pluralName: string;
        };
        /** @description Contains the updatable properties of a basket header for update operations. */
        "NatchOS.Plankton.ImplementationModels.UpdateBasketHeaderRequest": {
            /** @description The shipping address to deliver the products to in case the transfer type is a delivery. */
            shippingAddress: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketAddress"];
            /**
             * @description The shipping advice as an enum.
             *     This defines how complete the quantities for the ordered products must be before fulfillment of the order (or partial orders).
             *
             *     0 = NotSet (Not set.)
             *
             *     1 = Partial (The order can be split up, ie. per product or even per smaller quantities of a single product.)
             *
             *     2 = CompleteOrderLines (The order can be split up, but every order line must be complete (quantity).)
             *
             *     3 = Complete (The order will be fulfilled once, when all products are available.)
             */
            shippingAdvice: components["schemas"]["NatchOS.Plankton.ImplementationModels.PredefinedShippingAdvice"];
            /**
             * Format: double
             * @description The gross shipping cost.
             */
            shippingCostGrossVatExcluded?: number | null;
            /**
             * Format: double
             * @description The net shipping cost.
             */
            shippingCostNetVatExcluded?: number | null;
            /** @description The transfer to fields. */
            transferTo: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketPerson"];
            /**
             * @description The transfer type as an enum.
             *     Transfer types is a fixed list for all implementations.
             *
             *     0 = NotSet (Not set.)
             *
             *     1 = Pickup (Buyer will pick up the order.)
             *
             *     2 = Delivery (Seller will ship the order to the buyer.)
             *
             *     3 = PickupNightLocker (Buyer will pick up the order from a night locker.)
             */
            transferType: components["schemas"]["NatchOS.Plankton.ImplementationModels.PredefinedTransferType"];
            /**
             * Format: int32
             * @description The technical key of the transfer subtype, fex. all possible pickup locations.
             */
            transferSubTypeId?: number | null;
            /**
             * Format: date-time
             * @description The optional date chosen by the shopper on which the products will be transferred. (picked up or delivered).
             */
            transferDate?: string | null;
            /** @description The reference of the shopper(person) for this basket. */
            reference?: string | null;
            /** @description The instruction by the shopper(person) concerning this basket. */
            instructions?: string | null;
            /** @description The info supplied by the shopper(person) for this basket. */
            info?: string | null;
            /** @description The miscellaneous JSON with extra data. */
            miscJson?: string | null;
            /**
             * @description A flag indicating if the shipping address is the same as the invoice address.
             *     Should only be used for anonymous baskets.
             */
            isShippingAddressSameAsInvoiceAddress: boolean;
        };
        /** @description Represents the physical location where products are stored. */
        "NatchOS.Plankton.ImplementationModels.Warehouse": {
            /**
             * Format: int32
             * @description The id of the warehouse in the repository.
             */
            id: number;
            /** @description The code of the warehouse. */
            code: string;
            /** @description The internal name. */
            internalName: string;
            /** @description A value indicating whether this NatchOS.Plankton.ImplementationModels.WebRole is availlable for an internal NatchOS.Plankton.ImplementationModels.Person (employee). */
            isInternal: boolean;
            /**
             * @description A value indicating whether this warehouse is a primary warehouse.
             *     There can be multiple primary warehouses.
             */
            isPrimaryWarehouse: boolean;
            /** @description A value indicating whether this warehouse should be included when listing NatchOS.Plankton.ImplementationModels.ProductStock. */
            includeInStockOverview: boolean;
            /**
             * Format: int32
             * @description The technical key of the department the warehouse is attached to.
             */
            departmentId: number;
            /**
             * @description The address.
             *     This is optional.
             *     Always returns an instance.
             */
            address: components["schemas"]["NatchOS.Plankton.ImplementationModels.AddressLoose"];
            /**
             * Format: int32
             * @description The Predefined CultureInfo identifier for the warehouse.
             */
            lcid?: number | null;
            /** @description The translations, indexed by two-letter language code. */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.WarehouseTranslation"];
            };
            /** @description The miscellaneous data in XML format. */
            miscXml?: string | null;
        };
        /** @description Defines the translation of a department. */
        "NatchOS.Plankton.ImplementationModels.WarehouseTranslation": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The name. */
            name: string;
            /** @description The description. */
            description?: string | null;
            /** @description The miscellaneous XML with extra data. */
            miscXml?: string | null;
        };
        /**
         * @description Defines a role to which a NatchOS.Plankton.ImplementationModels.Person can belong.
         *     A role has rights attached to it for granular security.
         */
        "NatchOS.Plankton.ImplementationModels.WebRole": {
            /**
             * Format: int32
             * @description The id of the person in the repository.
             */
            id: number;
            /** @description The code of the web role. */
            code: string;
            /** @description The internal name. */
            internalName: string;
            /** @description A value indicating whether this NatchOS.Plankton.ImplementationModels.WebRole is available for an internal NatchOS.Plankton.ImplementationModels.Person (employee). */
            isInternal: boolean;
            /** @description A value indicating whether this NatchOS.Plankton.ImplementationModels.WebRole is available for an external NatchOS.Plankton.ImplementationModels.Person (customer). */
            isExternal: boolean;
            /**
             * Format: int32
             * @description The identifier of the store this webrole is attached to.
             */
            storeId: number;
            /** @description The translations attached to the webrole, indexed by two-letter language code. */
            readonly translations: {
                [key: string]: components["schemas"]["NatchOS.Plankton.ImplementationModels.WebRoleTranslation"];
            };
        };
        /** @description Contains the language specific properties of the NatchOS.Plankton.ImplementationModels.WebRole. */
        "NatchOS.Plankton.ImplementationModels.WebRoleTranslation": {
            /**
             * Format: int32
             * @description The culture identifier for the translation.
             */
            lcid: number;
            /** @description The name. */
            name: string;
            /** @description The description. */
            description?: string | null;
            /** @description The miscellaneous XML with extra data. */
            miscXml?: string | null;
        };
        /**
         * @description Overpack specific to a product.
         *     Defines a number of units in a pack.
         *     One product can have multiple overpacks.
         */
        Overpack: {
            overpackCode: string;
            productCode: string;
            internalName: string;
            /**
             * Format: double
             * @description The units per pack.
             *     Expressed in Sales units, NatchOS.Plankton.Models.Product.SalesUnitOfMeasureCode.
             */
            unitsPerPack: number;
            /** @description The code for the unit of measure that one overpack is in. */
            overpackUnitOfMeasureCode?: string | null;
            /**
             * @description The weight of the overpack for the product.
             *     Defined as a unit and a value.
             */
            weight?: components["schemas"]["OverpackMeasurement"] | null;
            /**
             * @description The volume of the overpack for the product.
             *     Defined as a unit and a value.
             */
            volume?: components["schemas"]["OverpackMeasurement"] | null;
            /**
             * @description The translations of the overpack.
             *     An empty list is allowed; any existing translations will be removed.
             */
            translations: components["schemas"]["BasicTranslationJsonMisc"][];
            miscJson?: string | null;
        };
        OverpackMeasurement: {
            /** @description The code for the unit of measure. */
            unitOfMeasureCode: string;
            /**
             * Format: double
             * @description The value of the measurement in the specified unit.
             *     Precision of 19 with a scale of 6.
             */
            value: number;
        };
        /**
         * @description Contains contact details of a person.
         *     Its parent is NatchOS.Plankton.Models.Customer.
         */
        Person: {
            personCode: string;
            shippingAddressCode?: string | null;
            firstName?: string | null;
            middleName?: string | null;
            lastName: string;
            initials?: string | null;
            searchName?: string | null;
            nickName?: string | null;
            /**
             * Format: int32
             * @description The language (as LCID or predefined CultureInfo identifier) of the person.
             */
            lcid: number;
            /**
             * @description The gender.
             *
             *     0 = None (Unknown or not set.)
             *
             *     1 = Male (Male gender.)
             *
             *     2 = Female (Female gender.)
             */
            gender: components["schemas"]["Gender"];
            /** @description The optional address. */
            address?: components["schemas"]["Address"] | null;
            /**
             * @description The phone numbers.
             *     This list may be empty.
             */
            phoneNumbers: components["schemas"]["PhoneNumber"][];
            /**
             * @description The username (e-mail address) for the login.
             *     The value must be unique. Duplicates will cause an error and the operation will be rolled back.
             *     The account activation flow will be triggered when the username is supplied for the first time.
             */
            username?: string | null;
            /** @description A value indicating whether this person is blocked from signing on or using the application. */
            isBlocked: boolean;
            /** Format: email */
            emailAddress: string;
            /** Format: email */
            emailAddressSecondary?: string | null;
            salespersonCode?: string | null;
            comment?: string | null;
            jobTitle?: string | null;
            organizationLevelCode?: string | null;
            /**
             * @description The web role codes per customer the person has access to.
             *     To bypass the requirement of sending web role codes, you can pass a single item
             *     with a valid customer code and web role code set to 'NONE'.
             */
            webRoles: components["schemas"]["PersonCustomerWebRoles"][];
            miscXml?: string | null;
        };
        /** @description Contains the web roles the person belongs to per specific customer. */
        PersonCustomerWebRoles: {
            /** @description The customer code. */
            customerCode: string;
            /** @description The web role codes. */
            webRoleCodes: string[];
        };
        /**
         * @description Default implementation of phone number.
         *     Phone numbers are attached to entities like NatchOS.Plankton.Models.Customer and NatchOS.Plankton.Models.Person.
         */
        PhoneNumber: {
            /**
             * @description The type of the phone number.
             *
             *     1 = Phone (Regular phone number.)
             *
             *     3 = Mobile (Mobile phone number.)
             */
            numberType: components["schemas"]["PhoneNumberType"];
            /** @description The phone number. */
            number: string;
        };
        /**
         * Format: int32
         * @description The types of phone numbers that are supported.
         *
         *     1 = Phone (Regular phone number.)
         *
         *     3 = Mobile (Mobile phone number.)
         * @enum {integer}
         */
        PhoneNumberType: PhoneNumberType;
        /** @description Contains a list of products and prices for the given price group and currency. */
        PriceGroupProductPrices: {
            /** @description The code of the price group. */
            priceGroupCode: string;
            /** @description The currency ISO code. */
            currencyIsoCode: string;
            /**
             * @description The products and their prices.
             *     An empty list is allowed; any existing prices will be removed.
             */
            products: components["schemas"]["ProductQuantityPrice"][];
        };
        /** @description Specifies a list of product prices to delete for a given price group and currency. */
        PriceGroupProductPricesDelete: {
            /** @description The code of the price group. */
            priceGroupCode: string;
            /** @description The currency ISO code. */
            currencyIsoCode: string;
            /**
             * @description The products and their prices.
             *     An empty list is allowed; any existing prices will be removed.
             */
            products: components["schemas"]["ProductQuantityPriceDelete"][];
        };
        /** @description Contains product information such as pricing, translations, measurements, etc... */
        Product: {
            /** @description The code of the product. */
            productCode: string;
            /** @description The (public) product number. */
            productNumber?: string | null;
            /** @description The internal name. */
            internalName: string;
            /** @description A value indicating whether this product is online. */
            isOnline: boolean;
            /** @description The code of the discount group of this product belongs to. */
            productDiscountGroupCode?: string | null;
            /** @description The code of the main vendor. */
            mainVendorCode?: string | null;
            /** @description The product number as which this product is known to the main vendor. */
            mainVendorProductNumber?: string | null;
            /** @description The product number as which this product is known to the producer/manufacturer. */
            producerProductNumber?: string | null;
            /**
             * @description The EAN-13 barcode digits.
             *     An EAN-13 barcode (originally European Article Number, but now renamed International Article Number even though the abbreviation EAN has been retained) is a 13 digit (12 data and 1 check) barcoding standard.
             */
            ean?: string | null;
            /**
             * Format: double
             * @description The unit price.
             *     This is the standard selling price for the product (vat excluded).
             */
            unitPrice?: number | null;
            /**
             * Format: double
             * @description The unit list price or suggested reselling price (vat excluded).
             */
            unitListPrice?: number | null;
            /**
             * Format: double
             * @description The unit cost.
             *     This is the cost price (for manufacturing or purchase) of the product (vat excluded).
             */
            unitCost?: number | null;
            /**
             * Format: int32
             * @description The average delivery time in days for the main vendor for this product.
             */
            leadTimeCalculation?: number | null;
            /**
             * Format: double
             * @description The minimum order quantity in 'sales unit'.
             */
            minimumOrderQuantity?: number | null;
            /**
             * Format: double
             * @description The incremental order quantity in 'sales unit'.
             */
            incrementalOrderQuantity?: number | null;
            /**
             * @description The intrastat code.
             *     Intrastat is the system for collecting information and producing statistics on the trade in goods between countries of the European Union (EU).
             */
            intrastatCode?: string | null;
            /** @description The code of the vat business posting group this product belongs to. */
            vatBusinessPostingGroupCode?: string | null;
            /** @description The code of the unit of measure for the measurement type 'base unit'. */
            baseUnitOfMeasureCode?: string | null;
            /** @description The code of the unit of measure for the measurement type 'sales unit'. */
            salesUnitOfMeasureCode?: string | null;
            /**
             * Format: double
             * @description The number of base units that go into one sales unit.
             */
            numberOfBaseUnitsInOneSalesUnit: number;
            /**
             * @deprecated
             * @description DEPRECATED. Property and property values should be used instead.
             *     The size of the product.
             *     Defined as a single unit and value.
             *     For specific size dimension see NatchOS.Plankton.Models.Product.SizeWidth, NatchOS.Plankton.Models.Product.SizeLength and NatchOS.Plankton.Models.Product.SizeHeight.
             */
            size?: components["schemas"]["Measurement"] | null;
            /**
             * @deprecated
             * @description DEPRECATED. Property and property values should be used instead.
             *     The size width of the product.
             *     Defined as a unit and value.
             */
            sizeWidth?: components["schemas"]["Measurement"] | null;
            /**
             * @deprecated
             * @description DEPRECATED. Property and property values should be used instead.
             *     The size length (depth) of the product.
             *     Defined as a unit and value.
             */
            sizeLength?: components["schemas"]["Measurement"] | null;
            /**
             * @deprecated
             * @description DEPRECATED. Property and property values should be used instead.
             *     The size height of the product.
             *     Defined as a unit and value.
             */
            sizeHeight?: components["schemas"]["Measurement"] | null;
            /**
             * @deprecated
             * @description DEPRECATED. Property and property values should be used instead.
             *     The volume of the product.
             *     Defined as a unit and value.
             */
            volume?: components["schemas"]["Measurement"] | null;
            /**
             * @deprecated
             * @description DEPRECATED. Property and property values should be used instead.
             *     The gross weight of the product.
             *     Defined as a unit and value.
             */
            grossWeight?: components["schemas"]["Measurement"] | null;
            /**
             * @deprecated
             * @description DEPRECATED. Property and property values should be used instead.
             *     The net weight of the product.
             *     Defined as a unit and value.
             */
            netWeight?: components["schemas"]["Measurement"] | null;
            /**
             * @deprecated
             * @description DEPRECATED. Property and property values should be used instead.
             *     Gets or sets how many items are contained in a single sales unit.
             *     Defined as a unit and value.
             */
            itemsPerSalesUnit?: components["schemas"]["Measurement"] | null;
            /** @description The code of the predefined description of the size. */
            sizeCode?: string | null;
            /** @description A value indicating whether discount is allowed for this product. */
            isDiscountAllowed: boolean;
            /** @description A value indicating whether price should not be shown and is only available on request. */
            isPriceOnRequest: boolean;
            /** @description A value indicating whether this product is a model product. */
            isModelProduct: boolean;
            /** @description A value indicating whether this product is a configurable product. */
            isConfigurable: boolean;
            /**
             * Format: int32
             * @description The id of the configurable type.
             */
            configurableTypeId?: number | null;
            miscXml?: string | null;
            /**
             * @description The translations of the product.
             *     An empty list is allowed; any existing translations will be removed.
             */
            translations: components["schemas"]["ProductTranslation"][];
        };
        /** @description Contains the root category and actual category, with optional JSON data. */
        ProductCategoryCodes: {
            /** @description The category code. */
            categoryCode: string;
            /**
             * @description The code of the category type, part of a predefined list specified per implementation.
             *     See NatchOS.Plankton.Models.Category documentation for allowed values.
             */
            categoryTypeCode: string;
            /**
             * @description The JSON that contains extra data that can not be placed in the predefined properties.
             *     Value must be escaped.
             */
            miscJson?: string | null;
        };
        /** @description Link between product and category. */
        ProductCategoryCombination: {
            /** @description The product code. */
            productCode: string;
            /**
             * @description The categories that the product is linked to.
             *     An empty list is allowed; any existing links will be removed.
             */
            categories: components["schemas"]["ProductCategoryCodes"][];
        };
        /** @description Contains the data to link a product with property values. */
        ProductPropertyValue: {
            /** @description The product code. */
            productCode: string;
            /**
             * @description The property values that the product is linked to.
             *     An empty list is currently not allowed.
             */
            propertyValues: components["schemas"]["ProductPropertyValueData"][];
        };
        /** @description A property value linked to a product. */
        ProductPropertyValueData: {
            /** @description The property value code. */
            propertyValueCode: string;
            /** @description The property code the value is attached to. */
            propertyCode: string;
        };
        /** @description Specifies a price for a product and a minimum quantity. */
        ProductQuantityPrice: {
            /** @description The product code. */
            productCode: string;
            /**
             * Format: double
             * @description The minimum quantity.
             */
            minimumQuantity: number;
            /**
             * Format: double
             * @description The price for the product and the given minimum quantity.
             */
            unitPrice: number;
            /** @description A JSON string. This should represent a valid JSON object. */
            miscellaneous?: string | null;
        };
        /** @description Specifies the product and quantity to delete a price for. */
        ProductQuantityPriceDelete: {
            /** @description The product code. */
            productCode: string;
            /**
             * Format: double
             * @description The minimum quantity.
             */
            minimumQuantity: number;
        };
        /** @description Defines a relations between a product and the related products. */
        ProductRelation: {
            /** @description The master product code. */
            masterProductCode: string;
            /**
             * @description The relations attached to the master product code.
             *     An empty list is allowed; any existing relations will be removed.
             */
            relations: components["schemas"]["Relation"][];
        };
        /** @description Contains stock information for a given product. */
        ProductStock: {
            /** @description The code of the product. */
            productCode: string;
            /**
             * @description A list of stock information attached to the product.
             *     An empty list is allowed; any existing stock information will be removed.
             */
            stock: components["schemas"]["StockInformation"][];
        };
        /** @description The store specific data attached to a product (in multi-store). */
        ProductStoreLink: {
            /**
             * Format: int32
             * @description The store identifier to link the entity to.
             */
            storeId: number;
            /**
             * @description The JSON that contains extra data that can not be placed in the predefined properties.
             *     Value must be escaped.
             */
            miscJson?: string | null;
            /**
             * Format: int32
             * @description The optional ID of the promotion that is active for the product.
             */
            promoTypeId?: number | null;
            /**
             * Format: double
             * @description The optional transport cost of the product.
             */
            transportCost?: number | null;
            /**
             * Format: double
             * @description The optional minimal amount at which shipping this product is free.
             */
            minimumAmountFreeShipping?: number | null;
            /**
             * Format: int32
             * @description The optional transfer lead time in days for this product.
             *     This is the number of days the product should take to deliver.
             */
            transferLeadTimeInDays?: number | null;
        };
        /** @description Defines links between a product and stores (in multi-store). */
        ProductStores: {
            /** @description The code of the product. */
            productCode: string;
            /**
             * @description The stores linked to the product.
             *     An empty list is allowed; any existing store links will be removed.
             */
            stores: components["schemas"]["ProductStoreLink"][];
        };
        /** @description Contains surcharge information for a given product. */
        ProductSurcharge: {
            /** @description The code of the product. */
            productCode: string;
            /**
             * @description A list of surcharges attached to the product.
             *     An empty list is allowed; any existing surcharges will be removed.
             */
            surcharges: components["schemas"]["Surcharge"][];
        };
        /** @description Included in products. Contains language specific data. */
        ProductTranslation: {
            /**
             * Format: int32
             * @description The language (as LCID or predefined CultureInfo identifier) of the translation.
             */
            lcid: number;
            miscXml?: string | null;
            /** @description The name of the entity in the specified LCID. */
            name: string;
            searchName?: string | null;
            /** @description The description of the entity in the specified LCID. */
            description?: string | null;
            comment?: string | null;
            synonyms?: string | null;
        };
        /**
         * @description Defines a property that can be used as a filter for product list (NatchOS.Plankton.Models.Property.UseAsFilter)
         *     or specification (NatchOS.Plankton.Models.Property.ShowAsProductSpecification) for a product.
         *     Has multiple NatchOS.Plankton.Models.PropertyValue that belong directly to a NatchOS.Plankton.Models.Product.
         *     May belong to a property class.
         */
        Property: {
            /** @description The property code. */
            propertyCode: string;
            /** @description The property class code this property belongs to. */
            propertyClassCode: string;
            /** @description The internal name. */
            internalName: string;
            /**
             * @description The type of the property value.
             *
             *     1 = Text (A textual value. Stored in NatchOS.Plankton.Models.PropertyValueTranslation.TextValue.)
             *
             *     2 = NumericValue (A numerical value, integer or decimal.)
             *
             *     4 = Boolean (A boolean value, stored as numeric 0 or 1.)
             */
            propertyValueType: components["schemas"]["PropertyValueType"];
            /**
             * @description The type of the property filter.
             *
             *     1 = Intersect (Evaluated as an `AND` operator within the property values. Selecting more values/options within the same property may reduce results. This was formerly known as 'Single'. Support in NatchOS search.)
             *
             *     2 = Union (Evaluated as an `OR` operator within the property values. Selecting more values/options within the same property may increase results. This was formerly known as 'Multi'. Support in NatchOS search.)
             *
             *     3 = Range (A selection of a range. NOT SUPPORTED in default NatchOS search. Only for customer search implementations!)
             */
            propertyFilterType: components["schemas"]["PropertyFilterType"];
            /** @description A value indicating whether this property must be shown with the product information. */
            showAsProductSpecification: boolean;
            /** @description A value indicating whether this property can be used as a filter for products. */
            useAsFilter: boolean;
            /**
             * @description A value indicating whether this property should be included in the search index (e.g. Full-Text Search in SQL or Azure Search).
             *     The NatchOS.Plankton.Models.Property.PropertyValueType is expected to be NatchOS.Plankton.Models.PropertyValueType.Text.
             */
            includeInSearchIndex: boolean;
            /**
             * Format: int32
             * @description The optional sort order value to sort properties.
             */
            sortOrderValue?: number | null;
            /**
             * @description The translations of the property.
             *     An empty list is allowed; any existing translations will be removed.
             */
            translations: components["schemas"]["PropertyTranslation"][];
            miscXml?: string | null;
        };
        /**
         * Format: int32
         * @description Supported value for the filter type of a property.
         *
         *     1 = Intersect (Evaluated as an `AND` operator within the property values. Selecting more values/options within the same property may reduce results. This was formerly known as 'Single'. Support in NatchOS search.)
         *
         *     2 = Union (Evaluated as an `OR` operator within the property values. Selecting more values/options within the same property may increase results. This was formerly known as 'Multi'. Support in NatchOS search.)
         *
         *     3 = Range (A selection of a range. NOT SUPPORTED in default NatchOS search. Only for customer search implementations!)
         * @enum {integer}
         */
        PropertyFilterType: PropertyFilterType;
        /** @description Included in properties. Contains language specific data. */
        PropertyTranslation: {
            /**
             * Format: int32
             * @description The language (as LCID or predefined CultureInfo identifier) of the translation.
             */
            lcid: number;
            /** @description The name of the entity in the specified LCID. */
            name: string;
            miscXml?: string | null;
            /** @description The description of the entity in the specified LCID. */
            description?: string | null;
        };
        /** @description Defines a value for a NatchOS.Plankton.Models.Property. */
        PropertyValue: {
            /** @description The property value code. */
            propertyValueCode: string;
            /** @description The property code. */
            propertyCode: string;
            /** @description The language independent textual value. */
            textValue: string;
            /**
             * Format: double
             * @description The optional numeric value.
             */
            numericValue?: number | null;
            /**
             * @description The translations of the property value.
             *     An empty list is allowed; any existing translations will be removed.
             */
            translations: components["schemas"]["PropertyValueTranslation"][];
            miscXml?: string | null;
        };
        /** @description Included in property value. Contains language specific data. */
        PropertyValueTranslation: {
            /**
             * Format: int32
             * @description The language (as LCID or predefined CultureInfo identifier) of the translation.
             */
            lcid: number;
            /** @description The textual value. */
            textValue: string;
            /** @description The XML that contains extra data that can not be placed in the predefined properties. */
            miscXml?: string | null;
        };
        /**
         * Format: int32
         * @description Supported values that a property and property value can have.
         *
         *     1 = Text (A textual value. Stored in NatchOS.Plankton.Models.PropertyValueTranslation.TextValue.)
         *
         *     2 = NumericValue (A numerical value, integer or decimal.)
         *
         *     4 = Boolean (A boolean value, stored as numeric 0 or 1.)
         * @enum {integer}
         */
        PropertyValueType: PropertyValueType;
        /** @description Defines a related product under a master product. */
        Relation: {
            /** @description The related product code. */
            relatedProductCode: string;
            /**
             * @description The type of the product relation.
             *
             *     1 = HasAlternative (The related product is an alternative to the origin product.)
             *
             *     2 = FrequentlyBoughtTogetherWith (The related product appears frequently in the same order as the origin product.)
             *
             *     3 = CustomersWhoBoughtThisAlsoBought (The related product is often bought by the same customer who bought origin product.)
             *
             *     4 = MandatoryIncludes (The related product is mandatory included in a sale of origin product.)
             *
             *     5 = HasAccessory (The related product is an accessory of the origin product.)
             *
             *     6 = IsModelOf (The origin product is the model for the related product.)
             *
             *     7 = IsInSameSeries (The origin product belongs to the same series of products as the related product.)
             *
             *     8 = HasReplacement (The related product is a replacement for the origin product. This is the opposite of NatchOS.Plankton.Models.RelationType.IsReplacementOf.)
             *
             *     9 = TemporaryHasAlternative (Time bound (by range) version of NatchOS.Plankton.Models.RelationType.HasAlternative.)
             *
             *     10 = Basic (The related product has a basic relation to the origin product, without any specific meaning.)
             *
             *     11 = SuggestedIncludes (The related product is a highly recommended accessory.)
             *
             *     12 = ContainsSubassembly (The related product is a subassembly of the origin product. E.g. a BOM definition, the product that is bought is built out of several other products.)
             *
             *     13 = HasCheaperAlternative (The related product is a cheaper alternative to the original product.)
             *
             *     70 = HasHighlyAdvisedAccessory (The related product is an important accessory of the origin product.)
             *
             *     106 = IsVariantOf (The origin product is a variant of the related product (model). This is the opposite of NatchOS.Plankton.Models.RelationType.IsModelOf.)
             *
             *     108 = IsReplacementOf (The origin product is a replacement of the related product. This is the opposite of NatchOS.Plankton.Models.RelationType.HasReplacement.)
             */
            relationType: components["schemas"]["RelationType"];
            /**
             * Format: date-time
             * @description The optional start date for time bound relations.
             *     Only the date part will be used; time will be ignored.
             */
            startDate?: string | null;
            /**
             * Format: date-time
             * @description The stop date for time bound relations.
             *     Only the date part will be used; time will be ignored.
             */
            stopDate?: string | null;
            /**
             * Format: double
             * @description The optional count of the related product.
             *     E.g. master product has a NatchOS.Plankton.Models.RelationType.MandatoryIncludes that
             *     should be bought 2 (battery pack) for every master product.
             */
            ratio?: number | null;
            miscXml?: string | null;
        };
        /**
         * Format: int32
         * @description The relation types which can be used to create relations between an origin product and a related product.
         *
         *     1 = HasAlternative (The related product is an alternative to the origin product.)
         *
         *     2 = FrequentlyBoughtTogetherWith (The related product appears frequently in the same order as the origin product.)
         *
         *     3 = CustomersWhoBoughtThisAlsoBought (The related product is often bought by the same customer who bought origin product.)
         *
         *     4 = MandatoryIncludes (The related product is mandatory included in a sale of origin product.)
         *
         *     5 = HasAccessory (The related product is an accessory of the origin product.)
         *
         *     6 = IsModelOf (The origin product is the model for the related product.)
         *
         *     7 = IsInSameSeries (The origin product belongs to the same series of products as the related product.)
         *
         *     8 = HasReplacement (The related product is a replacement for the origin product. This is the opposite of NatchOS.Plankton.Models.RelationType.IsReplacementOf.)
         *
         *     9 = TemporaryHasAlternative (Time bound (by range) version of NatchOS.Plankton.Models.RelationType.HasAlternative.)
         *
         *     10 = Basic (The related product has a basic relation to the origin product, without any specific meaning.)
         *
         *     11 = SuggestedIncludes (The related product is a highly recommended accessory.)
         *
         *     12 = ContainsSubassembly (The related product is a subassembly of the origin product. E.g. a BOM definition, the product that is bought is built out of several other products.)
         *
         *     13 = HasCheaperAlternative (The related product is a cheaper alternative to the original product.)
         *
         *     70 = HasHighlyAdvisedAccessory (The related product is an important accessory of the origin product.)
         *
         *     106 = IsVariantOf (The origin product is a variant of the related product (model). This is the opposite of NatchOS.Plankton.Models.RelationType.IsModelOf.)
         *
         *     108 = IsReplacementOf (The origin product is a replacement of the related product. This is the opposite of NatchOS.Plankton.Models.RelationType.HasReplacement.)
         * @enum {integer}
         */
        RelationType: RelationType;
        Salesperson: {
            personCode: string;
            /** @description A value indicating whether this salesperson is an internal employee. */
            isInternalSales: boolean;
            /** @description A value indicating whether this is the main salesperson for the customer. */
            isMainSalesperson: boolean;
            /**
             * Format: int32
             * @description The store identifier for multi-store implementations in which the salesperson is attached to the person.
             *     Use value `1` if multi-store is not used.
             */
            storeId: number;
            miscXml?: string | null;
        };
        /** @description Contains information about a delivery address that is attached to a NatchOS.Plankton.Models.Customer. */
        ShippingAddress: {
            shippingAddressCode: string;
            customerCode: string;
            /** @description A value indicating whether this is the main shipping address for the customer. */
            isMainShippingAddress: boolean;
            name?: string | null;
            secondaryName?: string | null;
            searchName?: string | null;
            /**
             * Format: int32
             * @description The language (as LCID or predefined CultureInfo identifier) of the shipping address.
             */
            lcid: number;
            /**
             * @description The address.
             *     Required to save the customer.
             */
            address: components["schemas"]["Address"];
            /**
             * @description The phone numbers.
             *     This list may be empty.
             */
            phoneNumbers: components["schemas"]["PhoneNumber"][];
            departmentCode?: string | null;
            primaryContactPersonCode?: string | null;
            /**
             * @description List of NatchOS supported shipping advice options that can be used with NatchOS.Plankton.Models.ShippingAddress.ShippingAdvice and NatchOS.Plankton.Models.Document.ShippingAdvice.
             *
             *     0 = NotSet (Not set.)
             *
             *     1 = Partial (The order can be split up, ie. per product or even per smaller quantities of a single product.)
             *
             *     2 = CompleteOrderLines (The order can be split up, but every order line must be complete (quantity).)
             *
             *     3 = Complete (The order will be fulfilled once, when all products are available.)
             */
            shippingAdvice: components["schemas"]["ShippingAdvice"];
            /** Format: int32 */
            shippingTimeInDays?: number | null;
            printPriceOnShippingDocument: boolean;
            combineShipments: boolean;
            /** Format: email */
            emailAddress?: string | null;
            miscXml?: string | null;
        };
        /**
         * Format: int32
         * @description List of NatchOS supported shipping advice options that can be used with NatchOS.Plankton.Models.ShippingAddress.ShippingAdvice and NatchOS.Plankton.Models.Document.ShippingAdvice.
         *
         *     0 = NotSet (Not set.)
         *
         *     1 = Partial (The order can be split up, ie. per product or even per smaller quantities of a single product.)
         *
         *     2 = CompleteOrderLines (The order can be split up, but every order line must be complete (quantity).)
         *
         *     3 = Complete (The order will be fulfilled once, when all products are available.)
         * @enum {integer}
         */
        ShippingAdvice: ShippingAdvice;
        /** @description Quantity of stock for a product at a given warehouse. */
        StockInformation: {
            warehouseCode: string;
            /**
             * Format: double
             * @description The actual stock count.
             *     For a stock indication, see NatchOS.Plankton.Models.StockInformation.StockIndication.
             */
            stockCount?: number | null;
            /**
             * @description The stock indication.
             *     This is an alternative for the actual stock, see NatchOS.Plankton.Models.StockInformation.StockCount.
             */
            stockIndication?: string | null;
        };
        /**
         * @description Defines an extra cost attached to a product.
         *     E.g 'bebat' for batteries.
         */
        Surcharge: {
            /**
             * Format: int32
             * @description The type identifier of the surcharge.
             *     NatchOS has pre-defined types, but custom types are also supported.
             */
            surchargeTypeId: number;
            /**
             * Format: int32
             * @description The quantity to apply to the surcharge unit price to calculate the total.
             */
            quantity: number;
            /**
             * Format: double
             * @description The unit price of the surcharge.
             *     This will be multiplied by the quantity for the total surcharge price.
             */
            unitPrice: number;
            /**
             * @description The JSON that contains extra data that can not be placed in the predefined properties.
             *     Value must be escaped.
             */
            miscJson?: string | null;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    Account_GETGetAccountActivationQueue: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.AccountActivationItem"][];
                };
            };
        };
    };
    Account_POSTPostMarkActivationMailSent: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The request. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.AccountController+MarkActivationMailRequest"];
            };
        };
        responses: {
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Account_POSTPostMarkActivationMailFailed: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The request. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.AccountController+MarkActivationMailRequest"];
            };
        };
        responses: {
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Account_GETGetHasActiveAccountInStore: {
        parameters: {
            query?: {
                /** @description The user's email address / username. */
                Email?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.AccountController+HasActiveAccountInStoreResponse"];
                };
            };
        };
    };
    Account_GETGetPersonRights: {
        parameters: {
            query: {
                PersonId: number;
                CustomerId: number;
                StoreId?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.AccountController+PersonRightsResponse"];
                };
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    Basket_GETCurrentBasket: {
        parameters: {
            query?: {
                /**
                 * @description Gets or sets the optional type of the basket.
                 *     Can be used to load the normal basket while impersonating
                 *     a customer (default is 'normal by internal').
                 *
                 *     0 = NotSet
                 *
                 *     1 = Normal (A regular basket.)
                 *
                 *     2 = NormalByInternal (A regular basket, but created by an internal person (ie. via impersonation).)
                 *
                 *     3 = Quote (A quote basket.)
                 */
                BasketType?: components["schemas"]["NatchOS.Plankton.Controllers.Api.BasketController+CurrentBasketQueryBasketType"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Basket"];
                };
            };
            /** @description The action was successful, but the data is empty. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Basket_PATCHMergeBasket: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.BasketController+MergeBasketRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Basket"];
                };
            };
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Basket_GETSearchBaskets: {
        parameters: {
            query?: {
                /**
                 * @description Gets the identifier of a custom entity the basket is linked to.
                 *     The attached to filter must be set to NatchOS.Plankton.ApiModels.BasketFilterAttachedTo.CustomEntity to use this property.
                 */
                CustomEntityId?: number;
                /**
                 * @description Gets or sets the filter specifying what the basket is attached to.
                 *
                 *     0 = Person (The basket is attached to a person.)
                 *
                 *     1 = Customer (The basket is attached to a customer. Will match all persons under the customer.)
                 *
                 *     2 = CustomEntity (The basket is attached to a custom entity.)
                 *
                 *     3 = None (No filter. Only for service accounts.)
                 */
                FilterAttachedTo?: components["schemas"]["NatchOS.Plankton.ApiModels.BasketFilterAttachedTo"];
                /** @description Gets the value of a payment reference the basket is linked to. */
                PaymentReference?: string;
                /** @description Gets the minimal net amount of the basket to filter on. */
                MinimumNetAmount?: number;
                /** @description Gets the minimal gross amount of the basket to filter on. */
                MinimumGrossAmount?: number;
                /** @description Gets the minimal age of the basket in number of days to filter on. */
                MinimumAgeInDays?: number;
                /** @description Gets the optional maximum number of basket ID results to retrieve. */
                MaximumBasketResults?: number;
                /**
                 * @description Gets the sort order for the results.
                 *
                 *     0 = NotSet (No specific order. Best performance.)
                 *
                 *     10 = CreationTimeAscending (Sort by creation time ascending.)
                 *
                 *     11 = CreationTimeDescending (Sort by creation time descending.)
                 */
                SortOrder?: components["schemas"]["NatchOS.Plankton.ApiModels.BasketSearchResultSortOrder"];
                /** @description Gets the minimal days since last abandoned basket notification was sent. */
                MinimumDaysSinceLastAbandonedBasketNotification?: number;
                /** @description Gets the number of time the abandoned basket notification must have been sent. */
                AbandonedBasketNotificationsSentCount?: number;
                /**
                 * @description Gets the basket types to filter the baskets.
                 *     If no types are specified, then NatchOS.Plankton.ImplementationModels.BasketType.Normal is used as a default.
                 *     Matches the NatchOS.Plankton.ImplementationModels.BasketHeader.BasketType property.
                 */
                BasketTypeList?: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketType"][];
                /**
                 * @description Gets the optional list of statuses to filter the baskets.
                 *     If no status is specified, status NatchOS.Plankton.ImplementationModels.BasketStatus.Closed and NatchOS.Plankton.ImplementationModels.BasketStatus.Pending will be excluded.
                 *     Matches the NatchOS.Plankton.ImplementationModels.BasketHeader.BasketStatus property.
                 */
                BasketStatusList?: components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketStatus"][];
                /**
                 * @description Defines how the status filter should be applied.
                 *     `true` for excluding the specified statuses; `false` for include.
                 *     Default is `false`.
                 */
                StatusFilterAsExclude?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": number[];
                };
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    Basket_GETGetBasketDetails: {
        parameters: {
            query: {
                /** @description Gets or sets the identifier of the basket. */
                BasketId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Basket"];
                };
            };
            /** @description The action was successful, but the data is empty. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    Basket_GETGetBasketDetailsList: {
        parameters: {
            query: {
                /**
                 * @description Gets or sets the list of basket identifiers to load.
                 *     A maximum of 100 baskets can be passed in one call.
                 */
                BasketIdList: number[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Basket"][];
                };
            };
        };
    };
    Basket_GETGetBasketHeadersList: {
        parameters: {
            query: {
                /**
                 * @description Gets or sets the list of basket identifiers to load.
                 *     A maximum of 100 baskets can be passed in one call.
                 */
                BasketIdList: number[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketHeader"][];
                };
            };
        };
    };
    Basket_POSTCreateAuthenticatedBasket: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.BasketController+CreateBasketRequest"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Basket"];
                };
            };
        };
    };
    Basket_POSTCreateAnonymousBasket: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.BasketController+CreateAnonymousBasketRequest"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Basket"];
                };
            };
        };
    };
    Basket_PUTUpdateStatus: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the basket to update. */
                basketId: number;
            };
            cookie?: never;
        };
        /** @description The request data. */
        requestBody: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.BasketController+UpdateStatusRequest"];
            };
        };
        responses: {
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    Basket_PUTUpdatePaymentInformation: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the basket to update. */
                basketId: number;
            };
            cookie?: never;
        };
        /** @description The request data. */
        requestBody: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.PaymentInformation"];
            };
        };
        responses: {
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Basket_PUTUpdateName: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the basket to update. */
                basketId: number;
            };
            cookie?: never;
        };
        /** @description The request data. */
        requestBody: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.BasketController+UpdateNameRequest"];
            };
        };
        responses: {
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Basket_PUTUpdateHeader: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the basket to update. */
                basketId: number;
            };
            cookie?: never;
        };
        /** @description The request data. */
        requestBody: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.UpdateBasketHeaderRequest"];
            };
        };
        responses: {
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Basket_POSTBatchAddProductLines: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the basket. */
                basketId: number;
            };
            cookie?: never;
        };
        /** @description The request data. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.BasketController+BatchAddBasketLinesRequest"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Basket"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    Basket_PUTUpdateProductLine: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the basket. */
                basketId: number;
            };
            cookie?: never;
        };
        /** @description The request data. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.BasketController+UpdateBasketLineRequest"];
            };
        };
        responses: {
            /** @description External data has been replaced per entity. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Basket"];
                };
            };
        };
    };
    Basket_PUTBatchUpdateBasketLines: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the basket. */
                basketId: number;
            };
            cookie?: never;
        };
        /** @description The request data, which must contain a complete list of the lines. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.BasketController+BatchUpdateBasketLinesRequest"];
            };
        };
        responses: {
            /** @description External data has been replaced per entity. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Basket"];
                };
            };
        };
    };
    Basket_DELETEDeleteLines: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the basket to delete the lines from. */
                basketId: number;
            };
            cookie?: never;
        };
        /** @description The request data. */
        requestBody: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.BasketController+DeleteLinesRequest"];
            };
        };
        responses: {
            /** @description Data has been deleted. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Basket"];
                };
            };
        };
    };
    Basket_DELETEDeleteBasket: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the basket to delete the lines from. */
                basketId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The action was successful, data has been deleted. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Basket_POSTSubmitBasket: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                basketId: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.BasketController+BasketSubmitRequest"];
            };
        };
        responses: {
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    Basket_PUTRegisterAbandonedBasketNotificationSent: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The basket ID. */
                basketId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Basket_GETGetBasketStatistics: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The basket ID. */
                basketId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketStatistics"];
                };
            };
            /** @description The action was successful, but the data is empty. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Basket_GETGetBasketStatisticsList: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.BasketStatistics"][];
                };
            };
        };
    };
    Category_GET: {
        parameters: {
            query?: {
                /** @description `true` to always include each category and skip filtering; `false` (default) to exclude offline categories and categories without products (in sub tree). */
                disableFiltering?: boolean;
            };
            header?: never;
            path: {
                /** @description The category id for which to load all the descendants. */
                rootCategoryId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Category"][];
                };
            };
        };
    };
    Category_POST: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of categories. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["Category"][];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    Category_DELETE: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The category code. */
                categoryCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The action was successful, data has been deleted. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    CategoryExternalData_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The external source identifier.<br/>Valid values are: `10` (ERP), `20` (Website), `30` (PIM), `40` (CRM), `50` (MAN), `99` (Natch(internal)) */
                sourceId: number;
            };
            cookie?: never;
        };
        /** @description A list of external data attached to category. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["EntityExternalData"][];
            };
        };
        responses: {
            /** @description External data has been replaced per category. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    CategoryProperty_PUT: {
        parameters: {
            query?: {
                /** @description The optional external source identifier.<br/>Valid values are: `10` (ERP), `20` (Website), `30` (PIM), `40` (CRM), `50` (MAN), `99` (Natch(internal)) */
                sourceId?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of category and property links. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["CategoryPropertyCombination"][];
            };
        };
        responses: {
            /** @description Property links have been replaced per category. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    CategoryProperty_DELETE: {
        parameters: {
            query?: {
                /** @description The optional external source identifier.<br/>Valid values are: `10` (ERP), `20` (Website), `30` (PIM), `40` (CRM), `50` (MAN), `99` (Natch(internal)) */
                sourceId?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of category and property links. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["CategoryPropertyCombination"][];
            };
        };
        responses: {
            /** @description Data has been deleted. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Customer_GET: {
        parameters: {
            query: {
                /**
                 * @description Gets or sets the list of customer identifiers to load.
                 *     A maximum of 100 customers can be passed in one call.
                 */
                CustomerIdList: number[];
                /** @description Gets or sets a value indicating whether the customers external data should be returned. */
                AddExternalData?: boolean;
                /** @description Gets or sets a value indicating whether the customers sales info should be returned. */
                AddSalesInfo?: boolean;
                /** @description Gets or sets a value indicating whether the customers salespersons should be returned. */
                AddSalesPersons?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Customer"][];
                };
            };
        };
    };
    Customer_PATCH: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The customer ID. */
                customerId: number;
            };
            cookie?: never;
        };
        /** @description The data. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.CustomerController+CustomerUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Customer_POST: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of customers. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["Customer"][];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    Customer_DELETE: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The customer code. */
                customerCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The action was successful, data has been deleted. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    CustomerCategory_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of customer and category combinations. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["CustomerCategory"][];
            };
        };
        responses: {
            /** @description Categories have been replaced per customer. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    CustomerExternalData_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The external source identifier.<br/>Valid values are: `10` (ERP), `20` (Website), `30` (PIM), `40` (CRM), `50` (MAN), `99` (Natch(internal)) */
                sourceId: number;
            };
            cookie?: never;
        };
        /** @description A list of external data attached to customer. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["EntityExternalData"][];
            };
        };
        responses: {
            /** @description External data has been replaced per customer. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    CustomerSalesperson_GET: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The customer identifier. */
                customerId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Domain.Ecommerce.CustomerSalesperson"][];
                };
            };
        };
    };
    CustomerSalesperson_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of salesperson and customer links. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["CustomerSalesperson"][];
            };
        };
        responses: {
            /** @description Salesperson links have been replaced per customer. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    DeepDive_POSTProductDetailView: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The data, containing at least the product identifier. */
        requestBody: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.DeepDiveController+DeepDiveEventData"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": boolean;
                };
            };
        };
    };
    DeepDive_POSTProductDocumentDownload: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The data, containing at least the product identifier. */
        requestBody: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.DeepDiveController+DeepDiveEventData"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": boolean;
                };
            };
        };
    };
    Document_GET: {
        parameters: {
            query: {
                /**
                 * @description Gets or sets the list of document identifiers to load.
                 *     A maximum of 100 documents can be passed in one call.
                 */
                DocumentIdList: number[];
                /**
                 * @description Gets or sets the value indicating whether to load the lines of the documents.
                 *     `true` for details; `false` for list of documents.
                 */
                AddLines?: boolean;
                /** @description Gets or sets the value indicating whether to load the attached files/link of the documents. */
                AddFiles?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Document"][];
                };
            };
        };
    };
    Document_GETMostRecentDocumentLines: {
        parameters: {
            query: {
                /**
                 * @description Gets or sets the list of products that the lines must be linked to.
                 *     A maximum of 100 products can be passed in one call.
                 */
                ProductIdList: number[];
                /** @description Gets or sets the list of document types to search in. */
                DocumentTypeList: components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentType"][];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentLine"][];
                };
            };
        };
    };
    Document_POST: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of documents. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["Document"][];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    Document_DELETE: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The document code. */
                documentCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The action was successful, data has been deleted. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    DocumentSearch_POST: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The search criteria. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentSearch.DocumentSearchCriteria"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentSearch.SearchResults"];
                };
            };
        };
    };
    EntityFile_PUT: {
        parameters: {
            query?: {
                /** @description The optional external source identifier.<br/>Valid values are: `10` (ERP), `20` (Website), `30` (PIM), `40` (CRM), `50` (MAN), `99` (Natch(internal)) */
                sourceId?: number;
            };
            header?: never;
            path: {
                /** @description Type of the entities in the data. Allowed values: `product`, `category`, `customer`, `person`, `document`. */
                entityType: string;
            };
            cookie?: never;
        };
        /** @description A list of files linked to an entity, must not be empty. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["EntityFiles"][];
            };
        };
        responses: {
            /** @description File links have been replaced per entity and file type combination. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    EntityFile_POST: {
        parameters: {
            query?: {
                /** @description The optional external source identifier.<br/>Valid values are: `10` (ERP), `20` (Website), `30` (PIM), `40` (CRM), `50` (MAN), `99` (Natch(internal)) */
                sourceId?: number;
            };
            header?: never;
            path: {
                /** @description Type of the entities in the data. */
                entityType: string;
            };
            cookie?: never;
        };
        /** @description A list of files linked to an entity, must not be empty. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["EntityFiles"][];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    EntityFile_DELETE: {
        parameters: {
            query?: {
                /** @description The optional external source identifier.<br/>Valid values are: `10` (ERP), `20` (Website), `30` (PIM), `40` (CRM), `50` (MAN), `99` (Natch(internal)) */
                sourceId?: number;
            };
            header?: never;
            path: {
                /** @description Type of the entities in the data. */
                entityType: string;
            };
            cookie?: never;
        };
        /** @description A list of files linked to an entity, must not be empty. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["EntityFiles"][];
            };
        };
        responses: {
            /** @description Data has been deleted. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    EntityStore_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Type of the entities in the data. Allowed values: `product`. */
                entityType: string;
            };
            cookie?: never;
        };
        /** @description A list of stores linked to an entity. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["EntityStores"][];
            };
        };
        responses: {
            /** @description Store links have been replaced per entity. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    ExportQueue_GETGetNextItemByType: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                exportTypeId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.ExportQueueItem"];
                };
            };
            /** @description The action was successful, but the data is empty. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportQueue_PUTMarkProcessed: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The identifier of the queue item. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.ExportQueueController+MarkProcessedRequest"];
            };
        };
        responses: {
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ExportQueue_PUTMarkFailed: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The queue item identifier and a failure reason. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.ExportQueueController+MarkFailedRequest"];
            };
        };
        responses: {
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Login_POSTLogin: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Username and password. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.LoginController+LoginRequest"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ApiModels.TokenResponse"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ApiModels.AuthErrorResponse"];
                };
            };
        };
    };
    Login_POSTServiceToken: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ApiModels.TokenResponse"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    Login_POSTStoresWithSignInAllowed: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The username. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.LoginController+StoresRequest"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": number[];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ApiModels.AuthErrorResponse"];
                };
            };
        };
    };
    Login_POSTStoresWithSignInAllowed_v1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The username. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.LoginController+StoresRequest1"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": number[];
                };
            };
        };
    };
    Login_POSTRefresh: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The refresh token. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.LoginController+RefreshRequest"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ApiModels.TokenResponse"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    Login_POSTImpersonate: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The person and customer to impersonate. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.LoginController+ImpersonateRequest"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ApiModels.TokenResponse"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ApiModels.AuthErrorResponse"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    Login_POSTImpersonateSearchCustomers: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The search criteria. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.LoginController+ImpersonateSearchCustomersRequest"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.ImpersonateSearchCustomersResult"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    Login_POSTImpersonateSearchPersons: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The search criteria. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.LoginController+ImpersonateSearchPersonsRequest"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Person"][];
                };
            };
        };
    };
    Login_POSTMultiCustomerChange: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The customer to get the tokens for. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.LoginController+MultiCustomerChangeRequest"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ApiModels.TokenResponse"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    Login_POSTMultiCustomerOptions: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.MultiCustomerOption"][];
                };
            };
        };
    };
    Login_POSTDebugClaims: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.LoginController+ClaimDebugDto"][];
                };
            };
        };
    };
    "MessageConfiguration_POSTresolve-email-config": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description The type of the email message.
                 *
                 *     1 = PasswordReset (A password reset mail.)
                 *
                 *     2 = PasswordChanged (Mail to user informing their password has changed.)
                 *
                 *     3 = AccountActivation (An account activation mail.)
                 *
                 *     4 = StoreAccess (A store access notification mail.)
                 *
                 *     5 = BasketSubmitted (A basket submitted notification mail (to internal).)
                 *
                 *     6 = BasketConfirmation (A basket submitted confirmation mail (to customer).)
                 *
                 *     7 = AccountRequest (Mail to internal - a customer requested a new account.)
                 *
                 *     8 = AccountRequestResponse (Mail to customer - confirmation of account request.)
                 *
                 *     9 = Registration (Mail to internal - a new customer requested an account.)
                 *
                 *     10 = RegistrationResponse (Mail to customer - confirmation of registration.)
                 *
                 *     11 = ContactUpdate (Mail to internal - Summary of updated contact data.)
                 *
                 *     12 = BasketToPurchaser (Mail to customer - a basket was assigned to purchaser for approval.)
                 *
                 *     13 = CustomerNote (Mail with customer note.)
                 *
                 *     14 = QuoteRequest (Mail to customer with quote.)
                 *
                 *     15 = ContactForm (Mail to customer with data from a contact form.)
                 *
                 *     16 = AnonymousBasketMail (Mail to user with content of anonymous list.)
                 *
                 *     17 = AnonymousBasketQuoteRequest (Mail to internal - Anonymous quote request.)
                 *
                 *     18 = AnonymousBasketQuoteResponse (Mail to user - Confirmation of anonymous quote request.)
                 *
                 *     19 = BlanketOrderMail (Mail to user - Informing him of the status of his blanket orders.)
                 *
                 *     20 = PriceListReplyEmail (Mail to customer informing him that his requested price list is ready to be downloaded.)
                 *
                 *     21 = Return (Mail to internal - form for return has been submitted.)
                 *
                 *     22 = Warranty (Mail to internal - form for warranty has been submitted.)
                 *
                 *     23 = AbandonedBasket (Mail to user or customer to inform him of an abandoned basket.)
                 *
                 *     24 = InfoDeliveryTime (Mail to internal - a customer requests info about a delivery time for a product.)
                 */
                messageType: components["schemas"]["NatchOS.Plankton.ImplementationModels.EmailMessageType"];
            };
            cookie?: never;
        };
        /** @description The context request for the email message. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.MessageConfigurationController+EmailMessageContextRequest"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.EmailMessageConfiguration"];
                };
            };
        };
    };
    Meta_GETStores: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Store"][];
                };
            };
        };
    };
    Meta_GETDocumentStatuses: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.DocumentStatus"][];
                };
            };
        };
    };
    Meta_GETOrderTypes: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.OrderType"][];
                };
            };
        };
    };
    Meta_GETPaymentMethods: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.PaymentMethod"][];
                };
            };
        };
    };
    Meta_GETDepartments: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Department"][];
                };
            };
        };
    };
    Meta_GETWarehouses: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Warehouse"][];
                };
            };
        };
    };
    Meta_GETTransferSubTypes: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.TransferSubtype"][];
                };
            };
        };
    };
    Meta_GETUnitOfMeasures: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.UnitOfMeasure"][];
                };
            };
        };
    };
    Meta_GETCountries: {
        parameters: {
            query?: {
                lcidList?: number[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Country"][];
                };
            };
        };
    };
    Meta_GETWebRoles: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.WebRole"][];
                };
            };
        };
    };
    Meta_GETSectors: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Sector"][];
                };
            };
        };
    };
    Overpack_GETKeys: {
        parameters: {
            query: {
                /**
                 * @description Gets or sets the list of identifiers to load to codes for.
                 *     A maximum of 100 keys can be passed in one call.
                 */
                IdList: number[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.CodeIdCombination"][];
                };
            };
        };
    };
    Overpack_POST: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of overpacks. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["Overpack"][];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    Overpack_DELETE: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The overpack code. */
                overpackCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The action was successful, data has been deleted. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Password_POSTChangePassword: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The current password and new password. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.PasswordController+ChangePasswordRequest"];
            };
        };
        responses: {
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    Password_POSTPasswordResetKeyGenerate: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The username of the person to reset the password for. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.PasswordController+PasswordResetKeyGenerateRequest"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.PasswordController+PasswordResetKeyGenerateResponse"];
                };
            };
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Password_POSTPasswordResetKeyValidate: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The key from a previous endpoint call. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.PasswordController+PasswordResetKeyValidateRequest"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.PasswordController+PasswordResetKeyValidateResponse"];
                };
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    Password_POSTResetPassword: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The key from a previous endpoint call, that makes password validation possible; and a new password. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.Auth.PasswordController+ResetPasswordRequest"];
            };
        };
        responses: {
            /** @description The action was successful. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    Person_GET: {
        parameters: {
            query: {
                /**
                 * @description Gets or sets the list of person identifiers to load.
                 *     A maximum of 100 persons can be passed in one call.
                 */
                PersonIdList: number[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Person"][];
                };
            };
        };
    };
    Person_POSTSearch: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The search criteria. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.PersonController+PersonSearchRequest"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Person"][];
                };
            };
        };
    };
    Person_POST: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of persons. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["Person"][];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    Person_DELETE: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The person code. */
                personCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The action was successful, data has been deleted. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    PersonExternalData_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The external source identifier.<br/>Valid values are: `10` (ERP), `20` (Website), `30` (PIM), `40` (CRM), `50` (MAN), `99` (Natch(internal)) */
                sourceId: number;
            };
            cookie?: never;
        };
        /** @description A list of external data attached to person. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["EntityExternalData"][];
            };
        };
        responses: {
            /** @description External data has been replaced per person. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    Product_GETGetIdByCode: {
        parameters: {
            query?: {
                /** @description The product code. */
                productCode?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": number;
                };
            };
        };
    };
    Product_GET: {
        parameters: {
            query: {
                /**
                 * @description Gets or sets the list of product identifiers to load.
                 *     A maximum of 100 products can be passed in one call.
                 */
                ProductIdList: number[];
                /**
                 * @description Gets or sets the list of lcid to load translations for.
                 *     If no values are passed, translations will not be loaded.
                 */
                LcidList?: number[];
                /**
                 * @description Gets or sets the LCID to be used for determining product and category names for analytics.
                 *     Should probably be LCID of English language that's used in the application, ie. 2057.
                 */
                AnalyticsLcid?: number;
                /**
                 * @description Gets or sets the brand source to be used for determining the brand for analytics.
                 *
                 *     0 = None (No brand name will be resolved.)
                 *
                 *     1 = Category (Determine the brand name via a category. Needs the root category id.)
                 *
                 *     2 = Property (Determine the brand name via a property. Needs the brand property id.)
                 */
                AnalyticsBrandSource?: components["schemas"]["NatchOS.Plankton.ApiModels.AnalyticsBrandSource"];
                /** @description Gets or sets the root category id or the property id needed to resolve the brand name. */
                AnalyticsBrandSourceId?: number;
                /** @description Gets or sets the root category id for the product groups / navigation. */
                AnalyticsProductGroupRootId?: number;
                /** @description Gets or sets the value indicating whether to load the categories of the products. */
                AddCategories?: boolean;
                /** @description Gets or sets the value indicating whether to load the translations of the products. */
                AddProductTranslations?: boolean;
                /** @description Gets or sets the value indicating whether to load the external data of the products. */
                AddExternalData?: boolean;
                /** @description Gets or sets the value indicating whether to load the store data of the products. */
                AddStoreData?: boolean;
                /** @description Gets or sets the value indicating whether to load the stock information of the products. */
                AddStock?: boolean;
                /** @description Gets or sets the value indicating whether to load the overpacks of the products. */
                AddOverpacks?: boolean;
                /**
                 * @description Gets or sets the value indicating whether to load the overpack translations of the products.
                 *     Requires NatchOS.Plankton.ApiModels.ProductQuery.AddOverpacks to be set to `true`.
                 */
                AddOverpackTranslations?: boolean;
                /**
                 * @description Gets or sets the value indicating whether to load the files of the products.
                 *     On the backend, an extra database call will be performed to load the data.
                 *     Only file types with absolute URLs are supported.
                 */
                AddFiles?: boolean;
                /**
                 * @description Gets or sets the value indicating whether to load the property values of the products.
                 *     On the backend, an extra database call will be performed to load the data.
                 *     You can also lazy load the properties in a separate call, which could improve page load times.
                 */
                AddPropertyValues?: boolean;
                /**
                 * @description The optional product relation types to load.
                 *     On the backend, an extra database call will be performed to load the data.
                 *     You can also lazily load the relations in a separate call, which could improve page load times.
                 */
                AddProductRelations?: components["schemas"]["NatchOS.Plankton.ImplementationModels.RelationType"][];
                /** @description If set to `true` then only relations for online products will be returned. */
                AddProductRelationsOnlyOnlineProducts?: boolean;
                /** @description If set to `true` then time-bound relations will be filtered to only include active one according to their date. */
                AddProductRelationsFilterTimeBoundActiveOnly?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Product"][];
                };
            };
        };
    };
    Product_GETGetPropertiesByProduct: {
        parameters: {
            query?: {
                /** @description A list of product id's. */
                productIdList?: number[];
                /** @description An optional list of property id's. */
                propertyIdList?: number[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductPropertyValues"][];
                };
            };
        };
    };
    Product_POST: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of products. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["Product"][];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    Product_DELETE: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The product code. */
                productCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The action was successful, data has been deleted. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Product_DELETEDeleteProductsInBatch: {
        parameters: {
            query?: {
                /** @description A list of product codes. */
                productCode?: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Data has been deleted. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ProductCategory_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of category and product links. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ProductCategoryCombination"][];
            };
        };
        responses: {
            /** @description Category links have been replaced per product. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    ProductExternalData_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The external source identifier.<br/>Valid values are: `10` (ERP), `20` (Website), `30` (PIM), `40` (CRM), `50` (MAN), `99` (Natch(internal)) */
                sourceId: number;
            };
            cookie?: never;
        };
        /** @description A list of external data attached to product. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["EntityExternalData"][];
            };
        };
        responses: {
            /** @description External data has been replaced per product. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    ProductPrice_GETGetForPriceGroup: {
        parameters: {
            query?: {
                PriceGroupId?: number;
                CurrencyId?: number;
                ProductIds?: number[];
                Quantities?: number[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductPrice"][];
                };
            };
        };
    };
    ProductPrice_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of price groups, products and prices. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["PriceGroupProductPrices"][];
            };
        };
        responses: {
            /** @description Prices have been replaced per price group. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    ProductPrice_DELETE: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of price groups with products and quantities. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["PriceGroupProductPricesDelete"][];
            };
        };
        responses: {
            /** @description Data has been deleted. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ProductPropertyValue_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of property values attached to product. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ProductPropertyValue"][];
            };
        };
        responses: {
            /** @description Property values have been replaced per product. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    ProductRelation_GETGetProductRelations: {
        parameters: {
            query: {
                /** @description The list of product id's to load the relations for */
                ProductIdList: number[];
                /** @description The product relation types to load. */
                Relations: components["schemas"]["NatchOS.Plankton.ImplementationModels.RelationType"][];
                /** @description If set to `true` then only online products will be returned. */
                OnlyOnlineProducts?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductRelation"][];
                };
            };
        };
    };
    ProductRelation_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of relations between products. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ProductRelation"][];
            };
        };
        responses: {
            /** @description Relations have been replaced per product. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    ProductSearch_POST: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description The search criteria. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria"];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.Results.SearchResults"];
                };
            };
        };
    };
    ProductSearchSuggestions_GETGetSuggestions: {
        parameters: {
            query?: {
                /**
                 * @description Gets the optional culture identifier.
                 *     Will default to the current culture if not explicitly set.
                 */
                LCID?: number;
                /**
                 * @description Gets or sets the input to complete with suggestions.
                 *     If the length exceeds 200 characters, nothing will be returned.
                 */
                Input?: string;
                /** @description Gets or sets a value indicating whether suggestions should only relate to products that have stock. */
                IsStockFilterActive?: boolean;
                /** @description Gets or sets the JSON for the custom query parameter. */
                CustomQueryParameterJson?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.ProductSearch.Suggestions.SearchSuggestionResults"];
                };
            };
        };
    };
    ProductSearchSuggestions_GETGetHistory: {
        parameters: {
            query?: {
                /**
                 * @description Gets the optional culture identifier.
                 *     Will default to the current culture if not explicitly set.
                 */
                LCID?: number;
                /** @description Gets or sets a value indicating whether suggestions should only relate to products that have stock. */
                IsStockFilterActive?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string[];
                };
            };
        };
    };
    ProductStock_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of products with their stock information. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ProductStock"][];
            };
        };
        responses: {
            /** @description Stock information has been replaced per product. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    ProductStore_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of stores linked to a product. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ProductStores"][];
            };
        };
        responses: {
            /** @description Store links have been replaced per product. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    ProductSurcharge_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of products with their surcharges. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ProductSurcharge"][];
            };
        };
        responses: {
            /** @description Surcharge has been replaced per product. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    Property_GETAll: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.Property"][];
                };
            };
        };
    };
    Property_GETAllClasses: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.PropertyClass"][];
                };
            };
        };
    };
    Property_POST: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of properties. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["Property"][];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    Property_DELETE: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The property code. */
                propertyCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The action was successful, data has been deleted. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    PropertyValue_GETGetPropertiesValuesByProperty: {
        parameters: {
            query?: {
                propertyIdList?: number[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.PropertyValue"][];
                };
            };
        };
    };
    PropertyValue_POST: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of property values. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["PropertyValue"][];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    PropertyValue_DELETE: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The property value code. */
                propertyValueCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The action was successful, data has been deleted. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    Root_GET: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ApiModels.RootResponse"];
                };
            };
        };
    };
    ShippingAddress_GET: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The shipping address identifier. */
                shippingAddressId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.ShippingAddress"];
                };
            };
            /** @description The action was successful, but the data is empty. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    ShippingAddress_GETGetCustomerShippingAddress: {
        parameters: {
            query?: {
                /** @description Gets or sets the value indicating whether to load the external data of the addresses. */
                AddExternalData?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["NatchOS.Plankton.ImplementationModels.ShippingAddress"][];
                };
            };
        };
    };
    ShippingAddress_PATCH: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The shipping address ID. */
                shippingAddressId: number;
            };
            cookie?: never;
        };
        /** @description The data. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["NatchOS.Plankton.Controllers.Api.ShippingAddressController+ShippingAddressUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
            /** @description Forbidden */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ProblemDetails"];
                };
            };
        };
    };
    ShippingAddress_POST: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description A list of shipping addresses. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["ShippingAddress"][];
            };
        };
        responses: {
            /** @description Entities has been created or updated. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
    ShippingAddress_DELETE: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The shipping address code. */
                shippingAddressCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The action was successful, data has been deleted. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ShippingAddressExternalData_PUT: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The external source identifier.<br/>Valid values are: `10` (ERP), `20` (Website), `30` (PIM), `40` (CRM), `50` (MAN), `99` (Natch(internal)) */
                sourceId: number;
            };
            cookie?: never;
        };
        /** @description A list of external data attached to shipping address. */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["EntityExternalData"][];
            };
        };
        responses: {
            /** @description External data has been replaced per shipping address. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Request could not be processed because of invalid data. */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Microsoft.AspNetCore.Mvc.ValidationProblemDetails"];
                };
            };
        };
    };
}
export enum DocumentInvoiceType {
    // The regular invoice with a positive amount.
    Invoice = 1,
    // The invoice has a negative amount.
    CreditNote = 2
}
export enum DocumentOrderType {
    // A normal order.
    Normal = 1,
    // A return order, customer sends something back.
    Return = 2
}
export enum DocumentType {
    // A sales quote allows a prospective buyer to see what costs would be involved for the work they would like to have done.
    Quote = 1,
    // An agreement for specific products or services.
    Order = 2,
    // A shipment document.
    Shipment = 3,
    // An invoice for a completed order. Includes both positive and negative invoices, see NatchOS.Plankton.Models.DocumentInvoiceType.
    Invoice = 4
}
export enum Gender {
    // Unknown or not set.
    None = 0,
    // Male gender.
    Male = 1,
    // Female gender.
    Female = 2
}
export enum NatchOSPlanktonApiModelsAnalyticsBrandSource {
    // No brand name will be resolved.
    None = 0,
    // Determine the brand name via a category. Needs the root category id.
    Category = 1,
    // Determine the brand name via a property. Needs the brand property id.
    Property = 2
}
export enum NatchOSPlanktonApiModelsAuthenticateResultStatus {
    // Value has not been set.
    None = 0,
    // The username and password are valid. A successful login attempt has been registered.
    Success = 1,
    // The username is valid, but the account was previously locked out.
    IsLockedOut = 2,
    // The username is not valid.
    UserNotFound = 3,
    // The username is valid, but password does not match. There have been too many attempt to authenticate the user in a specific time frame. The account has been locked out (and the event has been registered).
    LockedOutAfterTooManyAttempts = 4,
    // The username is valid, but password does not match. A failed login attempt has been registered.
    PasswordDoesNotMatch = 5,
    // The username is valid, but the account is blocked from using the application.
    IsBlocked = 6,
    // User does not have the permission to sign in.
    IsMissingPermissionForSignIn = 7
}
export enum NatchOSPlanktonApiModelsBasketFilterAttachedTo {
    // The basket is attached to a person.
    Person = 0,
    // The basket is attached to a customer. Will match all persons under the customer.
    Customer = 1,
    // The basket is attached to a custom entity.
    CustomEntity = 2,
    // No filter. Only for service accounts.
    None = 3
}
export enum NatchOSPlanktonApiModelsBasketSearchResultSortOrder {
    // No specific order. Best performance.
    NotSet = 0,
    // Sort by creation time ascending.
    CreationTimeAscending = 10,
    // Sort by creation time descending.
    CreationTimeDescending = 11
}
export enum NatchOSPlanktonControllersApiBasketControllerCurrentBasketQueryBasketType {
    NotSet = 0,
    // A regular basket.
    Normal = 1,
    // A regular basket, but created by an internal person (ie. via impersonation).
    NormalByInternal = 2,
    // A quote basket.
    Quote = 3
}
export enum NatchOSPlanktonControllersApiBasketControllerMergeBasketRequestQuantityHandlingMethod {
    Add = 0,
    Highest = 1,
    UseSource = 2,
    KeepTarget = 3
}
export enum NatchOSPlanktonImplementationModelsAccountActivationStatus {
    // Account activation mail must be sent. Triggered when a login is created or a contact becomes a login.
    MailQueued = 5,
    // Account activation mail is sent, but account has not been activated yet. Triggered when the activation mail is sent.
    MailSent = 10,
    // Account activation completed. Triggered when the login has initially set his password.
    AccountActivated = 15,
    // Account activation mail could not be sent.
    MailFailed = 20
}
export enum NatchOSPlanktonImplementationModelsBasketLineType {
    // A NatchOS.Plankton.ImplementationModels.BasketLineType.Product added to the basket.
    Product = 1,
    // A comment line (text) added to the basket. NOT IMPLEMENTED YET IN PLANKTON.
    Comment = 2,
    // A NatchOS.Plankton.ImplementationModels.BasketLineType.Voucher added to the basket. NOT IMPLEMENTED YET IN PLANKTON.
    Voucher = 3,
    // Defines a surcharge for a line of type NatchOS.Plankton.ImplementationModels.BasketLineType.Product. Multiple surcharges can be added to a single product. NOT IMPLEMENTED YET IN PLANKTON.
    ProductSurcharge = 4,
    // A custom product added to the basket. NOT IMPLEMENTED YET IN PLANKTON.
    CustomProduct = 5
}
export enum NatchOSPlanktonImplementationModelsBasketStatus {
    // Status has not been set explicitly.
    NotSet = 0,
    // Basket has been created but lines have not been added yet.
    Created = 10,
    // Lines are added to the basket. Checkout process has not started yet. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.Created status.
    InProgress = 20,
    // First step of the checkout process, where the user can change the contents of the basket. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.InProgress status.
    CheckoutContent = 30,
    // Second step of the checkout process, where the user can select transfer options of enter some details regarding the order. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutContent status.
    CheckoutDetails = 40,
    // Third step of the checkout process, where the user reviews the final state of the basket without changing anything. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutDetails status.
    CheckoutReview = 50,
    // Basket is in the payment step of the basket flow. Changes to the content of the basket should not be made. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutPayment status. If payment fails or is cancelled the status should go back to a previous step, i.e. NatchOS.Plankton.ImplementationModels.BasketStatus.CheckoutContent. If payment succeeds the status proceed to NatchOS.Plankton.ImplementationModels.BasketStatus.Closed and basket should be sent.
    CheckoutPayment = 60,
    // Basket is in a temporary state that requires some sort of approval or confirmation before it can proceed. Example of approval: current user can not submit the basket, but someone with more rights needs to do this. Example of confirmation: basket is sent to an external system where contents are validated before the basket can reach the NatchOS.Plankton.ImplementationModels.BasketStatus.Closed status.
    Pending = 70,
    // Basket is being reviewed by a user having the rights to submit the basket.
    BeingReviewed = 75,
    // Basket have been approved, either manually or automatically. Typically follows after the NatchOS.Plankton.ImplementationModels.BasketStatus.Pending or NatchOS.Plankton.ImplementationModels.BasketStatus.BeingReviewed status. Next logical step would be to proceed to status NatchOS.Plankton.ImplementationModels.BasketStatus.Closed.
    Approved = 80,
    // Basket is ready to be sent via standard `NatchOS API` or custom code.
    Closed = 99
}
export enum NatchOSPlanktonImplementationModelsBasketType {
    // A regular basket.
    Normal = 1,
    // A template basket.
    Template = 2,
    // A blanket basket.
    Blanket = 3,
    // A basket to request a quote for.
    Quote = 4,
    // A basket from an approved quote.
    BasketFromAcceptedQuote = 5,
    // A basket from a denied quote.
    BasketFromDeniedQuote = 6,
    // A regular basket, but created by an internal person (ie. via impersonation).
    NormalByInternal = 7,
    // A selection of products defined by a person with enough rights, that can be linked to one or more persons. This can be used to group product together and limit the catalogue of a person to only selected products.
    ProductSelection = 8,
    // A basket for anonymous users with products meant for a quote request.
    QuoteBasketForAnonymous = 9,
    // Much like a normal basket, but the basket is created during a PunchOut session (e.g. OCI or cXML). However, when proceeding through checkout, the basket will not be submitted like a normal basket. It will not be transmitted to the ERP system and therefore it will not directly generate an order in ERP. When checkout of this basket is finished, the basket is sent to the customer's e-procurement system that initiates the PunchOut session.
    ToEProcurement = 10,
    // A basket of this type is created by a direct request from a customer's e-procurement system to the web shop, e.g. through a cXML OrderRequest. When such a request is received, the configured submit pipeline will typically be triggered to e.g. produce a web order in the ERP system and send a confirmation email.
    FromEProcurement = 11
}
export enum NatchOSPlanktonImplementationModelsDocumentInvoiceType {
    // Not set.
    NotSet = 0,
    // The regular invoice with a positive amount.
    Invoice = 1,
    // The invoice has a negative amount.
    CreditNote = 2
}
export enum NatchOSPlanktonImplementationModelsDocumentSearchDocumentSearchResultSortOrder {
    // No specific order. Best performance.
    NotSet = 0,
    // Sort by search engine score descending (highest score first).
    ScoreDescending = 11,
    // Sort by document date (NatchOS.Plankton.ImplementationModels.Document.DocumentDateTime) ascending (oldest documents first).
    DocumentDateAscending = 12,
    // Sort by document date (NatchOS.Plankton.ImplementationModels.Document.DocumentDateTime) descending (newest documents first).
    DocumentDateDescending = 13,
    // Sort by requested delivery date (NatchOS.Plankton.ImplementationModels.Document.RequestedDeliveryDate) ascending (oldest first).
    RequestedDeliveryDateAscending = 14,
    // Sort by requested delivery date (NatchOS.Plankton.ImplementationModels.Document.RequestedDeliveryDate) descending (newest first).
    RequestedDeliveryDateDescending = 15,
    // Sort by order date (NatchOS.Plankton.ImplementationModels.Document.OrderDateTime) ascending (oldest first).
    OrderDateAscending = 16,
    // Sort by order date (NatchOS.Plankton.ImplementationModels.Document.OrderDateTime) descending (newest first).
    OrderDateDescending = 17
}
export enum NatchOSPlanktonImplementationModelsDocumentType {
    // A sales quote allows a prospective buyer to see what costs would be involved for the work they would like to have done.
    Quote = 1,
    // An agreement for specific products or services.
    Order = 2,
    // A shipment document.
    Shipment = 3,
    // An invoice for a completed order. Includes both positive and negative invoices, see NatchOS.Plankton.ImplementationModels.DocumentInvoiceType.
    Invoice = 4
}
export enum NatchOSPlanktonImplementationModelsEmailMessageType {
    // A password reset mail.
    PasswordReset = 1,
    // Mail to user informing their password has changed.
    PasswordChanged = 2,
    // An account activation mail.
    AccountActivation = 3,
    // A store access notification mail.
    StoreAccess = 4,
    // A basket submitted notification mail (to internal).
    BasketSubmitted = 5,
    // A basket submitted confirmation mail (to customer).
    BasketConfirmation = 6,
    // Mail to internal - a customer requested a new account.
    AccountRequest = 7,
    // Mail to customer - confirmation of account request.
    AccountRequestResponse = 8,
    // Mail to internal - a new customer requested an account.
    Registration = 9,
    // Mail to customer - confirmation of registration.
    RegistrationResponse = 10,
    // Mail to internal - Summary of updated contact data.
    ContactUpdate = 11,
    // Mail to customer - a basket was assigned to purchaser for approval.
    BasketToPurchaser = 12,
    // Mail with customer note.
    CustomerNote = 13,
    // Mail to customer with quote.
    QuoteRequest = 14,
    // Mail to customer with data from a contact form.
    ContactForm = 15,
    // Mail to user with content of anonymous list.
    AnonymousBasketMail = 16,
    // Mail to internal - Anonymous quote request.
    AnonymousBasketQuoteRequest = 17,
    // Mail to user - Confirmation of anonymous quote request.
    AnonymousBasketQuoteResponse = 18,
    // Mail to user - Informing him of the status of his blanket orders.
    BlanketOrderMail = 19,
    // Mail to customer informing him that his requested price list is ready to be downloaded.
    PriceListReplyEmail = 20,
    // Mail to internal - form for return has been submitted.
    Return = 21,
    // Mail to internal - form for warranty has been submitted.
    Warranty = 22,
    // Mail to user or customer to inform him of an abandoned basket.
    AbandonedBasket = 23,
    // Mail to internal - a customer requests info about a delivery time for a product.
    InfoDeliveryTime = 24
}
export enum NatchOSPlanktonImplementationModelsPaymentProvider {
    // No value set.
    NotSet = 0,
    // Mollie payment service provider. Officially support by NatchOS.
    Mollie = 1
}
export enum NatchOSPlanktonImplementationModelsPaymentStatus {
    // No online payment linked to the basket.
    NotSet = 0,
    // The payment has been created with the payment service provider. The reference and provider have been stored in NatchOS.Plankton.ImplementationModels.BasketHeader.PaymentInformation.
    Started = 1,
    // The payment was cancelled by the user. A new payment should be created if the user proceeds to online payment again.
    Cancelled = 2,
    // The payment has expired, e.g. the user has abandoned the payment. How much time it takes for a payment to expire depends on the payment method. A new payment should be created if the user proceeds to online payment again.
    Expired = 3,
    // The payment has failed and cannot be completed with a different payment method. A new payment should be created if the user proceeds to online payment again.
    Failed = 4,
    // The payment is successfully paid. Basket should be closed (NatchOS.Plankton.ImplementationModels.BasketStatus.Closed) and sent.
    Paid = 9
}
export enum NatchOSPlanktonImplementationModelsPredefinedRight {
    // Create a normal basket (NatchOS.Plankton.ImplementationModels.BasketType.Normal). External only. Can be automatically checked in the basket service layer.
    CreateNormalBasket = 1,
    // Create a template for a normal basket (NatchOS.Plankton.ImplementationModels.BasketType.Template). External only. Can be automatically checked in the basket service layer.
    CreateTemplateBasket = 2,
    // Create a basket from a blanket order (NatchOS.Plankton.ImplementationModels.BasketType.Blanket). External only. Can be automatically checked in the basket service layer.
    CreateBlanketBasket = 3,
    // Create a basket that will be sent as quote (NatchOS.Plankton.ImplementationModels.BasketType.Quote). External only. Can be automatically checked in the basket service layer.
    CreateQuoteBasket = 4,
    // Create a basket from a quote that is accepted (NatchOS.Plankton.ImplementationModels.BasketType.BasketFromAcceptedQuote). External only. Can be automatically checked in the basket service layer.
    CreateBasketFromAcceptedQuote = 5,
    // Create a basket from a quote that is not accepted (NatchOS.Plankton.ImplementationModels.BasketType.BasketFromDeniedQuote). External only. Can be automatically checked in the basket service layer.
    CreateBasketFromDeniedQuote = 6,
    // Create a normal basket as an internal person (NatchOS.Plankton.ImplementationModels.BasketType.NormalByInternal). Internal only. Can be automatically checked in the basket service layer.
    CreateNormalBasketByInternal = 7,
    // Submit own basket of the type NatchOS.Plankton.ImplementationModels.BasketType.Normal. External only. Can be automatically checked in the basket service layer.
    SubmitOwnNormalBasket = 10,
    // Submit own basket of the type NatchOS.Plankton.ImplementationModels.BasketType.Blanket. External only. Can be automatically checked in the basket service layer.
    SubmitOwnBlanketBasket = 11,
    // Submit own basket of the type NatchOS.Plankton.ImplementationModels.BasketType.Quote. External only. Can be automatically checked in the basket service layer.
    SubmitOwnQuoteBasket = 12,
    // Submit own basket of the type NatchOS.Plankton.ImplementationModels.BasketType.BasketFromAcceptedQuote. External only. Can be automatically checked in the basket service layer.
    SubmitOwnBasketFromAcceptedQuote = 13,
    // Submit own basket of the type NatchOS.Plankton.ImplementationModels.BasketType.BasketFromDeniedQuote. External only. Can be automatically checked in the basket service layer.
    SubmitOwnBasketFromDeniedQuote = 14,
    // Submit own basket of the type NatchOS.Plankton.ImplementationModels.BasketType.NormalByInternal. Internal only. Can be automatically checked in the basket service layer.
    SubmitOwnNormalBasketByInternal = 15,
    // Submit basket of the type NatchOS.Plankton.ImplementationModels.BasketType.Normal. External only. Can be automatically checked in the basket service layer.
    SubmitNormalBasket = 20,
    // Submit basket of the type NatchOS.Plankton.ImplementationModels.BasketType.Blanket. External only. Can be automatically checked in the basket service layer.
    SubmitBlanketBasket = 21,
    // Submit basket of the type NatchOS.Plankton.ImplementationModels.BasketType.Quote. External only. Can be automatically checked in the basket service layer.
    SubmitQuoteBasket = 22,
    // Submit basket of the type NatchOS.Plankton.ImplementationModels.BasketType.BasketFromAcceptedQuote. External only. Can be automatically checked in the basket service layer.
    SubmitBasketFromAcceptedQuote = 23,
    // Submit basket of the type NatchOS.Plankton.ImplementationModels.BasketType.BasketFromDeniedQuote. External only. Can be automatically checked in the basket service layer.
    SubmitBasketFromDeniedQuote = 24,
    // Submit basket of the type NatchOS.Plankton.ImplementationModels.BasketType.NormalByInternal. Internal only. Can be automatically checked in the basket service layer.
    SubmitNormalBasketByInternal = 25,
    // Manage customer product code.
    ManageCustomerProductCode = 27,
    // Can impersonate another person and act on their behalf. Internal only.
    ImpersonatePerson = 30,
    // View the customer list of the current salesperson. This would be a subset of the full customer list. Internal only.
    ViewCustomerListLinkedToCurrentSalesperson = 39,
    // View the full customer list. Internal only.
    ViewCustomerList = 40,
    // View a person list. Internal and external.
    ViewPersonList = 41,
    // View the quote list. Internal and external.
    ViewQuoteList = 50,
    // View the order list. Internal and external.
    ViewOrderList = 51,
    // View the shipment list. Internal and external.
    ViewShipmentList = 52,
    // View the invoice list. Internal and external.
    ViewInvoiceList = 53,
    // Can see promotions.
    ViewPromotions = 61,
    // Can see outlet products.
    ViewLiquidations = 62,
    // User is allowed to select the net price for display. Internal and external.
    ShowPriceNetAvailable = 83,
    // User is allowed to select the gross price for display. Internal and external.
    ShowPriceGrossAvailable = 84,
    // User has access to the backoffice/admin area of the application. External only.
    BackofficeAccess = 90,
    // User can sign in and use the application. Internal and external.
    SignInAllowed = 95
}
export enum NatchOSPlanktonImplementationModelsPredefinedShippingAdvice {
    // Not set.
    NotSet = 0,
    // The order can be split up, ie. per product or even per smaller quantities of a single product.
    Partial = 1,
    // The order can be split up, but every order line must be complete (quantity).
    CompleteOrderLines = 2,
    // The order will be fulfilled once, when all products are available.
    Complete = 3
}
export enum NatchOSPlanktonImplementationModelsPredefinedTransferType {
    // Not set.
    NotSet = 0,
    // Buyer will pick up the order.
    Pickup = 1,
    // Seller will ship the order to the buyer.
    Delivery = 2,
    // Buyer will pick up the order from a night locker.
    PickupNightLocker = 3
}
export enum NatchOSPlanktonImplementationModelsProductSearchModelsQueryType {
    // Don't use special logic. Use this value if the implementation does not use model products.
    Default = 0,
    // Search in the model products and return results based on these model products.
    ModelOnly = 1,
    // Search in the related products, but return results based on their model products.
    ModelViaRelated = 2,
    // Search in the related products and return results based on these related products.
    RelatedOnly = 3
}
export enum NatchOSPlanktonImplementationModelsProductSearchProductSearchResultCaching {
    // Allow cache for anonymous users. Don't cache for authenticated users. This is the default setting.
    AnonymousOnly = 0,
    // Disabled caching for anonymous users and authenticated users.
    Disabled = 1,
    // Allow caching for anonymous and authenticated users. Use with caution, as this might lead to many cache items.
    AnonymousAndAuthenticated = 2
}
export enum NatchOSPlanktonImplementationModelsProductSearchProductSearchResultSortOrder {
    // No specific order. Best performance.
    NotSet = 0,
    // Sort by search engine score descending (highest score first).
    ScoreDescending = 11,
    // Sort alphabetically by product number ascending.
    ProductNumberAscending = 12,
    // Sort alphabetically by product number descending.
    ProductNumberDescending = 13,
    // Sort alphabetically by product name (from translation) ascending.
    ProductNameAscending = 14,
    // Sort alphabetically by product name (from translation) descending.
    ProductNameDescending = 15,
    // Sort (1) by previously bought first, (2) then by the order value of the promotion type, (3) then by product number ascending (alphabetically).
    PreviouslyBoughtThenPromoThenProductNumber = 16,
    // Sort (1) by previously bought first, (2) then by the order value of the promotion type, (3) then by product name ascending (alphabetically).
    PreviouslyBoughtThenPromoThenProductName = 18,
    // Sort (1) by previously bought first, (2) then by product number ascending (alphabetically).
    PreviouslyBoughtThenProductNumber = 20,
    // Sort (1) by previously bought first, (2) then by product name ascending (alphabetically).
    PreviouslyBoughtThenProductName = 22,
    // Sort (1) by products that are in stock first, (2) then by product number ascending (alphabetically).
    InStockThenProductNumber = 24,
    // Sort (1) by previously bought first, (2) then by products that are in stock.
    PreviouslyBoughtThenInStock = 26,
    // Sort (1) by most bought.
    MostBought = 28,
    // A customer's personalized sort order of the search results.
    Personalized = 30,
    // Order by number of times bought.
    TimesBoughtAscending = 32,
    // Order by number of times bought.
    TimesBoughtDescending = 33,
    // Order by last time bought.
    LastTimeBoughtAscending = 34,
    // Order by last time bought.
    LastTimeBoughtDescending = 35,
    // Order by ascending price.
    PriceAscending = 40,
    // Order by descending price.
    PriceDescending = 41,
    // Order by customer product code ascending.
    CustomerProductCodeAscending = 42,
    // Order by customer product code descending.
    CustomerProductCodeDescending = 43,
    // Order by product code ascending.
    ProductCodeAscending = 44,
    // Order by product code descending.
    ProductCodeDescending = 45,
    // Explicitly randomize the results.
    Random = 100,
    // Order by a personalized sort order and product number ascending. Combination of NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchResultSortOrder.Personalized followed by NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchResultSortOrder.ProductNameAscending.
    PersonalizedThenProductNumberAscending = 112,
    // Sort (1) by previously bought first, (2) then by products that are in stock, (3) then products with a picture.
    PreviouslyBoughtThenInStockThenWithPicture = 126,
    // Sort (1) by most bought, (2) then products with a picture.
    MostBoughtThenWithPicture = 128
}
export enum NatchOSPlanktonImplementationModelsProductSearchSearchFilterType {
    // No filter.
    None = 0,
    // Indicates filtering on promotion type (e.g. new product).
    PromoType = 1,
    // Indicates filtering on stock.
    StockProduct = 2,
    // Indicates filtering on favorites for customer.
    FavoritesForCustomer = 4,
    // Indicates filtering on favorites for customer.
    FavoritesForPerson = 8,
    // Indicates filtering on product that were bought by customer.
    ProductsBoughtByCustomer = 16,
    // Indicates filtering on products that have a customer specific product code.
    CustomerProductCode = 32
}
export enum NatchOSPlanktonImplementationModelsProductSearchSearchOrigin {
    // Not set.
    NotSet = 0,
    // Search in identifiers after scanning a product bar code. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.ProductIdentifier. Can be set automatically as the default value in !:ProductIdentifierSearchCriteria constructor.
    Scanning = 1,
    // Textual search in products. Is set automatically as the default value in NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria constructor with a search term. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.TextSearch.
    TextSearch = 2,
    // Search under a category as part of a drill down. Is set automatically as the default value in NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria constructor with a category. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.DrillDown.
    DrillDown = 3,
    // Search in identifiers Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.ProductIdentifier. Can be set automatically as the default value in !:ProductIdentifierSearchCriteria constructor.
    QuickEntry = 4,
    // Search from a product page, i.e. get all promotions. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.DrillDown. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.
    ProductPage = 5,
    // Search for autocomplete in search text box. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.TextSearch. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.
    AutoComplete = 6,
    // Search for building the sitemap.xml content. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.DrillDown and NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.TextSearch. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.
    Sitemap = 7,
    // Search from an external source, like a webservice or API. Part of NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.DrillDown and NatchOS.Plankton.ImplementationModels.ProductSearch.SearchType.TextSearch. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.
    External = 8,
    // Get category id's with product counts optionally specific for a customer. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.
    Category = 9,
    // Use the product search to get the product id's for a pricelist. Must be set explicitly for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria.
    PriceList = 10,
    // Use the product search to filter a list of products. Is set automatically as the default value for NatchOS.Plankton.ImplementationModels.ProductSearch.ProductSearchCriteria constructor with a product ID list.
    FilterSearch = 11,
    // In cases where a user-initiated product search returns no results, the system automatically generates and executes a refined query (e.g., via typo correction, normalization, or reformulation) to improve result retrieval.
    ZeroResultsFallbackRetry = 12
}
export enum NatchOSPlanktonImplementationModelsProductSearchSearchType {
    // A drill-down in category.
    DrillDown = 0,
    // Perform a textual search.
    TextSearch = 1,
    // Search in all the product identifiers.
    ProductIdentifier = 2,
    // Search in all products, with one or more filters enabled.
    FilterSearch = 3
}
export enum NatchOSPlanktonImplementationModelsPropertyFilterType {
    // Value not set.
    NotSet = 0,
    // Evaluated as an `AND` operator within the property values. Selecting more values/options within the same property may reduce results. This was formerly known as 'Single'.
    Intersect = 1,
    // Evaluated as an `OR` operator within the property values. Selecting more values/options within the same property may increase results. This was formerly known as 'Multi'.
    Union = 2,
    // A selection of a range.
    Range = 3
}
export enum NatchOSPlanktonImplementationModelsPropertyValueType {
    // Value not set.
    NotSet = 0,
    // A textual value. Stored in NatchOS.Plankton.ImplementationModels.PropertyValueTranslation.TextValue.
    Text = 1,
    // A numerical value, integer or decimal.
    NumericValue = 2,
    // A boolean value, stored as numeric 0 or 1.
    Boolean = 4
}
export enum NatchOSPlanktonImplementationModelsRelationType {
    // The related product is an alternative to the origin product.
    HasAlternative = 1,
    // The related product appears frequently in the same order as the origin product.
    FrequentlyBoughtTogetherWith = 2,
    // The related product is often bought by the same customer who bought origin product.
    CustomersWhoBoughtThisAlsoBought = 3,
    // The related product is mandatory included in a sale of origin product.
    MandatoryIncludes = 4,
    // The related product is an accessory of the origin product.
    HasAccessory = 5,
    // The origin product is the model for the related product.
    IsModelOf = 6,
    // The origin product belongs to the same series of products as the related product.
    IsInSameSeries = 7,
    // The related product is a replacement for the origin product. This is the reverse of NatchOS.Plankton.ImplementationModels.RelationType.IsReplacementOf.
    HasReplacement = 8,
    // Time bound (by range) version of NatchOS.Plankton.ImplementationModels.RelationType.HasAlternative.
    TemporaryHasAlternative = 9,
    // The related product has a basic relation to the origin product, without any specific meaning.
    Basic = 10,
    // The related product is a highly recommended accessory.
    SuggestedIncludes = 11,
    // The related product is a subassembly of the origin product. I.e. a BOM definition, the product that is bought is built out of several other products.
    ContainsSubassembly = 12,
    // The related product is a cheaper alternative to the original product.
    HasCheaperAlternative = 13,
    // The related product is an important accessory of the origin product.
    HasHighlyAdvisedAccessory = 70,
    // The origin product is a variant of the related product (model). This is the opposite of NatchOS.Plankton.ImplementationModels.RelationType.IsModelOf.
    IsVariantOf = 106,
    // The origin product is a replacement of the related product. This is the opposite of NatchOS.Plankton.ImplementationModels.RelationType.HasReplacement.
    IsReplacementOf = 108
}
export enum PhoneNumberType {
    // Regular phone number.
    Phone = 1,
    // Mobile phone number.
    Mobile = 3
}
export enum PropertyFilterType {
    // Evaluated as an `AND` operator within the property values. Selecting more values/options within the same property may reduce results. This was formerly known as 'Single'. Support in NatchOS search.
    Intersect = 1,
    // Evaluated as an `OR` operator within the property values. Selecting more values/options within the same property may increase results. This was formerly known as 'Multi'. Support in NatchOS search.
    Union = 2,
    // A selection of a range. NOT SUPPORTED in default NatchOS search. Only for customer search implementations!
    Range = 3
}
export enum PropertyValueType {
    // A textual value. Stored in NatchOS.Plankton.Models.PropertyValueTranslation.TextValue.
    Text = 1,
    // A numerical value, integer or decimal.
    NumericValue = 2,
    // A boolean value, stored as numeric 0 or 1.
    Boolean = 4
}
export enum RelationType {
    // The related product is an alternative to the origin product.
    HasAlternative = 1,
    // The related product appears frequently in the same order as the origin product.
    FrequentlyBoughtTogetherWith = 2,
    // The related product is often bought by the same customer who bought origin product.
    CustomersWhoBoughtThisAlsoBought = 3,
    // The related product is mandatory included in a sale of origin product.
    MandatoryIncludes = 4,
    // The related product is an accessory of the origin product.
    HasAccessory = 5,
    // The origin product is the model for the related product.
    IsModelOf = 6,
    // The origin product belongs to the same series of products as the related product.
    IsInSameSeries = 7,
    // The related product is a replacement for the origin product. This is the opposite of NatchOS.Plankton.Models.RelationType.IsReplacementOf.
    HasReplacement = 8,
    // Time bound (by range) version of NatchOS.Plankton.Models.RelationType.HasAlternative.
    TemporaryHasAlternative = 9,
    // The related product has a basic relation to the origin product, without any specific meaning.
    Basic = 10,
    // The related product is a highly recommended accessory.
    SuggestedIncludes = 11,
    // The related product is a subassembly of the origin product. E.g. a BOM definition, the product that is bought is built out of several other products.
    ContainsSubassembly = 12,
    // The related product is a cheaper alternative to the original product.
    HasCheaperAlternative = 13,
    // The related product is an important accessory of the origin product.
    HasHighlyAdvisedAccessory = 70,
    // The origin product is a variant of the related product (model). This is the opposite of NatchOS.Plankton.Models.RelationType.IsModelOf.
    IsVariantOf = 106,
    // The origin product is a replacement of the related product. This is the opposite of NatchOS.Plankton.Models.RelationType.HasReplacement.
    IsReplacementOf = 108
}
export enum ShippingAdvice {
    // Not set.
    NotSet = 0,
    // The order can be split up, ie. per product or even per smaller quantities of a single product.
    Partial = 1,
    // The order can be split up, but every order line must be complete (quantity).
    CompleteOrderLines = 2,
    // The order will be fulfilled once, when all products are available.
    Complete = 3
}
